{
  "a11y": {
    "activeBatches": "Active batches, {{count}} pending",
    "activeBatchesButton": "Active batches",
    "addToFavorites": "Add to favorites",
    "addTag": "Add tag",
    "audioPlayer": "Audio player",
    "backupCode": "Backup code",
    "cancelAllDownloads": "Cancel all downloads",
    "clearAllNotifications": "Clear all notifications",
    "clearSelection": "Clear selection",
    "clearUploadQueue": "Clear upload queue",
    "copyLink": "Copy link",
    "closePanel": "Close panel",
    "composerFab": "Compose new email",
    "detailsPanel": "Details panel",
    "emailSending": "Sending email",
    "emptyFilesTable": "No files to display",
    "editFileTags": "Edit file tags",
    "fileTagsCount": "Tags, {{count}}",
    "enterFilePasswordForm": "Enter file password",
    "expandUploadProgress": "Expand upload progress",
    "fileTypesFilter": "Filter by file type",
    "onlyExpiredFilter": "Filter expired shares",
    "expiringWithinDaysFilter": "Filter shares expiring within days",
    "filters": "Filters",
    "fullscreen": "Fullscreen",
    "fileMoveForm": "Move files",
    "filePublicLinkForm": "Public link settings",
    "filesTable": "Files list",
    "globalSearch": "Search files",
    "goBack": "Go back",
    "groupForm": "Group form",
    "loading": "Loading, please wait",
    "minimizeUploadProgress": "Minimize upload progress",
    "mute": "Mute",
    "mainNavigation": "Main navigation",
    "markAllRead": "Mark all notifications as read",
    "notificationsButton": "Notifications",
    "notificationsCount": "Notifications, {{count}} unread",
    "notificationsList": "Notifications list",
    "openEmailsSection": "Open Emails section",
    "openFileMenu": "Open file actions menu",
    "openFolder": "Open folder {{name}}",
    "openList": "Open {{name}}",
    "openMoreActions": "Open more actions",
    "openFilesSection": "Open Files section",
    "otpCode": "One-time password code",
    "pendingGrants": "Pending grant requests, {{count}}",
    "pendingGrantsButton": "Pending grant requests",
    "playbackProgress": "Playback progress, {{current}} of {{duration}}",
    "playPause": "Play or pause",
    "quickShare": "Quick share upload, {{percent}} percent",
    "removeFromFavorites": "Remove from favorites",
    "removeException": "Remove exception",
    "removeSharedFile": "Remove shared file",
    "searchExactMatch": "Search exact match",
    "searchWholeWord": "Search whole word",
    "sectionSelector": "Section selector",
    "selectCountry": "Select {{country}}",
    "settingsSearch": "Search settings",
    "skipToMain": "Skip to main content",
    "tagActions": "Actions for tag {{name}}",
    "tagNotSelected": "not selected",
    "tagSelected": "selected",
    "tagToggle": "{{name}}, {{state}}",
    "textEditor": "Text file editor",
    "totpCode": "Authenticator code",
    "unmute": "Unmute",
    "activityMap": "World activity map by country",
    "cancelAllFailed": "Cancel all Failed batches",
    "copyBackupCodes": "Copy backup codes",
    "deleteSelected": "Delete selected",
    "downloadBackupCodes": "Download backup codes",
    "downloadProgress": "Download progress",
    "exitEditMode": "Exit edit mode",
    "expandDownloadProgress": "Expand download progress",
    "exportCsv": "Export to CSV",
    "imageEditor": "Image editor",
    "markdownEditor": "Markdown editor",
    "markdownHeading": "Heading style",
    "markdownLinkActions": "Link actions",
    "markdownToolbar": "Formatting toolbar",
    "minimizeDownloadProgress": "Minimize download progress",
    "pdfViewer": "PDF document viewer",
    "printDashboard": "Print dashboard",
    "refreshFolderStats": "Refresh folder statistics",
    "refreshList": "Refresh list",
    "removeFile": "Remove file",
    "saveFile": "Save file",
    "selectUser": "Select {{name}}",
    "viewUploadErrors": "View upload errors",
    "uploadProgress": "Upload progress",
    "viewAsGrid": "View as grid",
    "viewAsList": "View as list",
    "userForm": "User form",
    "userMenu": "User account menu",
    "viewRiskIndicator": "{{name}}, view details",
    "verifyingFile": "Verifying file",
    "videoPlayer": "Video player",
    "volume": "Volume, {{percent}} percent",
    "messageInput": "Message input",
    "sendMessage": "Send message",
    "stopGenerating": "Stop generating"
  },
  "antivirus": {
    "quarantine": {
      "title": "Quarantine",
      "description": "Review infected, failed, and skipped antivirus scans and release false positives.",
      "empty": "No files match this filter",
      "rescan": "Rescan",
      "release": "Release",
      "delete": "Delete",
      "rescanSuccess": "Rescan queued",
      "releaseSuccess": "File released from quarantine",
      "releaseModalTitle": "Release file from quarantine",
      "releaseConfirmDescription": "Release \"{{fileName}}\" from quarantine? The file will be available again. Provide a reason for the audit log.",
      "releaseReasonLabel": "Reason",
      "releaseReasonPlaceholder": "Explain why this file should be released",
      "releaseReasonRequired": "A release reason is required",
      "deleteConfirmTitle": "Delete quarantined file?",
      "deleteConfirmDescription": "Move \"{{fileName}}\" to trash? This uses the ordinary file delete path.",
      "status": {
        "infected": "Infected",
        "error": "Error",
        "skipped": "Skipped",
        "toolarge": "Too large"
      },
      "columns": {
        "name": "File name",
        "threat": "Threat",
        "engine": "Engine",
        "ownerEmail": "Owner email",
        "scannedAt": "Scanned at",
        "actions": "Actions"
      },
      "errors": {
        "loadFailed": "Could not load quarantined files",
        "rescanFailed": "Could not queue rescan",
        "releaseFailed": "Could not release file",
        "deleteFailed": "Could not delete file",
        "invalidParams": "Invalid filter or release reason"
      }
    }
  },
  "account": {
    "title": "Account",
    "description": "Manage your profile, preferences, and security.",
    "navAria": "Account sections",
    "profile": "Profile",
    "profileDescription": "Update your name. Email cannot be changed here.",
    "profileUnavailable": "Profile is not available.",
    "profileUpdated": "Profile updated",
    "preferences": "Preferences",
    "preferencesDescription": "Language, appearance, and accessibility options.",
    "languageDescription": "Choose the interface language.",
    "appearanceDescription": "Choose light, dark, or follow the system.",
    "accessibilityDescription": "Toggle high contrast and reduced motion.",
    "security": "Security",
    "securityDescription": "Two-factor authentication and passkeys.",
    "twoFactorDescription": "Add or manage authenticator app codes.",
    "passkeysDescription": "Register and manage passkeys for this account.",
    "openTwoFactor": "Manage 2FA",
    "openPasskeys": "Manage passkeys",
    "sessions": "Sessions",
    "sessionsDescription": "Manage signed-in sessions and folder unlock sessions.",
    "activeSessionsDescription": "Review and revoke active browser sessions.",
    "folderSessionsDescription": "Manage password unlock sessions for folders.",
    "openActiveSessions": "Manage active sessions",
    "openFolderSessions": "Manage folder sessions",
    "publicLinks": "Public links",
    "publicLinksDescription": "View and revoke public share links you created.",
    "publicLinksCtaDescription": "Open the list of your public links.",
    "openPublicLinks": "Manage public links"
  },
  "pageTitle": {
    "app": "Filegrant",
    "login": "Login",
    "logout": "Logout",
    "settings": "Settings",
    "account": "Account",
    "filesPersonal": "Files",
    "filesReceived": "Received",
    "filesShared": "Shared",
    "filesFavorites": "Favorites",
    "filesRecent": "Recent",
    "filesHidden": "Hidden",
    "filesTrash": "Trash",
    "publicLink": "Public link",
    "emails": "Emails",
    "emailsInbox": "Inbox",
    "emailsSent": "Sent",
    "emailsDrafts": "Drafts",
    "emailsFavorites": "Email favorites",
    "emailsArchive": "Archive",
    "emailsTrash": "Email trash",
    "users": "Users",
    "groups": "Groups",
    "dashboard": "Dashboard",
    "salesDashboard": "Sales dashboard",
    "activityLogs": "Activity logs",
    "antivirusQuarantine": "Quarantine",
    "viewer": "Viewer",
    "office": "Office",
    "quickShare": "Quick Share",
    "store": "Store",
    "purchase": "Purchase",
    "paymentSuccess": "Payment success",
    "fileShareRequests": "Share requests",
    "protectedFile": "Protected file",
    "extensionAuthorize": "Extension authorization",
    "sharePointStatus": "SharePoint status"
  },
  "activityLogOperationTypes": {
    "CreateFile": "File created",
    "CreateFolder": "Folder created",
    "CreateFileFailed": "File creation failed",
    "CreateFolderFailed": "Folder creation failed",
    "ReadFile": "File viewed",
    "ReadFolder": "Folder viewed",
    "DownloadFile": "File downloaded",
    "DownloadFileEncrypted": "Encrypted file downloaded",
    "DownloadFileZip": "File downloaded as Zip",
    "SearchFiles": "Files searched",
    "ReadFileFailed": "File view failed",
    "ReadFolderFailed": "Folder view failed",
    "DownloadFileFailed": "File download failed",
    "DownloadFileEncFailed": "Encrypted file download failed",
    "DownloadFileZipFailed": "Zip file download failed",
    "UpdateFile": "File updated",
    "RenameFile": "File renamed",
    "MoveFile": "File moved",
    "DuplicateFile": "File duplicated",
    "UploadFile": "File uploaded",
    "UpdateFileFailed": "File update failed",
    "RenameFileFailed": "File rename failed",
    "MoveFileFailed": "File move failed",
    "DuplicateFileFailed": "File duplication failed",
    "UploadFileFailed": "File upload failed",
    "DeleteFileToRecycleBin": "File moved to recycle bin",
    "DeleteFolderToRecycleBin": "Folder moved to recycle bin",
    "DeleteFileToRecycleBinFailed": "Failed to move file to recycle bin",
    "DeleteFolderToRecycleBinFailed": "Failed to move folder to recycle bin",
    "DeleteFilePermanently": "File permanently deleted",
    "DeleteFolderPermanently": "Folder permanently deleted",
    "DeleteFilePermanentlyFailed": "File permanent deletion failed",
    "DeleteFolderPermanentlyFailed": "Folder permanent deletion failed",
    "ShareFile": "File shared",
    "ShareFolder": "Folder shared",
    "RevokeShare": "Share revoked",
    "ShareFileFailed": "File share failed",
    "ShareFolderFailed": "Folder share failed",
    "RevokeShareFailed": "Revoke share failed",
    "ViewAuditLog": "Audit log viewed",
    "ExportAuditLog": "Audit log exported",
    "ViewAuditLogFailed": "Audit log view failed",
    "ExportAuditLogFailed": "Audit log export failed",
    "PurgeAuditLog": "Audit log purged (retention)",
    "GrantAccess": "Access granted",
    "RevokeAccess": "Access revoked",
    "GrantAccessFailed": "Access grant failed",
    "RevokeAccessFailed": "Access revoke failed",
    "CreateVersion": "Version created",
    "RevertVersion": "Version reverted",
    "CreateVersionFailed": "Version creation failed",
    "RevertVersionFailed": "Version revert failed",
    "CommentFile": "Comment added",
    "ReplyComment": "Comment replied",
    "AssignTask": "Task assigned",
    "CommentFileFailed": "Comment failed",
    "ReplyCommentFailed": "Reply to comment failed",
    "AssignTaskFailed": "Task assignment failed",
    "PreviewFile": "File previewed",
    "HiddenFile": "File hidden",
    "UnhiddenFile": "File unhidden",
    "AddToFavorites": "Added to favorites",
    "RemoveFromFavorites": "Removed from favorites",
    "PreviewFileFailed": "File preview failed",
    "HiddenFileFailed": "Hide file failed",
    "UnhiddenFileFailed": "Unhide file failed",
    "AddToFavoritesFailed": "Add to favorites failed",
    "RemoveFromFavoritesFailed": "Remove from favorites failed",
    "CreateUser": "User created",
    "EditUser": "User edited",
    "RemoveUser": "User removed",
    "CreateGroup": "Group created",
    "EditGroup": "Group edited",
    "RemoveGroup": "Group removed",
    "OnBehalfOfAccess": "Accessed on behalf of user",
    "OnBehalfOfOperation": "Operated on behalf of user",
    "CreateUserFailed": "User creation failed",
    "EditUserFailed": "User edit failed",
    "RemoveUserFailed": "User removal failed",
    "CreateGroupFailed": "Group creation failed",
    "EditGroupFailed": "Group edit failed",
    "RemoveGroupFailed": "Group removal failed",
    "OnBehalfOfAccessFailed": "On behalf access failed",
    "OnBehalfOfOperationFailed": "On behalf operation failed",
    "LogIn": "User logged in",
    "LogOut": "User logged out",
    "OTPRequest": "OTP requested",
    "LogInFailed": "Login failed",
    "LogOutFailed": "Logout failed",
    "OTPRequestFailed": "OTP request failed",
    "AddTag": "Tag added",
    "RemoveTag": "Tag removed",
    "UpdateTag": "Tag updated",
    "ListTags": "Tags listed",
    "AddTagFailed": "Tag add failed",
    "RemoveTagFailed": "Tag remove failed",
    "UpdateTagFailed": "Tag update failed",
    "ListTagsFailed": "Tag list failed",
    "RestoreFile": "File restored",
    "TagFile": "Tags added to file",
    "RemoveTagFile": "Tags removed from file",
    "EncryptFile": "File encrypted",
    "DecryptFile": "File decrypted",
    "ChangeFileOwner": "File owner changed",
    "SetFileExpiration": "File expiration set",
    "GenerateShareLink": "Share link generated",
    "ValidateUser": "User validated",
    "SignFile": "File signed",
    "FileDescription": "File description set",
    "ShortCut": "File shortcut created",
    "RestoreFileFailed": "File restore failed",
    "TagFileFailed": "Tagging file failed",
    "RemoveTagFileFailed": "Removing tags from file failed",
    "EncryptFileFailed": "File encryption failed",
    "DecryptFileFailed": "File decryption failed",
    "ChangeFileOwnerFailed": "Change file owner failed",
    "SetFileExpirationFailed": "Set expiration failed",
    "GenerateShareLinkFailed": "Generate share link failed",
    "ValidateUserFailed": "User validation failed",
    "SignFileFailed": "File signature failed",
    "FileDescriptionFailed": "File description set failed",
    "ShortCutFailed": "File shortcut creation failed",
    "ScreenCaptureAttempt": "Screen capture attempted",
    "ClipboardCopyAttempt": "Clipboard copy attempted",
    "UnauthorizedAccessAttempt": "Unauthorized access attempted",
    "ScreenCaptureAttemptFailed": "Screen capture attempt failed",
    "ClipboardCopyAttemptFailed": "Clipboard copy attempt failed",
    "UnauthorizedAccessAttemptFailed": "Unauthorized access attempt failed",
    "MalwareDetection": "Malware detected",
    "MalwareRemoval": "Malware removed",
    "SuspiciousActivityDetected": "Suspicious activity detected",
    "IntrusionDetection": "Intrusion detected",
    "IntrusionPrevention": "Intrusion prevented",
    "DataLeakageAttempt": "Data leakage attempted",
    "DataLeakageAttemptFailed": "Data leakage attempt failed",
    "PhishingAttemptDetected": "Phishing attempt detected",
    "RansomwareAttackDetected": "Ransomware attack detected",
    "BruteForceAttackDetected": "Brute force attack detected",
    "TwoFactorAuthEnabled": "Two-factor authentication enabled",
    "TwoFactorAuthDisabled": "Two-factor authentication disabled",
    "TwoFactorAuthAttemptFailed": "Two-factor authentication attempt failed",
    "PasswordChange": "Password changed",
    "PasswordChangeFailed": "Password change failed",
    "SecuritySettingsUpdate": "Security settings updated",
    "SecuritySettingsUpdateFailed": "Security settings update failed",
    "FirewallRuleChange": "Firewall rule changed",
    "FirewallRuleChangeFailed": "Firewall rule change failed",
    "EncryptionKeyManagement": "Encryption key managed",
    "EncryptionKeyManagementFailed": "Encryption key management failed",
    "AccessControlPolicyChange": "Access control policy changed",
    "AccessControlPolicyChangeFailed": "Access control policy change failed",
    "SecurityPatchApplied": "Security patch applied",
    "SecurityPatchAppliedFailed": "Security patch application failed",
    "LastCheckToken": "Last Check Token Activity",
    "UpdateSetting": "Update Setting",
    "ViewGroupsList": "Group list viewed",
    "ViewUsersList": "User list viewed",
    "ViewTrash": "RecycleBin viewed",
    "ViewArchivedFiles": "Hidden files viewed",
    "ViewFavoriteFiles": "Favorite files viewed",
    "ViewSharedFiles": "Shared files viewed",
    "ViewReceivedFiles": "Received files viewed",
    "ViewSettings": "Setting viewed",
    "EmailSent": "Email sent",
    "EmailRead": "Email read",
    "EmailSaveDraft": "Draft saved",
    "EmailUpdateDraft": "Draft updated",
    "EmailTrash": "Email moved to trash",
    "EmailRestore": "Email restored from trash",
    "EmailDelete": "Email permanently deleted",
    "EmailArchive": "Email archived",
    "EmailUnarchive": "Email unarchived",
    "EmailFavourite": "Email marked as favourite",
    "EmailUnfavourite": "Email unmarked as favourite",
    "EmailAttachmentRemoved": "Attachment removed from sent email",
    "EmailRecipientRemoved": "Recipient removed from sent email",
    "EmailReplied": "Email reply sent",
    "EmailForwarded": "Email forwarded",
    "CreateSetting": "Setting created",
    "DeleteSetting": "Setting deleted",
    "PaymentSessionCreated": "Payment session created",
    "PaymentCompleted": "Payment completed",
    "SessionRevoked": "Session revoked",
    "AllSessionsRevoked": "All sessions revoked",
    "AdminSessionRevoked": "Admin revoked user session",
    "CreateCompany": "Company created",
    "UpdateCompany": "Company updated",
    "BackOfficeCreateUser": "User created via back office",
    "BackOfficeUpdateUser": "User updated via back office",
    "SystemMaintenance": "System maintenance",
    "CreateCertificate": "Certificate created",
    "CreateAccessRule": "Access rule created",
    "VersionRetention": "Version retention applied",
    "CleanupDeletedVersions": "Deleted versions cleaned up",
    "CreateIdentityProvider": "Identity provider created",
    "UpdateIdentityProvider": "Identity provider updated",
    "CreateAIAgent": "AI agent created",
    "UpdateAIAgent": "AI agent updated",
    "DeleteAIAgent": "AI agent deleted",
    "AIChatRequest": "AI chat request",
    "AIChatWithDocument": "AI chat with document",
    "AIChatDeleteConversation": "AI chat conversation deleted",
    "CancelBatch": "Batch cancelled",
    "CancelFileJobs": "File jobs cancelled",
    "RetryFileJobs": "File jobs retried",
    "InviteUsers": "Users invited",
    "ViewExecutiveReport": "Executive report viewed",
    "CreatePublicLink": "Public link created",
    "RevokePublicLink": "Public link revoked",
    "PublicLinkAccess": "Public link accessed",
    "PublicLinkDownload": "Public link download",
    "PublicLinkViewerAccess": "Public link viewer access",
    "PublicLinkAccessFailed": "Public link access failed",
    "IpRegionLoginBlocked": "Login blocked by IP/region",
    "IpRegionFileOperationBlocked": "File operation blocked by IP/region",
    "EntraIdSyncStarted": "Entra ID sync started",
    "EntraIdSyncCompleted": "Entra ID sync completed",
    "EntraIdUserImported": "User imported from Entra ID",
    "EntraIdGroupImported": "Group imported from Entra ID",
    "EntraIdSyncFailed": "Entra ID sync failed",
    "DirectorySyncUserDisabled": "Directory sync disabled user",
    "DirectorySyncUserEnabled": "Directory sync enabled user",
    "DirectorySyncGroupMembersChanged": "Directory sync changed group members",
    "DirectorySyncStarted": "Directory sync started",
    "DirectorySyncCompleted": "Directory sync completed",
    "DirectorySyncFailed": "Directory sync failed",
    "DirectorySyncUserImported": "User imported by directory sync",
    "DirectorySyncGroupImported": "Group imported by directory sync",
    "DirectorySyncConnectionTested": "Directory connection tested",
    "SetFolderPassword": "Folder password set",
    "RemoveFolderPassword": "Folder password removed",
    "FolderPasswordVerified": "Folder password verified",
    "FolderPasswordFailed": "Folder password verification failed",
    "FolderPasswordLockout": "Folder password lockout",
    "FolderPasswordSessionRevoked": "Folder password session revoked",
    "FolderPasswordResetOtpRequested": "Folder password reset OTP requested",
    "FolderPasswordResetWithOtp": "Folder password reset with OTP",
    "FolderPasswordResetOtpFailed": "Folder password reset OTP failed",
    "TotpExemptionGranted": "TOTP exemption granted",
    "TotpExemptionRevoked": "TOTP exemption revoked",
    "TotpExemptionExpired": "TOTP exemption expired",
    "TransferOwnership": "Ownership transferred",
    "TransferOwnershipFailed": "Ownership transfer failed",
    "UserLoginTokenCreated": "Login token created",
    "UserLoginTokenDeleted": "Login token deleted",
    "UserLoginTokenStatusChanged": "Login token status changed",
    "UserLoginTokenUsed": "Logged in with login token",
    "UserLoginTokenFailed": "Login token authentication failed",
    "PasskeyRegistered": "Passkey registered",
    "PasskeyRemoved": "Passkey removed",
    "PasskeyRemovedByAdmin": "Passkey removed by admin",
    "PasskeyAuthenticationFailed": "Passkey authentication failed",
    "PasskeyPasswordlessLogin": "Passkey passwordless login",
    "PasskeyBlocked": "Passkey blocked",
    "SharePointFileEncrypted": "SharePoint file encrypted",
    "SharePointFileEncryptionFailed": "SharePoint file encryption failed",
    "SharePointFileEncryptionSkipped": "SharePoint file skipped",
    "SharePointScanCycleCompleted": "SharePoint scan cycle completed",
    "SharePointScanCycleFailed": "SharePoint scan cycle failed",
    "SharePointConnectionTested": "SharePoint connection verified",
    "SharePointConnectionTestFailed": "SharePoint connection verification failed",
    "SharePointPerimeterBrowsed": "SharePoint perimeter browsed",
    "SharePointViewerTokenIssued": "SharePoint viewer token issued",
    "SharePointViewerTokenDenied": "SharePoint viewer token denied",
    "SharePointEditSessionOpened": "SharePoint edit session opened",
    "SharePointEditSessionDenied": "SharePoint edit session denied",
    "SharePointFileEdited": "SharePoint file edited"
  },
  "activityLogTargetTypes": {
    "File": "File",
    "Folder": "Folder",
    "Files": "Files",
    "FilesAndFolders": "Files and Folders",
    "FilesAndTags": "Files and Tags",
    "FilesFoldersAndTags": "Files, Folders and Tags",
    "User": "User",
    "Group": "Group",
    "Share": "Share entry",
    "ShareLink": "Share link",
    "Version": "Version of a file or document",
    "Comment": "Comment on a document or file",
    "Task": "Task assigned in a collaborative environment",
    "Permission": "Permission",
    "AccessControl": "Access control entries",
    "Admin": "Admin-related operations",
    "Configuration": "System configuration",
    "Setting": "Individual setting",
    "Tag": "Tag or label",
    "Metadata": "Metadata entry",
    "Notification": "Notification entry",
    "Workflow": "Workflow or process definition",
    "Template": "Template for documents or files",
    "AuditLog": "Audit log",
    "Security": "Security-related targets",
    "Monitoring": "Monitoring and logging targets",
    "Authentication": "Authentication-related targets",
    "TwoFactorAuth": "Two-factor authentication targets",
    "Session": "User session or token",
    "Encryption": "Encryption-related targets",
    "EncryptionKey": "Encryption key management",
    "Payment": "Payment or transaction",
    "Company": "Company or tenant",
    "Certificate": "RSA certificate for enterprise access",
    "AccessRule": "Access control rule",
    "IdentityProvider": "Identity provider (e.g. Microsoft, Google)",
    "AIAgent": "AI classification agent",
    "AIChat": "AI chat conversation",
    "Batch": "Batch operation",
    "Report": "Executive or other report",
    "Other": "Other generic targets",
    "GroupsList": "Groups",
    "UsersList": "Users",
    "SpecialFolder": "Special Folder",
    "SettingsList": "Settings",
    "Email": "Email",
    "SharePointFile": "SharePoint file"
  },
  "realtime": {
    "connected": "Connected",
    "connecting": "Connecting…",
    "disconnected": "Disconnected",
    "reconnecting": "Reconnecting…"
  },
  "settings": {
    "settings": "Settings",
    "unavailable": "Settings are currently unavailable",
    "retry": "Click to retry",
    "authentication": "Authentication",
    "saveCard": {
      "message": "Click on <strong>Save</strong> when you have completed the changes."
    },
    "informations": "Informations",
    "preview": "Preview",
    "externalUserEnforcement": "External User Enforcement",
    "externalUserEnforcementDescription": "Enforce viewing in Anti-Capture mode for all external users.",
    "tagBasedEncryption": "Tag-Based Encryption",
    "tagBasedEncryptionDescription": "Enforce viewing in Anti-Capture mode for files with specific tags.",
    "tagBasedEncryptionPlaceholder": "Tags (comma separated), - e.g. 'confidential, secret'",
    "companyBranding": {
      "title": "Company branding",
      "description": "Customize the appearance of the platform with your company's branding. This includes setting the logo, colors, and other visual elements that will be displayed to users.",
      "companyName": "Company Name",
      "preferredLanguage": "Preferred Language",
      "companyLogos": "Company Logos",
      "companyLogosDescription": "The file size cannot be larger than 1MB",
      "loginPageLogo": "Login Page Logo",
      "loginPageLogoDescription": "Set the logo that will be shown on the login page for users. Suggestions: Square or horizontal logo with a transparent background with a max width of 200px.",
      "topBarLogo": "Top Bar Logo",
      "topBarLogoDescription": "Set the logo that will be displayed on the top bar of the platform. Suggestions: Square or horizontal logo with a transparent background.",
      "emailNotificationLogo": "Email Notification Logo",
      "emailNotificationLogoDescription": "Set the logo to be used in the email notifications sent to users.",
      "quickShareBackground": "Quick Share Background",
      "quickShareBackgroundDescription": "Set the background image that will be displayed on the quick share page. Suggested size: 1200x1920 pixels",
      "companyColors": "Company Colors",
      "topBarColors": "Top Bar Colors",
      "topBarColorsDescription": "Set the background and text color for the top bar of the platform.",
      "mainButtonsColors": "Main Buttons Colors",
      "mainButtonsColorsDescription": "Set the background and text color for the main button.",
      "loginPageTitle": "Login Page Title",
      "loginPageSubtitle": "Login Page Subtitle",
      "loginTermsAndConditions": "Login Terms and Conditions",
      "loginPagePreview": "Preview of the Login Page and Top Bar",
      "mainButtonsPreview": "Preview of texts and main button colors",
      "emailNotificationsPreview": "Preview of Email Notifications",
      "quickSharePreview": "Preview of Quick Share Background",
      "addLogo": "Add logo"
    },
    "emailCustomizations": {
      "title": "Email customizations",
      "description": "Customize the HTML templates used for email notifications sent by the platform.",
      "language": "Language",
      "noTemplates": "No email templates available",
      "subject": "Subject",
      "availablePlaceholders": "Available Placeholders (click to insert)",
      "preview": "Preview",
      "customized": "Customized",
      "default": "Default",
      "resetToDefault": "Reset to Default",
      "resetTitle": "Reset template",
      "resetConfirm": "Reset",
      "resetConfirmDescription": "This will remove your customizations and revert to the default template. This action cannot be undone.",
      "resetSuccess": "Template reset to default",
      "resetError": "Failed to reset template",
      "saveSuccess": "Template saved successfully",
      "saveError": "Failed to save template",
      "sendTest": "Send Test Email",
      "testSuccess": "Test email sent",
      "testError": "Failed to send test email"
    },
    "downloadRestrictions": {
      "title": "Download encryption enforcement",
      "description": "Control the settings for download restrictions for all members. This includes enforcing encryption on downloads, applying specific rules for external users, and overriding these settings based on file tags.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Enforce download encryption for members who already have download permissions, either because they are owners or have been granted editing permissions. If not enabled, downloads will function normally where applicable.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify members who are exceptions to the above restrictions.",
      "externalUserEnforcementTitle": "External User Enforcement",
      "externalUserEnforcementDescription": "Enforce download encryption for all external users",
      "tagBasedEncryptionTitle": "Tag-Based Encryption",
      "tagBasedEncryptionDescription": "Force Encrypted download with specific tags",
      "tagBasedEncryptionPlaceholder": "Tags (comma separated), - e.g. 'confidential, secret'",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags",
      "tagsRequired": "At least one tag is required when there are multiple rules"
    },
    "downloadAllowedTags": {
      "title": "Download allowed tags",
      "description": "Allows members to download documents that are shared with Read-Only permissions.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator. This setting can define the scope of permissions, the conditions under which they apply, and any exceptions allowed.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify members who are exceptions to the above restrictions.",
      "externalUserEnforcementTitle": "External User Enforcement",
      "externalUserEnforcementDescription": "Enforce download encryption for all external users",
      "tagsTitle": "Tags",
      "tagsDescription": "Enable download for read-only files only for files with these tags.",
      "tagsPlaceholder": "Tags (comma separated), - e.g. 'confidential, secret'",
      "tagsRequired": "At least one tag is required when there are multiple rules"
    },
    "forcedAntiCaptureMode": {
      "title": "Forced Anti-Capture mode",
      "description": "Enforce viewing shared files with specific tags only in Anti-Capture mode.",
      "forcedAntiCaptureModeTitle": "Anticapture Enforcement",
      "forcedAntiCaptureModeDescription": "Select whether to apply anti-capture to all or none. Enabling anti-capture will also activate secure file downloads.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify members who are exceptions to the above restrictions.",
      "tagBasedEncryptionTitle": "Tag-Based Encryption",
      "tagBasedEncryptionDescription": "Apply this rule only to files with specific tags"
    },
    "aiTagging": {
      "title": "AI tagging",
      "description": "Enable AI tagging for files. This will automatically tag files based on their content.",
      "descriptionInternal": "Enable AI tagging for files. This will automatically tag files based on their content. <DangerText>Note: This applies only to files smaller than 250 MB. Changes to these settings are NOT applied retroactively, meaning files with existing tags will not be automatically classified.</DangerText>",
      "isRuleEnabledTitle": "Enable AI Tagging Rule",
      "isRuleEnabledDescription": "Enable the ability for users ( Admins and Contributors ) to let the AI tag their files based on their content.",
      "isAutomaticClassificationEnabledTitle": "Enable Automatic Classification",
      "isAutomaticClassificationEnabledDescription": "Enable the automatic classification of files based on their content.",
      "ruleTargetTitle": "Rule Target",
      "ruleTargetDescription": "Select the target of the rule.",
      "tagsTitle": "Tags",
      "tagsDescription": "Apply this rule only to files with specific tags",
      "aiAgentTitle": "AI Agent",
      "aiAgentDescription": "Select the AI agent to use for tagging files.",
      "aiAgentPlaceholder": "Select an AI agent",
      "membersTitle": "Who Can Classify with the Selected Agent",
      "membersDescription": "Choose which members the selected agent applies to.",
      "exceptionsTitle": "Manage Exceptions",
      "exceptionsDescription": "Add users you don't want to have automatic classification",
      "exceptionsButtonText": "Manage users",
      "filesTypeTitle": "File Extension Management",
      "filesTypeDescription": "Specify the file extensions to be classified by the agent.",
      "externalUserTitle": "External User",
      "externalUserDescription": "Allow classification by external users.",
      "filesTypePlaceholder": "Please select one or more",
      "folderIdsTitle": "Folders to be classified",
      "folderIdsDescription": "Select the folders to be classified by the selected agent."
    },
    "singleSignOn": {
      "title": "Single sign-on (SSO)",
      "enableTitle": "Enable Single Sign-On",
      "description": "Enable Single Sign-On (SSO) for your organization. This will allow your users to log in to Filegrant Enterprise using their existing credentials from a supported identity provider.",
      "providers": "Providers",
      "providersDescription": "Select the providers you want to enable for Single Sign-On (SSO).",
      "google": "Google",
      "microsoft": "Microsoft",
      "cybergrant": "CyberGrant",
      "notificationSsoEnableMessage": "The Single Sign-On (SSO) feature is being enabled. This process may take a few minutes to complete. Please remain on this page until the process is completed.",
      "notificationSsoEnabledMessage": "The Single Sign-On (SSO) feature has been enabled successfully.",
      "copyRedirectUriHint": "Copy it and add in the configuration of your IdP.",
      "redirectUri": "Redirect URI",
      "copyRedirectUriDesc": "Copy it and add in the configuration of your IdP.",
      "notificationSsoEnableTimeout": "Error enabling SSO",
      "notificationSsoEnableTimeoutDesc": "It was not possible to enable the Single Sign-On (SSO) feature. Please try again.",
      "domainAlreadySet": "This domain is already set",
      "mobileRedirectUri": "Mobile Redirect URI",
      "mobileRedirectUriHint": "Add this redirect URI only if you want to enable SSO on the mobile app.",
      "clientCertificate": "Client certificate",
      "certificateInUse": "Certificate in use",
      "certificateThumbprint": "Thumbprint",
      "certificateExpiresAt": "Expires",
      "certificateExpired": "This certificate expired on {{date}}. SSO login and Entra ID sync will fail until you replace it.",
      "certificateExpiringSoon": "This certificate expires on {{date}} (in {{days}} days).",
      "certificateTooLarge": "The certificate file is too large. Use a PKCS#12 (.pfx/.p12) under the size limit.",
      "certificateReadyToUpload": "New certificate selected. Enter its password (leave empty if none) and save.",
      "uploadCertificate": "Upload certificate",
      "replaceCertificate": "Replace certificate",
      "clearCertificate": "Clear certificate",
      "certificatePassword": "Certificate password",
      "certificatePasswordHint": "Enter the PKCS#12 password on every new upload; the stored password is never reused. Leave empty if the file has no password.",
      "certificatePasswordPlaceholder": "PKCS#12 password (optional)",
      "noCredentialsWarning": "No client secret or certificate is configured. Add at least one credential before enabling this provider.",
      "clientIdChangeWarning": "Client ID changed. Send a new client secret and/or re-upload the certificate, or masked credentials will be cleared.",
      "clientIdChangeBlocksSave": "Cannot save: client ID changed while keeping masked credentials",
      "clientIdChangeBlocksSaveHint": "Microsoft configuration {{index}}: enter a new client secret and/or upload a certificate before saving.",
      "certificateProblemEntry": "{{provider}} — configuration {{index}}: {{message}}",
      "errors": {
        "certificateInvalid": "The client certificate could not be accepted",
        "certificateNotSupported": "Certificates are not supported for this provider",
        "invalidConfiguration": "Invalid Single Sign-On configuration"
      }
    },
    "fileDeletionRestriction": {
      "title": "File deletion restriction",
      "description": "Enable granular control over file deletion by users. This setting allows you to define deletion permissions based on the user’s role with respect to the file: creator, owner, or recipient. This ensures clear and secure content management rules, preventing unauthorized deletions and supporting compliance with organizational policies.",
      "allowDeletionFor": "Allow Deletion For",
      "allowDeletionForDescription": "Choose whether all or none of the users are allowed to delete files.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify members who are exceptions to the above restrictions.",
      "fileAccessTypeTitle": "Authorized Access Types",
      "fileAccessTypeDescription": "Select the types of file/folder access that are authorized to delete the file.",
      "owner": "Owner",
      "creator": "Creator",
      "receiver": "Receiver"
    },
    "adminRegisteredMemberVisibility": {
      "title": "Admin registered member visibility",
      "description": "Control the visibility of admin-registered members or groups to users. Options include allowing all users to see admin-registered users or none. Visibility is primarily through file sharing. When a user shares a file with an email address corresponding to an admin-registered member, the user will see the member's name and surname after the sharing, even if the user does not have permission to view admin-registered users as per this setting. This limitation does not apply to users or groups to which the status Private has been assigned.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify members who are exceptions to the above restrictions.",
      "sectionTitle": "Users Visibility Limitations",
      "visibilityTitle": "Admin-Registered Members Visibility",
      "visibilityDescription": "Control the visibility of admin-registered members or groups to users. Options include allowing all users to see admin-registered users or none. Visibility is primarily through file sharing. When a user shares a file with an email address corresponding to an admin-registered member, the user will see the member's name and surname after the sharing, even if the user does not have permission to view admin-registered users as per this setting. This limitation does not apply to users or groups to which the status Private has been assigned."
    },
    "aiFileSummary": {
      "title": "AI file summary",
      "description": "Enable AI file summary for files. This will automatically generate a summary of the file based on its content.",
      "descriptionInternal": "Enable AI file summary for files. This will automatically generate a summary of the file based on its content. <DangerText>Note: This applies only to files smaller than 250 MB.</DangerText>",
      "activeForAllTitle": "AI File Summary access",
      "activeForAllDescription": "Choose whether the AI-generated file summaries are available to all users or to none.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify members who are exceptions to the above restrictions.",
      "externalUserTitle": "External User",
      "externalUserDescription": "Allow summary generation by external users.",
      "filesTypeTitle": "File Extension Management",
      "filesTypeDescription": "Specify the file extensions to be summarized by the AI.",
      "filesTypePlaceholder": "Please select one or more"
    },
    "aiFileChat": {
      "title": "AI file chat",
      "description": "Enable AI file chat for files. This will allow users to chat with the file content.",
      "descriptionInternal": "Enable AI file chat for files. This will allow users to chat with the file content. <DangerText>Note: This applies only to files smaller than 250 MB.</DangerText>",
      "activeForAllTitle": "AI File Chat access",
      "activeForAllDescription": "Choose whether the AI-generated file chat are available to all users or to none.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify members who are exceptions to the above restrictions.",
      "externalUserTitle": "External User",
      "externalUserDescription": "Allow chat with the file content by external users.",
      "filesTypeTitle": "File Extension Management",
      "filesTypeDescription": "Specify the file extensions to be chat with the AI.",
      "filesTypePlaceholder": "Please select one or more"
    },
    "aiScraping": {
      "title": "AI scraping",
      "description": "Deny AI scraping for files. This will deny any AI tool from scraping the file content.",
      "descriptionInternal": "Deny AI scraping for files. This will deny any AI tool from scraping the file content. <DangerText>Note: AI scraping is applied only to files opened in Read-Only mode and smaller than 250 MB. Scraping protection is currently active only on PDF and Office files.</DangerText>",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator. This setting can define the scope of permissions, the conditions under which they apply, and any exceptions allowed.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify members who are exceptions to the above restrictions.",
      "externalUserTitle": "External User",
      "externalUserDescription": "Allow scraping the file content by external users.",
      "tagsTitle": "Tags",
      "tagsDescription": "Apply these rules only to files with specific tags",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags"
    },
    "onBehalfMode": {
      "title": "On behalf mode",
      "description": "Control the on behalf mode for the platform. This will allow you to specify which contributors can perform actions on behalf of other contributors.",
      "internalTitle": "Admin Actions on Behalf of Users",
      "internalDescription": "Authorized admins can view the list of contributor files and perform necessary actions such as moving, deleting, or sharing files on behalf of users. However, they cannot open or view the contents of the files, maintaining user privacy. Only he super admin has the authority to enable or disable this feature for individual admins. This ensures that only trusted admins have the ability to manage user files",
      "activeForAllTitle": "Admins Scope",
      "activeForAllDescription": "Control the ability to define whether admins can perform actions on behalf of all users or none. This setting allows you to specify if admins have the permission to manage files and perform tasks on behalf of other users within the platform.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Admins selected here will be exceptions to the above 'on behalf' permissions."
    },
    "fileSalesPermission": {
      "title": "File sales permission",
      "description": "Allow users to sell their own files through the platform.",
      "internalTitle": "Enable File Selling for Members",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Allow members to sell their own files through the platform. Options include enabling this feature for all members or none. Files listed for sale will be managed by the platform, ensuring secure transactions and proper handling of payments.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify users who are exceptions to the above feature.",
      "externalUserTitle": "External User",
      "externalUserDescription": "Allow file selling by external users."
    },
    "resharingPermission": {
      "title": "File re-sharing permission",
      "description": "Allow users to re-share files with others, while enforcing rules based on predefined options and the tags applied to each file. This ensures controlled distribution of content and helps maintain compliance with organizational policies.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions on sharing files with specific options and tags set by the admin. Options include applying this permission to all users or none. Existing files that have already been shared will remain active, and changes to tags will not affect these previously shared files.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify users who are exceptions to the above rule.",
      "showUsers": "Show users who have already been granted access by others.",
      "allowEdit": "Lets users change, override, or delete existing sharing settings.",
      "readOnly": "Enable file sharing by users with read-only (Viewer) access.",
      "tagsTitle": "Tags",
      "tagsDescription": "Apply these rules only to files with specific tags",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags"
    },
    "fileVersioningRetentionPolicies": {
      "title": "File versioning",
      "description": "Configure how file versions are retained. Retention Count is required, while Retention Age is optional and can be set to 0.",
      "retentionByCountTitle": "Retention by Count",
      "retentionByCountDescription": "Set retention by count – keep only the last N versions of each file; older versions are automatically purged once this limit is reached",
      "retentionByAgeTitle": "Retention by Age",
      "retentionByAgeDescription": "Set retention by age – delete versions older than N days; any snapshot exceeding this age will be automatically purged to prevent storage bloat"
    },
    "retentionPolicies": {
      "title": "Retention policies",
      "description": "Configure how long files are kept on the platform. Manage automatic deletion from the trash and define retention rules for active files.",
      "exceptionHandlingTitle": "Exception Handling",
      "trash": {
        "title": "Trash retention",
        "description": "Files moved to the trash are deleted permanently after the configured number of days.",
        "activeForAllTitle": "Trash retention scope",
        "activeForAllDescription": "Choose whether trash retention applies to all users or to none. Policy values below remain editable; use the exception list to exclude specific users or groups.",
        "retentionDaysTitle": "Days in Trash",
        "retentionDaysDescription": "Days a file stays in the trash before permanent deletion. Must be greater than 0.",
        "exceptionHandlingDescription": "Users and groups in this list are not subject to trash retention; their files remain in the trash indefinitely."
      },
      "files": {
        "title": "File retention",
        "description": "Apply a retention rule to active files. The retention period is counted from the date you choose below (creation or last modification).",
        "activeForAllTitle": "File retention scope",
        "activeForAllDescription": "Choose whether file retention applies to all users or to none. Policy values below remain editable; use the exception list to exclude specific users or groups.",
        "retentionDaysTitle": "Retention Period (days)",
        "retentionDaysDescription": "Number of days after the selected reference date (creation or modification) after which the action is triggered. Must be greater than 0.",
        "retentionTriggerTitle": "Count retention from",
        "retentionTriggerDescription": "Choose whether the retention period is calculated from when the file was created or when it was last modified.",
        "retentionTrigger": {
          "created_at": "File creation date",
          "updated_at": "Last modification date"
        },
        "actionOnExpiryTitle": "Action on Expiry",
        "actionOnExpiryDescription": "What happens to files that exceed the retention period.",
        "actionOnExpiry": {
          "MoveToTrash": "Move to trash",
          "DeletePermanently": "Delete permanently",
          "RetainedTagWorkflow": "Apply *RETAINED tag, then delete"
        },
        "retainedTag": {
          "title": "How the *RETAINED tag works",
          "step1": "When you save this policy, the server creates a system tag named *RETAINED (visible in the company tag list, but read-only).",
          "step2": "After the retention period above, the *RETAINED tag is automatically applied to every file created more than that many days ago.",
          "step3": "Once tagged, the file remains accessible but the tag cannot be removed by anyone: the UI hides the detach control and the server rejects any attempt to delete a system tag.",
          "step4": "When the days set below pass since the tag was applied, the file is permanently deleted (DB + storage). Add users or groups to the exceptions to opt them out of the whole flow."
        },
        "retainedTagDaysTitle": "Days with *RETAINED tag",
        "retainedTagDaysDescription": "After the *RETAINED tag is applied, files are permanently deleted after this many days. Must be greater than 0.",
        "tagsTitle": "Apply only to files with these tags",
        "tagsDescription": "Leave empty to apply the policy to all files. Only public tags are supported.",
        "exceptionHandlingDescription": "Users and groups in this list are not subject to file retention; their files are never moved to trash, deleted, or tagged as *RETAINED."
      },
      "deletePermanentlyConfirm": {
        "title": "Confirm permanent deletion policy",
        "description": "<DangerText>This action will PERMANENTLY delete every company file that exceeds the retention period. This operation is not reversible.</DangerText>"
      },
      "deletePermanentlySelectWarning": {
        "title": "Confirm permanent deletion",
        "description": "When this action is selected, files that exceed the retention period will be deleted permanently. <DangerText>This cannot be undone, and deleted files cannot be recovered.</DangerText><br></br>To proceed, type <DangerText>{{confirmKeyword}}</DangerText> in the field below."
      },
      "errors": {
        "trashRetentionDays": "Days in trash must be greater than 0.",
        "retentionDays": "Retention period must be greater than 0.",
        "retainedTagDays": "Days with *RETAINED tag must be greater than 0."
      }
    },
    "mandatoryExpirationSharedFile": {
      "title": "Mandatory expiration shared file",
      "description": "Control the mandatory expiration of shared files. This will allow you to specify which shared files must have an expiration date.",
      "descriptionInternal": "This section enforces time limits on file sharing to prevent indefinite access. Administrators can require an expiration date for every shared file, set a maximum allowed duration, and block shares with no expiration date. These rules ensure that shared access is temporary and aligned with security and compliance requirements. <DangerText> Changes to these settings are NOT applied retroactively, meaning existing shares that exceed the new limits will be NOT updated.</DangerText>",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator. This setting can define the scope of permissions, the conditions under which they apply, and any exceptions allowed. It ensures that user activity remains aligned with organizational policies while still allowing flexibility where appropriate.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify members who are exceptions to the above restrictions.",
      "maxAllowedByAgeTitle": "Maximum Allowed Duration",
      "maxAllowedByAgeDescription": "Sets a maximum duration limit (e.g., 90 days) for any file share.",
      "excludedDomainsTitle": "Excluded domains",
      "excludedDomainsDescription": "Shares toward these exact domains do not require an expiration date. Enter domains only (e.g. company.com), with no wildcards or URLs. Leave empty for no exemption.",
      "excludedDomainsPlaceholder": "No excluded domains, click to add",
      "excludedGroupsTitle": "Excluded groups",
      "excludedGroupsDescription": "Group shares can be exempt from mandatory expiration. Choose none, all groups, or specific groups. User membership in an exempt group does not exempt individual user shares.",
      "excludedGroupsModeNone": "No groups exempt",
      "excludedGroupsModeAll": "All groups exempt",
      "excludedGroupsModeSome": "Only selected groups exempt",
      "excludedGroupsPlaceholder": "Select exempt groups",
      "excludedGroupsExceptionsTitle": "Groups that remain subject",
      "excludedGroupsExceptionsPlaceholder": "Select groups that still require expiration",
      "tagsTitle": "Tags",
      "tagsDescription": "Applies the maximum sharing time limit only to files with certain tags.",
      "tagsRequired": "At least one tag is required when there are multiple rules",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags"
    },
    "fileTagManagement": {
      "title": "Tag removal rules",
      "description": "Define which tags cannot be removed from files. Users targeted by a rule cannot remove the selected tags from files; exceptions to the rule can be granted per user or group.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions on removing tags as defined by the admin. Existing tags on files will remain unchanged, and permission updates will not affect previously applied tags.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify users who are exceptions to the above rule.",
      "tagsTitle": "Tags",
      "tagsDescription": "Tags that cannot be removed from files. Leave empty to protect all tags.",
      "tagsRequired": "At least one tag is required when there are multiple rules"
    },
    "fileTagAdditionRestriction": {
      "title": "Tag addition rules",
      "description": "Define which tags cannot be added to files. Users targeted by a rule cannot add the selected tags to files; exceptions to the rule can be granted per user or group.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify users who are exceptions to the above rule.",
      "tagsTitle": "Tags",
      "tagsDescription": "Tags that cannot be added to files. Leave empty to restrict all tags.",
      "tagsRequired": "At least one tag is required when there are multiple rules"
    },
    "externalFileSharingRestriction": {
      "title": "External sharing restrictions",
      "description": "This section lets administrators decide if contributors can share files outside the organization and under what conditions. Sharing can be fully enabled, disabled, or limited to specific trusted domains. Rules can also restrict external sharing based on file tags or allow certain senders and recipients to bypass Data Loss Prevention (DLP) policies. These controls help secure confidential information and ensure external collaborations happen only with approved parties.",
      "descriptionInternal": "This section lets administrators decide if contributors can share files outside the organization and under what conditions. Sharing can be fully enabled, disabled, or limited to specific trusted domains. Rules can also restrict external sharing based on file tags or allow certain senders and recipients to bypass Data Loss Prevention (DLP) policies. These controls help secure confidential information and ensure external collaborations happen only with approved parties.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator. This setting can define the scope of permissions, the conditions under which they apply, and any exceptions allowed. It ensures that user activity remains aligned with organizational policies while still allowing flexibility where appropriate.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify members who are exceptions to the above rule.",
      "approvedDomainsTitle": "Approved Domains Only",
      "approvedDomainsDescription": "Limits sharing to a list of pre-approved domains.",
      "tagsTitle": "Tags",
      "tagsDescription": "Allows sharing with external domains only for files that have specific tags.",
      "tagsRequired": "At least one tag is required when there are multiple rules",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags",
      "approvedDomainsPlaceholder": "No domains approved, click to add"
    },
    "secureFileLocalAccess": {
      "title": "Secure file local access",
      "description": "Control the secure local access to files. This will allow you to specify which files can be accessed locally.",
      "descriptionInternal": "This setting defines how documents can be opened locally (on Windows or macOS) through the agent in a secure and encrypted way. If a user has the required permissions, they can open protected files with the authorized applications, ensuring compliance with Data Loss Prevention policies.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator. This setting can define the scope of permissions, the conditions under which they apply, and any exceptions allowed. It ensures that user activity remains aligned with organizational policies while still allowing flexibility where appropriate.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify members who are exceptions to the above rule.",
      "tagsTitle": "Tags",
      "tagsDescription": "Apply these rules only to files with specific tags",
      "tagsRequired": "At least one tag is required when there are multiple rules",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags",
      "restrictionsTitle": "Restrictions",
      "restrictionsDescription": "Define which user actions are limited when accessing protected documents:",
      "restrictCopyPaste": "Restrict Copy-Paste Operations",
      "restrictCopyPasteDescription": "Restrict copy-paste operations for files with specific tags.",
      "restrictPrint": "Restrict Printing",
      "restrictPrintDescription": "Restrict printing for files with specific tags.",
      "restrictAppInternetAccess": "Restrict App Internet Access",
      "restrictAppInternetAccessDescription": "Restrict app internet access for files with specific tags.",
      "restrictScreenCapture": "Restrict Screen Capture",
      "restrictScreenCaptureDescription": "Restrict screen capture for files with specific tags.",
      "localAccessSettingsTitle": "Local Access Settings",
      "localAccessSettingsDescription": "Configure how users can open and work with protected files on their devices:",
      "defaultLocalFileOpen": "Default Local File Opening",
      "defaultLocalFileOpenDescription": "Choose whether to open protected files with the default application or with the application specified in the 'Allowed Applications' field.",
      "allowedApplicationsTitle": "Allowed Applications",
      "allowedApplicationsDescription": "Choose the applications that are allowed to open protected files.",
      "offlineMode": "Enables file access when no internet connection is available",
      "offlineModeDescription": "Storing the certificate locally enables offline decryption of files. File contents may be exposed if the local user has access to the stored certificate"
    },
    "tagBasedAccessControl": {
      "title": "Tagged files visibility",
      "description": "Manage document access with tags (e.g. Public), granting visibility to all users or external guests, with optional read/write rights and password protection.",
      "descriptionInternal": "Control document access using user or group tags to simplify search and policy management. Tags (such as Public) can be applied to allow broader visibility, either to all registered users (Internal Public) or to external, unauthenticated users (Every One), with optional read or read/write permissions and password protection.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator. This setting can define the scope of permissions, the conditions under which they apply, and any exceptions allowed. It ensures that user activity remains aligned with organizational policies while still allowing flexibility where appropriate.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify members who are exceptions to the above rule.",
      "audienceTitle": "Audience",
      "audienceDescription": "Define who is allowed to access tagged documents.",
      "registeredUsers": "Registered Users",
      "unregisteredUsers": "Unregistered Users",
      "admin": "Admin",
      "contributors": "Contributors",
      "readers": "Readers",
      "external": "External",
      "readAndWrite": "Read & Write",
      "readOnly": "Read Only",
      "passwordRequired": "Require password for access",
      "setLinkExpiration": "Set link expiration (date/time)",
      "tagsTitle": "Tags",
      "tagsDescription": "Allows sharing with external domains only for files that have specific tags.",
      "tagsRequired": "At least one tag is required when there are multiple rules",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags",
      "accessPolicyTagsRequired": "Access policy tags are required"
    },
    "contributorStorageLimit": {
      "title": "Storage limitations",
      "allocationTitle": "Contributor Storage Allocation",
      "allocationDescription": "Define the storage space available to contributors for uploading and sharing files. This option allows you to set specific storage limits for contributors or choose \"License-Limited\" for storage that is bound by the total space purchased by the company under its license."
    },
    "deviceAccessLimitation": {
      "title": "Handling simultaneous connections",
      "browsersTitle": "Browsers",
      "browsersDescription": "Set the number of simultaneous connections each member can make to Filegrant Enterprise via different browsers using the web application",
      "exceedingConnectionsTitle": "Exceeding Browser Connections",
      "exceedingConnectionsDescription": "Specify the action to take when the number of connected browsers exceeds the allowed limit.",
      "invalidateOldSessionsOption": "Automatically invalidate the session token of the oldest connections.",
      "blockAccessOption": "Deny access until older sessions are manually disconnected or expire."
    },
    "editorFileManagement": {
      "title": "Contributor file management control",
      "subtitle": "Control the permissions for contributors to delete and rename files and folders within their accounts. Options include allowing all contributors or none, with actions restricted to files they have uploaded or received with editor access.",
      "deletionPermissionsTitle": "Deletion Permissions",
      "deletionPermissionsDescription": "Control whether contributors can delete files. Options include allowing or disallowing contributors to delete files they have uploaded or received with editor access.",
      "userScopeTitle": "User Scope",
      "userScopeDescription": "Control the application of the above permissions to all contributors or none.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify users who are exceptions to the above permissions. These users will have customized access to delete and rename files and folders regardless of the general settings."
    },
    "fileSizeLimit": {
      "title": "File size limit per member",
      "limitTitle": "File Size Limitation",
      "limitDescription": "Define the maximum file size that members can upload. This setting allows you to control the largest file size that can be added to the platform by any member, ensuring efficient use of storage space and maintaining optimal performance."
    },
    "quickShareMode": {
      "title": "Quick Share",
      "description": "Manage Quick Share settings. Control activation, auto-open after login, and maximum sharing duration.",
      "isVisibleTitle": "Visible",
      "isVisibleDescription": "Enable or disable Quick Share for users",
      "activeForAllTitle": "Quick Share access",
      "activeForAllDescription": "Choose whether Quick Share is available to all users or to none.",
      "exceptionsTitle": "Exception handling",
      "exceptionsDescription": "Specify members who are exceptions to the above rule.",
      "showQuickShareByDefaultTitle": "Show Quick Share by default",
      "showQuickShareByDefaultDescription": "Make Quick Share the default landing page after login",
      "maxSharingDaysTitle": "Maximum sharing duration (days)",
      "maxSharingDaysDescription": "Set how many days sharing lasts. Shares expire automatically after the selected number of days (maximum 365)",
      "enabledTitle": "Enable Quick Share",
      "enabledDescription": "When enabled, users can share files via Quick Share. When disabled, the Quick Share feature is not available.",
      "daysTitle": "Maximum sharing duration",
      "daysDescription": "After this number of days the shared file link will expire and the share will be removed.",
      "daysOption1": "Sharing last 1 day",
      "daysOption3": "Sharing last 3 days",
      "daysOption7": "Sharing last 7 days",
      "daysOption14": "Sharing last 14 days",
      "daysOption30": "Sharing last 30 days",
      "daysOption90": "Sharing last 90 days"
    },
    "totpRequired": {
      "title": "Two-factor authentication (TOTP)",
      "description": "Configure company-wide TOTP 2FA. Require TOTP for all users, set a grace period for new accounts, and allow admins to reset user TOTP.",
      "requiredTitle": "Require TOTP for all users",
      "requiredDescription": "When enabled, all users must set up TOTP. New users have a grace period to activate it after account creation.",
      "gracePeriodDaysTitle": "Grace period (days)",
      "gracePeriodDaysDescription": "Users have this many days from account creation to activate TOTP before login is blocked.",
      "allowAdminResetTitle": "Allow admins to reset user TOTP",
      "allowAdminResetDescription": "When enabled, administrators can disable TOTP for users who have lost access to their authenticator app.",
      "maxExemptionDaysTitle": "Max exemption days",
      "maxExemptionDaysDescription": "Maximum number of days (1–365) for a temporary TOTP exemption when an admin grants one. Default 30.",
      "allowPermanentExemptionTitle": "Allow permanent exemptions",
      "allowPermanentExemptionDescription": "When enabled, administrators can grant permanent TOTP exemptions (no expiry). When disabled, only temporary exemptions are allowed.",
      "gracePeriodOption0": "No grace period (immediate)",
      "gracePeriodOption1": "1 day",
      "gracePeriodOption3": "3 days",
      "gracePeriodOption7": "7 days (recommended)",
      "gracePeriodOption14": "14 days",
      "gracePeriodOption30": "30 days"
    },
    "passkeySettings": {
      "allowAdminRemoveDescription": "When enabled, administrators can remove individual passkeys or clear all passkeys for a user from admin tools.",
      "allowAdminRemoveTitle": "Allow administrators to remove user passkeys",
      "allowAs2faDescription": "When enabled, users who complete email OTP may finish login with a passkey instead of TOTP, depending on enrollment and other policies.",
      "allowAs2faTitle": "Allow passkeys as a second factor",
      "allowPasswordlessDescription": "When enabled, eligible users may sign in with a passkey without an email OTP. Requires passkeys as a second factor to be allowed.",
      "allowPasswordlessTitle": "Allow passwordless passkey sign-in",
      "attestationOptionDirect": "Direct",
      "attestationOptionIndirect": "Indirect",
      "attestationOptionNone": "None (typical for most organizations)",
      "attestationPreferenceDescription": "How strongly the server requests attestation during registration. Higher levels can improve assurance but may reduce authenticator compatibility.",
      "attestationPreferenceTitle": "Attestation preference",
      "authenticatorAttachmentAny": "Any (no restriction)",
      "authenticatorAttachmentCrossPlatform": "Cross-platform (e.g. security key)",
      "authenticatorAttachmentDescription": "Optionally restrict registration to platform authenticators on this device, cross-platform security keys, or leave unrestricted for broadest compatibility.",
      "authenticatorAttachmentPlatform": "Platform (this device)",
      "authenticatorAttachmentTitle": "Authenticator attachment (optional)",
      "description": "Configure organization-wide passkeys (WebAuthn): enablement, second-factor vs passwordless sign-in, per-user limits, admin removal, and registration ceremony preferences.",
      "enabledDescription": "When disabled, passkey registration and passkey-based sign-in are not available for users under this policy.",
      "enabledTitle": "Enable passkeys for the organization",
      "maxCredentialsPerUserDescription": "Maximum number of passkeys each user may register (1–50). Limits sprawl and support overhead.",
      "maxCredentialsPerUserTitle": "Maximum passkeys per user",
      "title": "Passkeys (WebAuthn)",
      "userVerificationDescription": "How strictly the authenticator must verify the user during passkey registration. Required is strictest; discouraged is weakest.",
      "userVerificationOptionDiscouraged": "Discouraged",
      "userVerificationOptionPreferred": "Preferred",
      "userVerificationOptionRequired": "Required",
      "userVerificationTitle": "User verification for registration"
    },
    "antivirusScan": {
      "title": "Antivirus scan",
      "description": "Configure which uploaded file types are scanned by the antivirus engine. The extension filter controls scan cost, not security policy.",
      "enabledTitle": "Enable antivirus scanning",
      "enabledDescription": "When enabled, matching uploads are scanned asynchronously. When disabled, new uploads are not scanned, but existing scan verdicts remain on files.",
      "extensionsTitle": "Scanned file extensions",
      "extensionsDescription": "Only files whose extension is listed here are sent to the scanner. Narrow the list to reduce scan volume and cost.",
      "extensionsPlaceholder": "Select extensions to scan",
      "costNoticeTitle": "Cost filter, not a security boundary",
      "costNoticeDescription": "Extensions outside this list are not scanned — including an executable renamed to .txt. Narrow the list to reduce scan volume and cost.",
      "saveError": "Antivirus scan settings are invalid. Enable scanning only with at least one extension selected.",
      "stickyInfectedNote": "Turning scanning off does not clear existing infected verdicts or remove files from quarantine."
    },
    "activityLogRetention": {
      "title": "Activity log retention",
      "description": "Define how long the company keeps its activity log. Once the retention period has elapsed since a log entry was created, the entry is permanently deleted.",
      "activeTitle": "Retention policy",
      "activeDescription": "When disabled, the activity log is kept indefinitely and nothing is ever deleted.",
      "windowTitle": "Retention period",
      "windowDescription": "Log entries older than this period are permanently deleted. Allowed range: from {{min}} months to {{max}} years.",
      "warningTitle": "Deletion is permanent and retroactive",
      "warningDescription": "Enabling the policy also deletes log entries that already exceed the retention period. Deleted entries cannot be recovered: export the activity log first if you need to keep a copy."
    },
    "securityAnalysis": {
      "title": "Executive Report & Security Notification",
      "description": "Single configuration for the Executive Report (internal domains, risk indicator thresholds), the security anomaly detection thresholds and the email notifications for detected anomalies.",
      "enableTitle": "Enable email notifications",
      "enableDescription": "When enabled, an email is sent to the selected recipients for new security anomalies of the chosen severity or above.",
      "recipientsTitle": "Recipients",
      "recipientsDescription": "Platform users and groups that will receive the notifications. For groups, all members are notified.",
      "recipientsPlaceholder": "Search for users or groups",
      "minSeverityTitle": "Minimum severity",
      "minSeverityDescription": "Send notifications only from this severity upwards. Warning includes Warning and Critical; Critical sends only Critical.",
      "severityWarning": "Warning and above",
      "severityCritical": "Critical only",
      "domainsTitle": "Internal domains",
      "domainsDescription": "Comma-separated list of email domains considered internal when the Executive Report distinguishes internal vs external sharing. If empty, the email domain of the first administrator is used.",
      "domainsPlaceholder": "company.com, subsidiary.com",
      "domainsError": "One or more domains are not in a valid format (e.g. company.com).",
      "thresholdsTitle": "Risk indicator thresholds",
      "thresholdsDescription": "Percentage thresholds defining what is considered warning and what is considered critical for each risk indicator of the Executive Report.",
      "warningLabel": "Warning ≥",
      "criticalLabel": "Critical ≥",
      "thresholdError": "The warning threshold must be lower than the critical threshold.",
      "detectorThresholdsTitle": "Anomaly detection thresholds",
      "detectorThresholdsDescription": "Event counts defining what is considered warning and what is considered critical for each security anomaly detector. Detectors without numeric thresholds (blocked admin IP, explicit security signals) are not customizable.",
      "detectorThresholdError": "The warning threshold must be lower than the critical threshold.",
      "detectors": {
        "bruteForceLogin": "Failed logins on the same account (15 min window)",
        "folderPassword": "Failed folder password attempts (per folder and user)",
        "publicLinkBruteForce": "Failed public link accesses (per link and IP)",
        "massDownload": "Files downloaded by one user (60 min window)",
        "passwordSpray": "Password spray: distinct accounts attempted from one IP",
        "unauthorizedCountry": "Blocked accesses from unauthorized country (per user and country)"
      }
    },
    "ipRegionRestriction": {
      "title": "IP/region restriction",
      "description": "Restrict platform access based on IP address, country, or region",
      "warningMessage": "Warning: This setting blocks all users who don't match the criteria",
      "warningDescription": "Users outside allowed IPs, countries, or regions will be denied access. Configure exceptions for specific users or groups.",
      "confirmTitle": "Confirm Configuration",
      "confirmWarning": "This configuration will restrict access. Users outside allowed IPs, countries, or regions will be denied access. Are you sure?",
      "scopeTitle": "Scope of Application",
      "scopeDescription": "When should this restriction apply?",
      "scopeLogin": "Login Only",
      "scopeFileOps": "File Operations Only",
      "scopeBoth": "Both (Recommended)",
      "allowedIpsTitle": "Allowed IP Addresses / CIDR Ranges",
      "allowedIpsDescription": "Comma-separated list of IPs or CIDR ranges (IPv4/IPv6)",
      "allowedCountriesTitle": "Allowed Countries",
      "allowedCountriesDescription": "Select countries (ISO 3166-1 alpha-2 codes)",
      "allowedRegionsTitle": "Allowed Regions",
      "allowedRegionsDescription": "Select regions (ISO 3166-2 codes or 'EU' for European Union)",
      "allowPrivateNetworksTitle": "Allow Private Networks",
      "allowPrivateNetworksDescription": "Bypass restriction for private IP ranges (10.x, 192.168.x, 172.16-31.x)",
      "adminAccessSectionTitle": "Admin Access",
      "restrictAdminAccessTitle": "Restrict admin settings by IP",
      "restrictAdminAccessDescription": "Allow access to admin settings only from specified IP addresses or CIDR ranges",
      "adminAllowedIpsTitle": "Allowed admin IP addresses",
      "adminAllowedIpsDescription": "Comma-separated list of IPs or CIDR ranges permitted to open admin settings",
      "addAdminIp": "Add IP",
      "addAllowedIp": "Add IP or CIDR",
      "logBlockedAttemptsTitle": "Log Blocked Attempts",
      "logBlockedAttemptsDescription": "Record all access denial attempts in activity log",
      "blockedMessageTitle": "Custom Blocked Message",
      "blockedMessageDescription": "Message shown to blocked users (max 200 characters)",
      "blockedMessagePlaceholder": "Access denied from your location.",
      "exceptionsTitle": "Exceptions",
      "exceptionsDescription": "Users or groups with additional access criteria",
      "validationAtLeastOne": "At least one criterion (IP, country, or region) must be specified",
      "validationInvalidIp": "Invalid IP/CIDR format: {{entries}}",
      "validationInvalidCountry": "Invalid country codes: {{codes}}",
      "validationInvalidRegion": "Invalid region codes: {{codes}}",
      "adminAllowedIpsHelper": "IP/CIDR only: no geolocation, no private-network bypass, and the exceptions above do not apply here."
    },
    "fileTypeRestriction": {
      "title": "File type restriction control",
      "description": "Allows you to specify which file types are blocked for upload.",
      "blockedExtensionsTitle": "File Extensions Blocked",
      "blockedExtensionsDescription": "Specify which file extensions are blocked. This allows you to define exactly which file types are subject to the restrictions.",
      "userScopeTitle": "User Scope",
      "userScopeDescription": "Control whether users will be blocked from uploading or sharing files on the platform according to the specified file types defined above. Options include blocking all users or none. Existing files uploaded or shared will remain active even if the permission is later revoked.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify users who are exceptions to the above feature.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator. This setting can define the scope of permissions, the conditions under which they apply, and any exceptions allowed.",
      "exceptionsTitle": "Exception Handling",
      "exceptionsDescription": "Specify users who are exceptions to the above restrictions.",
      "showUsers": "Show users who have already been granted access by others.",
      "allowEdit": "Lets users change, override or delete existing sharing settings.",
      "readOnly": "Enable file sharing by users with read-only (Viewer) access.",
      "tagsTitle": "Tags",
      "tagsDescription": "Apply these rules only to files with specific tags.",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags",
      "tagsRequired": "At least one tag is required when there are multiple rules",
      "fileTypesTitle": "File Types",
      "fileTypesDescription": "Define the file types that are subject to this rule.",
      "fileTypesPlaceholder": "Select file types or extensions"
    },
    "folderCreationPermission": {
      "title": "Folder limitations",
      "creationTitle": "Contributor Folder Creation",
      "creationDescription": "Control which contributors can create folders on the platform. Options include allowing all contributors or none. Existing folders remain accessible even if the permission is later revoked.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify users who are exceptions to the above feature."
    },
    "groupCreationControl": {
      "title": "Group limitations",
      "creationTitle": "Contributor Group Creation",
      "creationDescription": "Control which contributors can create groups on the platform. Options include allowing all contributors or none. Groups created are visible only to the user who created them. Existing groups remain accessible even if the permission is later revoked.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify users who are exceptions to the above feature."
    },
    "publicAccessLink": {
      "title": "Public access link",
      "description": "Control the ability for contributors to generate links for accessing files and folders without authentication. Options include allowing all members or none to create these links. Existing links will remain active even if the permission is later revoked.",
      "activeForAllTitle": "Contributor Link Generation",
      "activeForAllDescription": "Control the ability for contributors to generate links for accessing files and folders without authentication. Options include allowing all members or none to create these links. Existing links will remain active even if the permission is later revoked.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify contributors who are exceptions to the above link generation permissions.",
      "forcePasswordTitle": "Force Password",
      "forcePasswordDescription": "When enabled, the user must set a password when creating a public link.",
      "mandatoryMaxAccessCountTitle": "Mandatory Max Access Count",
      "mandatoryMaxAccessCountDescription": "If greater than 0, the user must specify a maximum number of accesses (0–10000). 0 means not required.",
      "maxExpirationDaysTitle": "Max Expiration Days",
      "maxExpirationDaysDescription": "If greater than 0, the user must set an expiration within this many days (0–365). 0 means no constraint. <br /> <DangerText> If “Mandatory Expiration Shared File” is enabled, the expiration date defined in that setting will take precedence over the maximum expiration date configured here. </DangerText>",
      "tagsTitle": "Tags",
      "tagsDescription": "Public links can only be created for files with these tags."
    },
    "sessionControl": {
      "title": "Concurrent session limit",
      "description": "Limit the number of active sessions per user. When a user exceeds the limit, the oldest session is automatically terminated.",
      "maxSessionsTitle": "Maximum Sessions",
      "maxActiveSessions": "Max active sessions",
      "maxSessionsDescription": "Set the maximum number of concurrent sessions allowed per user. When the limit is reached, the oldest session will be automatically disconnected.",
      "unlimited": "Unlimited",
      "exceptionsTitle": "Exceptions",
      "exceptionsDescription": "Override the session limit for specific users or groups.",
      "pendingExceptionsTitle": "Pending exceptions",
      "savedExceptionsTitle": "Saved exceptions",
      "selectUsersOrGroups": "Select users or groups..."
    },
    "uploadWithTag": {
      "title": "Automatic tag management",
      "description": "Filegrant Enterprise will scan the metadata of the uploaded classified files for specific keywords. If any of the specified keywords are detected, the corresponding value will be applied to the file as a tag. If a tag does not already exist on the platform, it is created automatically. This process ensures that every file is properly categorized and tagged based on its content.",
      "keywordsTitle": "Keywords",
      "keywordsDescription": "Specify the keywords whose values will be used as tags for the file after upload.",
      "userScopeTitle": "User Scope",
      "userScopeDescription": "Control whether members are subject to automatic tag detection for file uploads on the platform. Options include applying this to all members or none. Existing files that have already been uploaded and tagged will remain active, and changes to keywords will not affect these previously tagged files.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify users who are exceptions to the above feature."
    },
    "watermarkProtection": {
      "title": "Watermark protection",
      "description": "Control watermark protection for shared files. Enable for all members or none, manage exceptions, and configure which data appears on the watermark (e.g. sharing date, owner, recipient, creation date, IP).",
      "descriptionInternal": "Control watermark protection for shared files. Enable for all members or none, manage exceptions, and configure which data appears on the watermark (e.g. sharing date, owner, recipient, creation date, IP). <DangerText>At the moment, watermarks are applied to PDF files and images (jpeg, png, svg), and only to recipients who receive Office files (doc, docx, ppt, pptx, xls, xlsx) in read-only mode.</DangerText>",
      "enabledTitle": "Enabled",
      "enabledDescription": "Turn this setting on or off.",
      "userScopeTitle": "User Scope",
      "userScopeDescription": "Allow members to protect their files with watermarks. Options include enabling this feature for all members or none. Watermarks can be applied at the time of sharing. When recipients open the document, the watermark will display their email address, IP address, and the date of document access, ensuring content protection and tracking.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Apply watermark protection to all members or none. When set to none, you can still target specific members via exceptions and tags.",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify users who are exceptions to the above feature.",
      "tagsTitle": "Tags",
      "tagsDescription": "Apply watermark protection only to files with these tags.",
      "previewTitle": "Preview",
      "textLabel": "Watermark text",
      "repetitionLabel": "Repetition",
      "repetitionSingle": "Single",
      "repetitionRepetitive": "Repetitive",
      "fieldsLabel": "Fields to display",
      "fieldsSharingDate": "Sharing date",
      "fieldsOwner": "Owner",
      "fieldsRecipient": "Recipient",
      "fieldsCreationDate": "Creation date",
      "fieldsIp": "IP address",
      "positionXLabel": "Horizontal position",
      "positionYLabel": "Vertical position",
      "positionLeft": "Left",
      "positionCenter": "Center",
      "positionRight": "Right",
      "positionTop": "Top",
      "positionMiddle": "Middle",
      "positionBottom": "Bottom",
      "positionsLabel": "Position",
      "positionsTopLeft": "Top left",
      "positionsTopCenter": "Top center",
      "positionsTopRight": "Top right",
      "positionsBottomLeft": "Bottom left",
      "positionsBottomCenter": "Bottom center",
      "positionsBottomRight": "Bottom right",
      "positionsDiagonal": "Diagonal (repeated)",
      "fontSizeLabel": "Font size",
      "fontSizeDescription": "1–72",
      "fontColorLabel": "Font color",
      "opacityLabel": "Opacity",
      "opacityDescription": "0–100%",
      "textPlaceholderHelp": "The buttons below insert placeholders into the text. You can use \\n for line breaks and **bold** for bold text. Each button's tooltip explains what it does.",
      "placeholderButtonOwner": "Owner",
      "placeholderTooltipOwner": "In the watermark, {owner} is replaced with the document owner name.",
      "placeholderButtonAccessDate": "View date/time",
      "placeholderTooltipAccessDate": "In the watermark, {access_date} is replaced with the date and time the document was viewed.",
      "placeholderButtonSharingDate": "Sharing date",
      "placeholderTooltipSharingDate": "In the watermark, {sharing_date} is replaced with the link generation date.",
      "placeholderButtonIp": "IP address",
      "placeholderTooltipIp": "In the watermark, {ip} is replaced with the viewer's IP address.",
      "placeholderButtonRecipient": "Recipient",
      "placeholderTooltipRecipient": "In the watermark, {recipient} is replaced with the recipient name.",
      "placeholderButtonOwnerEmail": "Owner email",
      "placeholderTooltipOwnerEmail": "In the watermark, {owneremail} is replaced with the document owner email address.",
      "placeholderButtonRecipientEmail": "Recipient email",
      "placeholderTooltipRecipientEmail": "In the watermark, {recipientemail} is replaced with the recipient email address."
    },
    "remotegrantForceEncryption": {
      "title": "Remotegrant force encryption (license required)",
      "description": "Encrypt files and automatically assign access permissions to newly created members using Remotegrant."
    },
    "sharingApprovalRequirement": {
      "title": "Sharing approval requirements",
      "description": "Controls whether file and folder sharing requires prior approval, ensuring sensitive files are reviewed before distribution and compliance is maintained.",
      "descriptionInternal": "This section allows administrators to control whether file and folder sharing requires prior approval. Rules can be applied universally, to specific file ownership types, or based on classification tags. Administrators can ensure that sensitive files are reviewed before being shared, helping maintain compliance, prevent data leaks, and enforce organizational policies. Approval requests can be routed to a designated supervisor or a pre-defined review team.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator. This setting can define the scope of permissions, the conditions under which they apply, and any exceptions allowed. It ensures that user activity remains aligned with organizational policies while still allowing flexibility where appropriate.",
      "exceptionsTitle": "Exception Handling",
      "exceptionsDescription": "Specify users who are exceptions to the above feature.",
      "reviewTeamTitle": "Review Team",
      "reviewTeamDescription": "Specify the team that will review the approval requests.",
      "tagsTitle": "Tags",
      "tagsDescription": "Apply these rules only to files with specific tags",
      "tagsRequired": "At least one tag is required when there are multiple rules",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags",
      "exceptionHandlingTitle": "Exception Handling",
      "exceptionHandlingDescription": "Specify users who are exceptions to the above feature.",
      "generalApprovalTitle": "General Approval Requirement",
      "generalApprovalDescription": "Sharing is only allowed after prior approval from a designated supervisor or team defined in the policy.",
      "resharingApprovalTitle": "Approval for Reshared Files Only",
      "resharingApprovalDescription": "Applies the approval requirement only to files that were previously received and are being reshared.",
      "manageReviewTeam": "Manage Review Team"
    },
    "mandatoryFileClassification": {
      "title": "Mandatory file classification",
      "description": "Require files to be classified before sharing, ensuring sensitive files are properly tagged and protected.",
      "descriptionInternal": "This section ensures that files are properly classified before they can be shared. By requiring classification, it helps prevent accidental or unauthorized sharing of sensitive content and supports consistent data governance.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator. This setting can define the scope of permissions, the conditions under which they apply, and any exceptions allowed. It ensures that user activity remains aligned with organizational policies while still allowing flexibility where appropriate.",
      "exceptionsTitle": "Exception Handling",
      "exceptionsDescription": "Specify users who are exceptions to the above feature.",
      "tagsTitle": "Tags",
      "tagsDescription": "Apply these rules only to files with specific tags",
      "tagsRequired": "At least one tag is required when there are multiple rules",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags"
    },
    "forcedFileInvisibility": {
      "title": "Forced file invisibility",
      "description": "This feature allows administrators to make specific file types invisible to recipients while still completing the sharing action. For example, Office documents used as master editable files can be shared but remain hidden to the recipient, reducing the risk of exposing editable source files while still allowing sharing of approved formats like PDFs.",
      "descriptionInternal": "This feature allows administrators to make specific file types invisible to recipients while still completing the sharing action. For example, Office documents used as master editable files can be shared but remain hidden to the recipient, reducing the risk of exposing editable source files while still allowing sharing of approved formats like PDFs.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator. This setting can define the scope of permissions, the conditions under which they apply, and any exceptions allowed. It ensures that user activity remains aligned with organizational policies while still allowing flexibility where appropriate.",
      "exceptionsTitle": "Exception Handling",
      "exceptionsDescription": "Specify users who are exceptions to the above feature.",
      "fileTypesTitle": "Invisible After Sharing",
      "fileTypesDescription": "Makes certain file types (e.g., Office documents) invisible to recipients while still completing the sharing process.",
      "fileTypesPlaceholder": "Enter file types or extensions (e.g., .docx, .xls, .pptx)",
      "tagsTitle": "Tags",
      "tagsDescription": "Apply these rules only to files with specific tags",
      "tagsRequired": "At least one tag is required when there are multiple rules",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags"
    },
    "shortcutLink": {
      "title": "Shortcut link restriction",
      "description": "Restrict the creation of shortcut links for files that contain designated tags.",
      "descriptionInternal": "Restrict the creation of shortcut links for files that contain designated tags.",
      "activeForAllTitle": "User Scope",
      "activeForAllDescription": "Control whether users are subject to restrictions set by the administrator.",
      "exceptionsTitle": "Exception Handling",
      "exceptionsDescription": "Specify users who are exceptions to the above feature.",
      "tagsTitle": "Tags",
      "tagsDescription": "Apply these rules only to files with specific tags",
      "tagsRequired": "At least one tag is required when there are multiple rules",
      "exceptionsRequiredForTags": "Exceptions are required for setting tags"
    },
    "adminSettingsPermissions": {
      "title": "Admin settings permissions",
      "description": "Restricts Admin access to platform settings",
      "deniedSettingsUserTitle": "Administrator Scope",
      "deniedSettingsUserDescription": "Select the administrator that will be denied access to the settings.",
      "deniedSettingsTitle": "Denied Settings",
      "deniedSettingsDescription": "Specify the settings that administrators are not allowed to access.",
      "selectUserFirst": "Select a user first"
    },
    "sharePointIntegration": {
      "title": "SharePoint integration",
      "description": "Encrypt the files of a chosen SharePoint perimeter, in place.",
      "steps": {
        "connection": "Connection",
        "key": "Encryption key",
        "perimeter": "Perimeter"
      },
      "connectionDescription": "App-only credentials of your Entra ID app registration.",
      "tenantIdLabel": "Tenant ID",
      "clientIdLabel": "Client ID",
      "spaClientIdLabel": "SPA client ID (viewer/editor)",
      "spaClientIdHint": "Second app registration, of type SPA (public): the browser signs into it to read and edit the encrypted files. Without it nobody can open a file from the web app. Never put the app-only registration here — that one has a secret.",
      "guidHint": "Enter a valid GUID.",
      "clientSecretLabel": "Client secret",
      "clientSecretPlaceholder": "Paste the client secret",
      "clientSecretHint": "Write-only: once saved it can only be replaced.",
      "clientSecretStored": "A client secret is stored",
      "replaceSecret": "Replace",
      "editConnection": "Edit",
      "hideConnection": "Close",
      "testAction": "Verify",
      "testOk": "Connection verified",
      "testKo": "Connection refused",
      "saveCredentialsFirst": "Save the credentials first.",
      "lastVerifyOk": "Verified",
      "lastVerifyKo": "Check failed",
      "lastVerifiedAt": "Last check: {{date}}",
      "perimeterDescription": "The sites and folders the scan inspects.",
      "perimeter": {
        "sitesTitle": "Sites",
        "searchSites": "Search sites",
        "reloadSites": "Reload the sites list",
        "foldersTitle": "{{siteName}}",
        "foldersTitleEmpty": "Folders",
        "pickSiteFirst": "Pick a site on the left.",
        "noLibraries": "No document library is visible here.",
        "wholeSiteTag": "Whole site",
        "selectedTitle": "In scope:",
        "scopeNone": "none",
        "folderCount": "{{count}} folder(s)",
        "librariesCrumb": "Document libraries",
        "noSubfolders": "No subfolder.",
        "levelTruncatedTitle": "Too many folders to list here",
        "levelTruncatedBody": "Above the 2000-folder ceiling some folders never appear on any page. Add them by path below.",
        "manualPathLabel": "Add a folder by path",
        "manualPathPlaceholder": "Add a folder by path, e.g. Contracts/2026",
        "manualPathInvalid": "Path relative to the library root, without \".\" or \"..\" segments (max 400 characters).",
        "browse": "Browse",
        "openFolder": "Open {{name}}",
        "scopeLabel": "Watch in this site",
        "scopeOff": "Nothing",
        "scopeWhole": "The whole site",
        "scopeFolders": "Only the folders below",
        "selectedFoldersTitle": "Watched folders",
        "librariesNotSelectable": "Open a library. A folder you pick applies to every library of this site.",
        "addFolder": "Add {{name}} to the watched folders",
        "folderAdded": "Added",
        "folderAlreadyAdded": "This folder is already watched",
        "noFoldersSelected": "None yet.",
        "parentFolderWatched": "The parent folder \"{{folder}}\" is already watched, so its subfolders are already in scope.",
        "emptyWarning": "No site selected: nothing will be scanned or encrypted.",
        "siteCount": "{{count}} site(s)"
      },
      "certificateDescription": "The RemoteGrant certificate the files are encrypted to.",
      "encryption": {
        "thumbprintLabel": "Fingerprint",
        "unnamedCertificate": "Certificate #{{id}}",
        "reloadAction": "Reload certificates",
        "selectPlaceholder": "Pick a certificate",
        "optionLabel": "{{name}} — created on {{date}}",
        "rotationTitle": "Changing the certificate does not re-encrypt anything",
        "rotationBody": "Files already encrypted stay tied to the previous certificate: keep it in RemoteGrant or they become unreadable.",
        "dryRunBlockedReason": "Pick an encryption certificate to turn discovery mode off.",
        "errors": {
          "listFailed": "The certificate list could not be loaded.",
          "certificateNotFound": "The selected certificate is no longer in your RemoteGrant list. Reload the list and pick one again.",
          "remoteGrantNotConfigured": "RemoteGrant is not configured for your company. Its keys are set by CyberGrant: contact support.",
          "remoteGrantUnavailable": "RemoteGrant is temporarily unreachable. Try again in a moment.",
          "remoteGrantDenied": "RemoteGrant refused your company's credentials. Contact support."
        },
        "empty": "RemoteGrant returned no certificate for your company."
      },
      "fileExtensionsTitle": "File type filter",
      "fileExtensionsDescription": "Only files with these extensions are in scope. Leave the list empty to include every file type.",
      "addFileExtension": "Add an extension",
      "invalidFileExtension": "Enter a single extension, for example .docx",
      "allFileTypesWarning": "No filter set: every file type in the perimeter is in scope.",
      "dryRunTitle": "Discovery mode",
      "dryRunDescription": "Inspect the perimeter without encrypting anything. Safe default.",
      "dryRunOnTag": "Discovery",
      "dryRunOffTag": "Encrypting",
      "confirmEncryption": {
        "confirmAction": "Encrypt",
        "irreversible": "They are rewritten in place and cannot be decrypted from here.",
        "title": "Encrypt the files in this selection?"
      },
      "errors": {
        "notAvailableTitle": "Not included in your licence",
        "notAvailable": "The SharePoint integration is not included in your licence. Contact support to enable it.",
        "notConfigured": "No credentials are stored yet. Enter and save the connection parameters first.",
        "configInvalid": "The stored configuration was refused. Fix the problems listed below and save again.",
        "testFailed": "The connection could not be verified.",
        "sitesFailed": "The sites of the tenant could not be loaded.",
        "foldersFailed": "This folder level could not be loaded.",
        "siteNotFound": "This site is no longer available with these credentials. Reload the sites list and pick it again.",
        "graphUnauthorizedShort": "Microsoft Graph refused the credentials.",
        "graphUnavailable": "Microsoft Graph is temporarily unreachable. Try again in a moment.",
        "notAllowed": "You are not allowed to manage this setting. Ask a SuperAdmin to grant you access to the SharePoint integration.",
        "invalidParams": "The request was refused because of an invalid parameter.",
        "remedyPermissions": "The app registration needs the application permissions Sites.Read.All and Files.ReadWrite.All with admin consent.",
        "remedySecret": "The client secret may be wrong or expired — enter a new one above."
      }
    },
    "activeDirectoryLdap": {
      "title": "Active Directory (LDAP)",
      "description": "Connect Filegrant to your on-premises Active Directory for user and group sync.",
      "connectionTitle": "Connection",
      "connectionDescription": "Domain controller, service account and search root.",
      "hostLabel": "Host",
      "portLabel": "Port",
      "securityLabel": "Security",
      "securityNone": "None (cleartext)",
      "allowInsecureLabel": "I understand the password travels in clear — allow insecure LDAP",
      "allowInsecureWarning": "With security set to none, the service-account password travels in clear over the network.",
      "bindDnLabel": "Bind DN",
      "bindPasswordLabel": "Bind password",
      "bindPasswordStored": "A bind password is stored",
      "bindPasswordRequired": "Enter the bind password before saving.",
      "replacePassword": "Replace",
      "baseDnLabel": "Base DN",
      "loginAliasLabel": "Login alias attribute",
      "loginAliasNone": "None",
      "suggestRetypePassword": "Host or bind DN changed — consider re-typing the bind password.",
      "passwordRequiredOnTargetChange": "Re-enter the password: the connection target changed.",
      "filterHelp": "Optional extra condition that narrows the default search (AND), e.g. (department=Sales).",
      "neverVerifiedInvite": "Connection never verified — press Test connection.",
      "testAction": "Test connection",
      "testOk": "Connection verified",
      "saveCredentialsFirst": "Save the configuration first, with no unsaved changes.",
      "lastVerifiedAt": "Last verified: {{date}}",
      "neverVerified": "Never verified",
      "caTitle": "CA certificate",
      "caDescription": "PEM of the internal CA that signed the domain controller certificate. Leave empty to use the system trust store.",
      "uploadCa": "Upload .cer / .pem",
      "removeCa": "Remove CA",
      "caThumbprint": "Thumbprint",
      "caExpiresAt": "CA expires on {{date}}",
      "caExpiringSoon": "CA expires soon ({{date}})",
      "caExpired": "CA expired on {{date}}",
      "advancedTitle": "Advanced",
      "advancedDescription": "Optional search bases and LDAP filters.",
      "advancedToggle": "Search bases and filters",
      "userSearchBaseLabel": "User search base",
      "groupSearchBaseLabel": "Group search base",
      "userFilterLabel": "User filter",
      "groupFilterLabel": "Group filter",
      "errors": {
        "notAvailableTitle": "Not available"
      }
    },
    "outboundEmail": {
      "title": "Custom e-mail sender",
      "description": "Send platform notifications from your own domain via SMTP or Mailgun.",
      "statusTitle": "Sender status",
      "statusDescription": "Whether notifications currently leave from your custom domain.",
      "refreshStatus": "Refresh status",
      "badgeActive": "Active: notifications leave from {{domain}}",
      "badgeInactive": "Not active: notifications still use the platform sender",
      "reasonDisabled": "Custom sender is disabled.",
      "reasonNotVerified": "Domain ownership is not verified yet.",
      "reasonMailgunNotActive": "Mailgun domain is not active yet.",
      "reasonNotActive": "Custom sender is not in use.",
      "formTitle": "Configuration",
      "formDescription": "Domain, From identity and delivery mode.",
      "enabledLabel": "Enable custom sender",
      "modeLabel": "Delivery mode",
      "modeSmtp": "SMTP (own server)",
      "modeMailgun": "Mailgun (platform account)",
      "mailgunUnavailable": "Mailgun mode is not available on this platform.",
      "domainLabel": "Domain",
      "fromAddressLabel": "From address",
      "fromNameLabel": "From name",
      "sendFromUserLabel": "Send from user",
      "sendFromUserOn": "Use the acting user's e-mail as From",
      "sendFromUserOff": "Use the company From address / custom domain",
      "smtpHostLabel": "SMTP host",
      "smtpPortLabel": "SMTP port",
      "smtpUsernameLabel": "SMTP username",
      "smtpPasswordLabel": "SMTP password",
      "smtpPasswordStored": "An SMTP password is stored",
      "smtpPasswordRequired": "Enter the SMTP password before saving.",
      "replacePassword": "Replace",
      "smtpSecurityLabel": "SMTP security",
      "suggestRetypePassword": "Host or username changed — re-enter the SMTP password.",
      "domainChangeTitle": "Change domain?",
      "domainChangeWarning": "Changing the domain restarts verification. The custom sender will stop being used until the new domain is verified.",
      "dnsTitle": "DNS & verification",
      "dnsDescription": "Publish the ownership TXT record, then verify. In Mailgun mode, publish the Mailgun records too.",
      "verifyNow": "Verify now",
      "verifyOk": "Domain ownership verified",
      "verifyPending": "Ownership TXT not found yet",
      "verifyMailgun": "Verify Mailgun records",
      "verifyMailgunOk": "Mailgun records verified: the domain is active",
      "verifyMailgunPending": "Mailgun has not verified every record yet",
      "autoCheckHint": "Checked automatically every minute until the domain is verified.",
      "autoCheckVerified": "Domain verified: the custom sender can now be used.",
      "saveBeforeVerify": "Save a domain first, then verify.",
      "ownershipName": "Name",
      "ownershipValue": "Value",
      "recordType": "Type",
      "recordValid": "Valid",
      "recordInvalid": "Not valid",
      "verifiedAt": "Verified: {{date}}",
      "lastCheckedAt": "Last check: {{date}}",
      "dnsEmpty": "Save a domain to receive the ownership TXT record.",
      "mailgunRecordsTitle": "Mailgun DNS records",
      "testTitle": "Test e-mail",
      "testDescription": "Queues a test message to your own SuperAdmin address through the custom sender.",
      "testDescriptionPlatform": "Queues a test message to your own SuperAdmin address. The custom sender is not in use yet, so the current sender is used.",
      "sendTest": "Send test e-mail",
      "testQueued": "Queued to {{recipient}}",
      "testQueuedPlatform": "Queued to {{recipient}} through the current sender (custom sender not in use)",
      "errors": {
        "notAvailableTitle": "Not available"
      }
    }
  },
  "auth": {
    "loginPageTitle": "Welcome to Filegrant Enterprise",
    "loginPageSubtitle": "Please enter your email address to securely access the document.",
    "resendOtpCode": "Resend OTP code",
    "loginTermsAndConditions": "I agree to Cyber Grant Inc.'s [**Terms of Service**](https://www.cybergrant.net/terms-of-service)",
    "loginPageEmailLabel": "Email/Username",
    "loginPageEmailPlaceholder": "Enter your email/username...",
    "loginPageOtpLabel": "We sent a code to your registered email. Enter the 6-digit code here. If you haven't received it, click 'Request a new code'",
    "loginButtonLabel": "Login",
    "loginPageResendOtp": "Request a new code",
    "orContinueWith": "Or continue with",
    "loginPageTooManyAttempts": "Too many attempts, try again in",
    "totpStepTitle": "Two-factor authentication",
    "enterTotpCode": "Enter the 6-digit code from your authenticator app",
    "configure2FA": "I need to set up 2FA",
    "useBackupCode": "Use a backup code",
    "useOtpCode": "Use OTP code",
    "enterBackupCode": "Enter your backup code",
    "backupCodePlaceholder": "Enter your backup code",
    "totpTimeRemaining": "Time remaining to complete authentication: {{time}}",
    "twoFactorChooseMethod": "Choose how to verify",
    "usePasskey": "Use passkey",
    "useTotp": "Use authenticator app",
    "passkeyWaiting": "Waiting for your passkey…",
    "orDivider": "or",
    "signInWithPasskey": "Sign in with passkey",
    "passkeyCancelled": "Passkey sign-in was cancelled.",
    "passkeyNotSupported": "Your browser does not support passkeys.",
    "passwordlessNotEnabled": "Passkey sign-in is not enabled for your organization.",
    "totpForcedSetupIntro": "Your organization requires two-factor authentication. Set it up now to finish signing in as {{email}}.",
    "totpForcedSetupTitle": "Set up two-factor authentication",
    "totpForcedSetupDescription": "Scan the QR code with your authenticator app, then enter the 6-digit code to finish signing in."
  },
  "secret": {
    "createTitle": "Create secret file",
    "createSecret": "Password or secret",
    "newSecret": "New secret",
    "fileName": "File name",
    "fileNameRequired": "File name is required",
    "protectWithPassword": "Protect with password",
    "protectWithSecretKey": "Protect with secret key",
    "secretKeyWarning": "If you lose this key, the information will no longer be accessible",
    "changeSecretKey": "Change secret key",
    "currentSecretKey": "Current secret key",
    "wrongCurrentKey": "The current secret key is incorrect",
    "hint": "Hint",
    "hintPlaceholder": "Optional hint to remember the key",
    "newSecretKey": "New secret key",
    "confirmSecretKey": "Confirm secret key",
    "secretKeyMismatch": "Secret keys do not match",
    "enterPassword": "Enter password",
    "confirmPassword": "Confirm password",
    "passwordRequired": "Password is required",
    "passwordMinLength": "Password must be at least 4 characters",
    "confirmPasswordRequired": "Confirm password",
    "passwordMismatch": "Passwords do not match",
    "wrongPassword": "Wrong password",
    "addField": "Add field",
    "addFieldForGroup": "Add field for group",
    "addWebsite": "Add website",
    "addGroup": "Add group",
    "newGroup": "New group",
    "renameGroup": "Rename group",
    "deleteGroup": "Delete group",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "dragToReorderField": "Drag to reorder {{label}}",
    "dragToReorderGroup": "Drag to reorder group {{label}}",
    "removeField": "Remove field",
    "editLabel": "Edit label",
    "fieldType": "Type",
    "fieldLabel": "New Field",
    "fieldValue": "Value",
    "fields": {
      "heading": "Fields",
      "username": "Username",
      "password": "Password",
      "website": "Website",
      "cardholder": "Cardholder",
      "number": "Card number",
      "brand": "Brand",
      "exp_month": "Expiry month",
      "exp_year": "Expiry year",
      "cvv": "CVV",
      "title": "Title",
      "first_name": "First name",
      "last_name": "Last name",
      "fiscal_code": "Fiscal code",
      "passport": "Passport",
      "driving_license": "Driving license",
      "email": "Email",
      "phone": "Phone",
      "address1": "Address line 1",
      "address2": "Address line 2",
      "address3": "Address line 3",
      "city": "City",
      "state": "State / Province",
      "zip": "ZIP / Postal code",
      "country": "Country",
      "private_key": "Private key",
      "public_key": "Public key",
      "fingerprint": "Fingerprint",
      "notes": "Notes"
    },
    "searchFields": "Search fields",
    "noFieldsYet": "No fields yet",
    "untitled": "Untitled",
    "presets": {
      "credentials": "Login credentials",
      "card": "Payment card",
      "identity": "Identity",
      "ssh_key": "SSH key",
      "custom": "Custom secret"
    },
    "groups": {
      "credentials_main": "Login credentials",
      "credentials_autofill": "Autofill options",
      "card_main": "Card",
      "identity_personal": "Personal",
      "identity_ids": "IDs",
      "identity_contact": "Contact",
      "identity_address": "Address",
      "ssh_main": "SSH key",
      "custom_fields": "Custom fields",
      "additional_options": "Additional options"
    },
    "card": {
      "brands": {
        "visa": "Visa",
        "mastercard": "Mastercard",
        "amex": "American Express",
        "other": "Other"
      }
    },
    "identity": {
      "titles": {
        "mr": "Mr",
        "ms": "Ms",
        "mx": "Mx",
        "dr": "Dr",
        "prof": "Prof",
        "other": "Other"
      }
    },
    "ssh": {
      "upload": "Upload key file",
      "uploadError": "Could not read key file"
    },
    "types": {
      "text": "Text",
      "password": "Password",
      "url": "URL",
      "username": "Username",
      "email": "Email",
      "phone": "Phone",
      "textarea": "Text area",
      "number": "Number",
      "month": "Month",
      "year": "Year"
    },
    "validation": {
      "email": "This doesn't look like a valid email",
      "url": "This doesn't look like a valid URL",
      "phone": "This doesn't look like a valid phone number",
      "number": "This doesn't look like a valid number"
    },
    "password": {
      "show": "Show",
      "hide": "Hide",
      "generate": "Generate password",
      "copy": "Copy",
      "copied": "Copied!",
      "length": "Length",
      "includeSymbols": "Include special characters",
      "strength": {
        "veryWeak": "Very weak",
        "weak": "Weak",
        "fair": "Fair",
        "strong": "Strong",
        "veryStrong": "Very strong"
      }
    },
    "edit": "Edit",
    "save": "Save",
    "saved": "Saved successfully",
    "cancel": "Cancel",
    "protectedFile": "Protected file",
    "enterPasswordToView": "Enter password to view the content",
    "unlock": "Unlock",
    "noData": "No data available",
    "loadError": "Error loading file",
    "saveError": "Error saving file"
  },
  "publicShare": {
    "createLink": "Public Link",
    "revokeLink": "Revoke public link",
    "revokeLinkConfirmDescription": "Revoke the public link for {{fileName}}?",
    "badgeSection": "Public link",
    "badgeActive": "Public link active",
    "revoked": "Public link revoked successfully",
    "createModal": {
      "title": "Create Public Link",
      "fileLabel": "File",
      "allowDownload": "Allow download",
      "expirationLabel": "Expiration (optional)",
      "expirationPlaceholder": "Never",
      "maxAccessCountLabel": "Max access count (optional)",
      "maxAccessCountPlaceholder": "Unlimited",
      "protectWithPassword": "Protect with password",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Enter password",
      "passwordRequired": "Password is required when protection is enabled",
      "createLink": "Create Link"
    },
    "successModal": {
      "title": "Link created!",
      "message": "The public link has been created.",
      "copyLink": "Copy link",
      "warning": "Anyone with this link can access the file.",
      "expiresAt": "Expires",
      "remainingAccesses": "Remaining accesses",
      "password": "Password"
    },
    "errors": {
      "linkAlreadyExists": "A public link already exists for this file. Revoke it first to create a new one.",
      "linkNotFound": "No active link found for this file.",
      "featureDisabled": "Public links are disabled for your organization.",
      "notOwner": "You must be the owner to create or revoke public links."
    },
    "passwordTitle": "Protected content",
    "passwordMessage": "This file is protected by a password. Enter the password to access it.",
    "passwordRequired": "Password is required.",
    "errorInvalidPassword": "The password you entered is incorrect. Please try again.",
    "passwordSubmit": "Access",
    "errorExpiredTitle": "Link expired",
    "errorExpiredMessage": "This sharing link is no longer valid. The expiration date has passed. Contact the person who sent you the link to request a new one.",
    "errorMaxAccessTitle": "Access limit reached",
    "errorMaxAccessMessage": "This link has reached the maximum number of allowed accesses. Contact the person who sent you the link to request a new one.",
    "errorNotFoundTitle": "Invalid link",
    "errorNotFoundMessage": "The link you are trying to open does not exist or has been revoked by the owner. Please check that you copied the URL correctly.",
    "folderContents": "Folder contents",
    "items": "items",
    "fileSize": "Size",
    "fileType": "Type",
    "sharedAt": "Shared on",
    "list": {
      "title": "My public links",
      "description": "Manage your public share links. Revoke a link to disable it.",
      "fileName": "Name",
      "type": "Type",
      "status": "Status",
      "statusActive": "Active",
      "statusExpired": "Expired",
      "statusExhausted": "Limit reached",
      "expiresAt": "Expires",
      "accessCount": "Accesses",
      "hasPassword": "Password",
      "empty": "No public links yet."
    }
  },
  "common": {
    "buttons": "Buttons",
    "change": "Change",
    "setting": "Setting",
    "background": "Background",
    "foreground": "Foreground",
    "edit": "Edit",
    "remove": "Remove",
    "settings": "Settings",
    "integrations": "Integrations",
    "customizations": "Customizations",
    "enable": "Enable",
    "logout": "Logout",
    "features": "Features",
    "day_one": "{{count}} day",
    "day_other": "{{count}} days",
    "files": "Files",
    "received": "Received",
    "rename": "Rename",
    "cancel": "Cancel",
    "cancelUpload": "Cancel upload",
    "canceled": "Canceled",
    "close": "Close",
    "open": "Open",
    "createFolder": "Create folder",
    "openFolder": "Open folder",
    "uploadFolder": "Upload folder",
    "uploadFile": "Upload file",
    "downloadEncrypted": "Download encrypted",
    "createdBy": "Created by",
    "login": "Login",
    "otpCode": "OTP code",
    "passkeys": "Passkeys",
    "email": "Email",
    "username": "Username",
    "emails": "Emails",
    "emailLabel": "Email Label",
    "emailPlaceholder": "Email Placeholder",
    "labels": "Labels",
    "inputs": "Inputs",
    "loginLabel": "Login Label",
    "resendOtpLabel": "Resend OTP Label",
    "otpCodeLabel": "OTP Code Label",
    "allUsers": "All users",
    "allGroups": "All groups",
    "globalSearchPlaceholder": "Search for files and folders",
    "folderPickerSearchInFolder": "Search in this folder",
    "globalSearchDescription": "Start typing to search for files and folders",
    "filterExactMatch": "Exact match (whole word)",
    "filterWholeWord": "Like search (wildcard)",
    "loading": "Loading...",
    "loadingDescription": "Please wait while we load your data",
    "thinking": "Thinking...",
    "thinkingDescription": "AI is processing your request",
    "noResults": "No results found",
    "noFilesFound": "No files found",
    "hidden": "Hidden",
    "hide": "Hide",
    "lock": "Lock",
    "file": "File",
    "fileSize": "File size",
    "tags": "Tags",
    "tag": "Tag",
    "title": "Title",
    "users": "Users",
    "user": "User",
    "systemUser": "System",
    "groups": "Groups",
    "overview": "Overview",
    "mode": "Mode",
    "opacity": "Opacity",
    "includeUserEmail": "Include user email",
    "appliesToExternalUsers": "Applies to external users",
    "blurOnFocusLoss": "Blur on focus loss",
    "maxExpirationDays": "Max expiration (days)",
    "noRecipients": "No recipients",
    "createdAt": "Created at",
    "group": "Group",
    "reviewTeam": "Review Team",
    "folder": "Folder",
    "publicLink": "Public Link",
    "publicLinkTitle": "Filegrant Public Link",
    "logs": "Logs",
    "addUsersOrGroups": "Add users or groups",
    "addUsers": "Add users",
    "userTagInputEmptyPlaceholder": "Start typing to search for users or groups",
    "member": "Member",
    "member_zero": "No members",
    "member_other": "Members",
    "uploaded": "Uploaded",
    "failed": "Failed",
    "retries": "Retries",
    "preparingFilesForUpload": "Preparing files for upload",
    "uploadingFilesCounter": "Uploading files {{amount}} of {{total}}",
    "uploadedFilesCounter": "Uploaded {{amount}} of {{total}}",
    "copyLink": "Copy link",
    "unhide": "Unhide",
    "licenseLimitation": "License Limitation",
    "deletionDate": "Deletion date",
    "creationDate": "Creation date",
    "newUser": "New user",
    "newGroup": "New group",
    "noActionsAvailable": "No actions available",
    "author": "Author",
    "openProtectedFile": "Open protected file",
    "showFilesSharedWith": "Show files shared with",
    "showFilesSharedBy": "Show files shared by",
    "upload": "Upload",
    "youCanRequestANewOtpIn": "You can request a new OTP in",
    "otpExpired": "OTP expired",
    "otpValidFiveMinutesOnce": "This code is valid for 5 minutes and works once.",
    "generateNewOtp": "Generate new OTP",
    "clickHereToGenerateNewOtp": "Click here to generate a new OTP",
    "preparingFileForDownload": "Preparing file for download",
    "preparingForDownload": "Preparing for download",
    "uploadErrors": "Upload errors",
    "uploadErrorsDescription": "Some files could not be uploaded",
    "size": "Size",
    "status": "Status",
    "percentage": "Percentage",
    "viewer": "Viewer",
    "editor": "Editor",
    "shareWith": "Share with",
    "retry": "Retry",
    "regenerate": "Regenerate",
    "permissions": "Permissions",
    "expiration": "Expiration",
    "message": "Message",
    "uploadingFiles": "Uploading files",
    "addFiles": "Add files",
    "addFolders": "Add folders",
    "max": "Max",
    "preview": "Preview",
    "write": "Write",
    "quickShare": "Quick Share",
    "maxFilesAmountAndSizeEach": "Max {{amount}} files, {{size}}MB each",
    "startUploadAndShare": "Start upload and share",
    "processing": "Processing",
    "startNewUploadAndShare": "Start new upload and share",
    "continue": "Continue",
    "goToFileManager": "Go to File Manager",
    "goToQuickShare": "Go to Quick Share",
    "viewAll": "View all",
    "emptyUsersList": "Here you can find the users you added",
    "emptyGroupsList": "Here you can find the groups you added",
    "confirmationMessage": "Confirmation message",
    "lastModified": "Last modified",
    "opened": "Opened",
    "lastAccess": "Last access",
    "accessExpiration": "Access expiration",
    "description": "Description",
    "descriptionNotEditable": "Description is not editable",
    "sharedItems": "Shared items",
    "sharedItemsCount": "Shared {{count}} item",
    "sharedItemsCount_other": "Shared {{count}} items",
    "itemsSharedWith": "Items shared with <strong>{{resource}}</strong>",
    "manageItems": "Manage items",
    "items": "Items",
    "visibleToAdminsOnly": "Visible to admins only",
    "loginAlias": "Login alias / Employee number",
    "loginAliasManagedBy": "Managed by {{source}}",
    "loginAliasManagedWarning": "Editing this alias stops automatic directory updates.",
    "loginAliasSourceEntraId": "Entra ID",
    "loginAliasSourceActiveDirectory": "Active Directory",
    "employeeId": "Employee ID",
    "searchUsersIncludingAlias": "Search users (name, email, or alias)...",
    "pleaseEnterName": "Please enter a name",
    "pleaseEnterFirstName": "Please enter a first name",
    "pleaseEnterLastName": "Please enter a last name",
    "pleaseEnterEmail": "Please enter an email",
    "invalidEmail": "The input is not a valid email",
    "nameCannotBeEmail": "Name cannot be an email",
    "publicLinkSearchHint": "Search filters this folder after all pages finish loading",
    "companyTag": "Company tag",
    "replace": "Replace",
    "fileName": "File name",
    "enterFileName": "Enter file name",
    "new": "New",
    "organize": "Organize",
    "downloadFile": "Download file",
    "expiry": "Expiry",
    "downloadPdf": "Download PDF",
    "downloadEncryptedFile": "Download encrypted file",
    "save": "Save",
    "createShortcut": "Create shortcut",
    "create": "Create",
    "createShortcutFor": "Create shortcut for {{resource}}",
    "selectFolderToCreateFileShortcut": "Select a position to show the folder path where the file will be created",
    "editUser": "Edit user",
    "unblockUser": "Unblock user",
    "blockUser": "Block user",
    "deleteUser": "Delete user",
    "excludeFromSso": "Exclude from SSO",
    "includeInSso": "Re-enable SSO",
    "confirm": "Confirm",
    "search": "Search",
    "noUsersFound": "No users found",
    "noSettingsFound": "No settings found",
    "block": "Block",
    "unblock": "Unblock",
    "role": "Role",
    "addedOn": "Added on",
    "memberOfNGroups": "Member of N° groups",
    "noExpirationDate": "No expiration date",
    "groupsMember": "Groups member",
    "onBehalfOf": "On behalf of",
    "exitFromBehalfOfMode": "Exit from behalf mode",
    "expiryDate": "Expiry date",
    "select": "Select",
    "nothingHasBeenSharedYet": "Nothing has been shared yet",
    "manageGroups": "Manage groups",
    "noGroupsYet": "No groups yet",
    "addExpirationDate": "Add expiration date",
    "editExpirationDate": "Edit expiration date",
    "edited": "Edited",
    "removed": "Removed",
    "removeExpirationDate": "Remove expiration date",
    "usersWithSharedFiles": "Users with shared files",
    "usersWithoutSharedFiles": "Users without shared files",
    "changeRole": "Change role",
    "yes": "Yes",
    "no": "No",
    "selected": "Selected",
    "editGroup": "Edit group",
    "viewGroup": "View group",
    "numberOfMembers": "N° of members",
    "numberOfMembersInline": "{{count}} member",
    "numberOfMembersInline_one": "{{count}} member",
    "numberOfMembersInline_other": "{{count}} members",
    "groupMembers": "Group members",
    "editGroups": "Edit groups",
    "noUsers": "No users",
    "deleteGroup": "Delete group",
    "documents": "Documents",
    "images": "Images",
    "audio": "Audio",
    "video": "Video",
    "other": "Other",
    "fileExtensionType": {
      "Text": "Text",
      "SourceCode": "Source Code",
      "Markup": "Markup",
      "Data": "Data",
      "Image": "Image",
      "Video": "Video",
      "Audio": "Audio",
      "Document": "Document",
      "Spreadsheet": "Spreadsheet",
      "Presentation": "Presentation",
      "Archive": "Archive",
      "Database": "Database",
      "Font": "Font",
      "System": "System",
      "Executable": "Executable",
      "Configuration": "Configuration",
      "Log": "Log",
      "Backup": "Backup",
      "Certificate": "Certificate",
      "Model3D": "3D Model",
      "CAD": "CAD",
      "GIS": "GIS",
      "Scientific": "Scientific",
      "EBook": "E-Book",
      "Vector": "Vector",
      "Raw": "Raw"
    },
    "fileTypes": "File types",
    "download": "Download",
    "share": "Share",
    "createCopy": "Create copy",
    "markAsRead": "Mark as read",
    "markAsUnread": "Mark as unread",
    "move": "Move",
    "convertToPdf": "Convert to PDF",
    "convert": "Convert",
    "wordDocument": "Word Document",
    "excelDocument": "Excel Document",
    "pptDocument": "PowerPoint Document",
    "hideFromList": "Hide from list",
    "showInList": "Show in list",
    "editAccessAndProtections": "Edit access & protections",
    "tagColor": "Tag color",
    "tagName": "Tag name",
    "addToFavorites": "Add to favorites",
    "removeFromFavorites": "Remove from favorites",
    "deletePermanently": "Delete permanently",
    "delete": "Delete",
    "selectedItems": "Selected items",
    "deselectAll": "Deselect all",
    "signOut": "Sign out",
    "tagTitle": "Tag Title",
    "noTagsYet": "No tags yet",
    "untitledDocument": "Untitled Document",
    "copyOf": "Copy of",
    "restoreFromTrash": "Restore from trash",
    "shared": "Shared",
    "expiresOn": "Expires on {{date}}",
    "shareExpiredOn": "Share expired on {{date}}",
    "favourite": "Favourite",
    "favouriteAddedTo": "added to",
    "favouriteRemovedFrom": "removed from",
    "publicLinkLabel": "Public link",
    "classificationInProgress": "Classification in progress",
    "forSale": "For Sale",
    "favorites": "Favorites",
    "recent": "Recent",
    "transferOwnership": "Transfer ownership",
    "trash": "Trash",
    "expirationDate": "Expiration date",
    "details": "Details",
    "unlock": "Unlock",
    "activities": "Activities",
    "copyToClipboard": "Copy to clipboard",
    "fileType": "File type",
    "noTagsApplied": "No tags have been applied to this file",
    "notSharedYet": "Not shared yet",
    "manageAccess": "Manage access",
    "selectItemToViewDetails": "Select an item to view its details",
    "unlockFolderToViewDetails": "Unlock the folder to view details",
    "unlockFolderToViewSize": "Unlock the folder to view the size",
    "folderContent": "Folder content",
    "calculateFolderSize": "Calculate size",
    "recalculate": "Recalculate",
    "recalculateCooldown": "Please wait a moment before recalculating",
    "subfolders": "Subfolders",
    "totalSize": "Total size",
    "filters": "Filters",
    "owner": "Owner",
    "linkCopied": "Link copied to clipboard!",
    "account": "Account",
    "customization": "Customization",
    "adminRegisteredUserVisibility": "Admin-Registered User Visibility",
    "adminRegisteredUserVisibilityDescription": "Make admin-registered users visible unless deactivated; visibility through file sharing only.",
    "autoFileDeletion": "Auto File Deletion",
    "autoFileDeletionDescription": "Automatically delete files after a specified creation date and retention period.",
    "cannotOpenFileOnBehalf": "You cannot open files On Behalf Of Mode.",
    "certifiedTimestamping": "Certified Timestamping",
    "certifiedTimestampingDescription": "Allow contributors to apply a certified date to files using a digital certificate.",
    "compressionCompleted": "Compression completed",
    "compressionFailed": "Compression failed",
    "compressionOfFilesInProgress": "Compression of files in progress",
    "verifyingFileIntegrity": "Verifying file integrity...",
    "fileIntegrityVerified": "File integrity verified",
    "downloadCompletedWithExclusions": "Download completed, but some files were excluded",
    "moveCompletedWithExclusions": "Move completed, but some files could not be moved",
    "filesExcludedForMove": "The following files could not be moved:",
    "excludedFilesTitle": "Excluded files",
    "viewExcludedFiles": "View excluded files",
    "filesExcludedForRestrictions": "Some files were excluded due to restrictions:",
    "contributorStorageLimit": "Contributor Storage Limit",
    "contributorStorageLimitDescription": "Set storage space limits for contributors to upload new files.",
    "contents": "Contents",
    "deviceAccessLimitation": "Device Access Limitation",
    "deviceAccessLimitationDescription": "Limit access to a number of devices and disconnect older ones.",
    "downloadPreparation": "Preparing download",
    "downloadReady": "Download ready",
    "editorFileManagement": "Editor File Management",
    "editorFileManagementDescription": "Allow contributors to delete and rename files as per permissions.",
    "fileSizeLimit": "File Size Limit",
    "fileSizeLimitDescription": "Restrict the maximum size of each file that can be uploaded.",
    "folderCreationPermission": "Folder Creation Permission",
    "folderCreationPermissionDescription": "Define whether contributors have permission to create new folders.",
    "groupCreationControl": "Group Creation Control",
    "groupCreationControlDescription": "Control which contributors are allowed to create groups.",
    "members": "Members",
    "msOfficeEditing": "Word, Excel, Powerpoint Editing",
    "msOfficeEditingDescription": "Allow members to edit documents directly with Microsoft Office online editor.",
    "newButton": "New",
    "security": "Security",
    "sessionControl": "Session Control",
    "sessionControlDescription": "Limit the number of concurrent sessions per user.",
    "sessions": "Sessions",
    "superAdmins": "Super Admins",
    "uploadWithTag": "Upload with Tag",
    "uploadWithTagDescription": "Capture and set automatically tag detected on source files.",
    "withExpiration": "With expiration",
    "withoutExpiration": "Without expiration",
    "addTag": "Add tag",
    "openFileLocation": "Open file location",
    "loadingTags": "Loading tags...",
    "unlimited": "Unlimited",
    "dropHereYourFirstFile": "Drop here your first file",
    "noFilesReceived": "No files received",
    "hereYouCanFindFavoritesFiles": "Here you can find your favorite files",
    "noRecentlyOpenedFiles": "No recently opened files",
    "hereYouCanFindSharedFiles": "Here you can find shared files",
    "hereYouCanFindDeletedFiles": "Here you can find deleted files",
    "noFiles": "No files",
    "loadingFiles": "Loading files...",
    "filesFetchFailed": "Could not load files. Check your connection and try again.",
    "shareDisabledNoRecipients": "Add at least one user or group to share",
    "shareDisabledNoChanges": "No changes to save",
    "editorDisabledByPolicy": "Editor permission is not allowed for these files",
    "editorDisabledCannotElevate": "You cannot elevate this share to Editor",
    "hereYouCanFindHiddenFiles": "Here you can find hidden files",
    "noFilesInThisFolder": "No files in this folder",
    "noGroupsFound": "No groups found",
    "sell": "Sell",
    "loadingPermissions": "Loading permissions...",
    "me": "Me",
    "applyTags": "Apply tags",
    "emptyTrash": "Empty trash",
    "classify": "AI Classification",
    "active": "Active",
    "activeDescription": "Enable or disable this setting",
    "add": "Add",
    "rule": "Rule",
    "selectTags": "Select tags",
    "manageExceptions": "Manage exceptions",
    "selectFolders": "Select folders",
    "selectUsers": "Select users",
    "selectGroups": "Select groups",
    "selectDate": "Select date",
    "none": "None",
    "addRule": "Add rule",
    "addConfiguration": "Add configuration",
    "aiAgents": "AI Agents",
    "daysLeft": "days left",
    "disabled": "Disabled",
    "enabled": "Enabled",
    "months": "Months",
    "years": "Years",
    "totpStatus": {
      "enabled": "2FA active",
      "enabledExempt": "2FA active (exempt)",
      "exempt": "Exempt from 2FA",
      "exemptExpires": "Exempt until {{date}}"
    },
    "clientId": "Client ID",
    "clientSecret": "Client Secret",
    "tenantId": "Tenant ID",
    "domains": "Domains",
    "addDomain": "Add domain",
    "addItem": "Add item",
    "artificialIntelligence": "Artificial Intelligence",
    "artificialIntelligenceSummary": "AI Summary",
    "artificialIntelligenceDocumentChat": "Chat with document",
    "generatingSummary": "Generating summary",
    "startNewConversation": "Start a new conversation",
    "groupMembership": "Group membership",
    "expired": "Expired",
    "onlyExpired": "Expiration",
    "expiredOnly": "Expired only",
    "expiringWithinDays": "Expiring within",
    "expiringWithinDaysOption": "{{count}} days",
    "expiringWithinDaysOption_one": "{{count}} day",
    "sharedBy": "Shared by",
    "shareRequests": "Share requests",
    "fileShareRequests": "File share requests",
    "noShareRequests": "No share requests",
    "activityLog": "Activity log",
    "targetType": "Target type",
    "operationType": "Operation type",
    "fromDate": "From date",
    "toDate": "To date",
    "classificationStatus": "IA Classification",
    "invite": "Invite",
    "send": "Send",
    "target": "Target",
    "operation": "Operation",
    "timestamp": "Timestamp",
    "export": "Export",
    "exportActivityLogsDescription": "Export the visible activity logs to a CSV file",
    "clickForDetailAiClassification": "Click for detail of AI classification",
    "aiClassificationStatus": "AI Classification Status",
    "noActivityLogsFound": "No activity logs found",
    "activityLogQuickFilters": {
      "clearDatesAndOperation": "Clear date and type filters",
      "downloads24h": "File downloads in the last 24 hours",
      "failedLogins7d": "Failed logins in the last 7 days",
      "last24hAllActivity": "All activity in the last 24 hours",
      "last24hLogins": "Logins in the last 24 hours",
      "last7DaysAllActivity": "All activity in the last 7 days",
      "sharing7d": "File sharing in the last 7 days",
      "title": "Quick filter presets"
    },
    "waitingForUpload": "Waiting for upload",
    "waitingForNetwork": "Waiting for network",
    "uploadsPausedWaitingForNetwork": "Uploads paused — waiting for network connection",
    "offline": "Offline",
    "noPermissions": "No permissions",
    "additionalData": "Additional data",
    "noActivities": "No activities",
    "multipleOwners": "Multiple owners",
    "mixed": "Mixed",
    "firstName": "First name",
    "lastName": "Last name",
    "multipleExpiryDates": "Multiple expiry dates",
    "copied": "Copied!",
    "copy": "Copy",
    "editFile": "Edit file",
    "untitled": "Untitled",
    "editModeEnabled": "Edit mode enabled",
    "exitEditMode": "Exit edit mode",
    "editModeDisabled": "Edit mode disabled",
    "reload": "Reload",
    "forward10Seconds": "Forward 10 seconds",
    "backward10Seconds": "Backward 10 seconds",
    "goToStart": "Go to start",
    "goToEnd": "Go to end",
    "playbackSpeed": "Playback speed",
    "error": "Error",
    "shareAgain": "Share again",
    "expiringSoon": "Expiring soon",
    "filterByTargetOrOperation": "Filter by target or operation",
    "searchByFileName": "Search by file name",
    "versions": "Versions",
    "version": "Version",
    "restore": "Restore",
    "showMoreVersions": "Show more versions",
    "showLessVersions": "Show less versions",
    "currentVersion": "Current version",
    "bold": "Bold",
    "italic": "Italic",
    "link": "Link",
    "unorderedList": "Unordered list",
    "orderedList": "Ordered list",
    "header1": "Header 1",
    "header2": "Header 2",
    "header3": "Header 3",
    "paragraph": "Paragraph",
    "secondsAgo": "seconds ago",
    "all": "All",
    "dataLossPrevention": "Data Loss Prevention",
    "uploadSuccess": "Upload successful",
    "uploading": "Uploading",
    "readOnly": "Read-Only",
    "aiScrapingProtectionOn": "AI Scraping Protection On",
    "openFileLocally": "Open file locally",
    "reloadPage": "Reload page",
    "reloadingPageIn": "Reloading the page in <strong>{{count}}</strong>",
    "keepOffline": "Sync on Device",
    "openFileOnline": "Open file online",
    "saveAndContinue": "Save and continue",
    "cancelAndContinue": "Cancel and continue",
    "language": "Language",
    "colorScheme": {
      "title": "Appearance",
      "light": "Light",
      "dark": "Dark",
      "system": "Follow system"
    },
    "accessibility": {
      "title": "Accessibility",
      "highContrast": "High contrast",
      "reduceMotion": "Reduce motion",
      "none": "Off",
      "activeCount": "{{count}} on"
    },
    "impersonateUser": "Impersonate User",
    "protect": "Protect",
    "setPassword": "Set password",
    "password": "Password",
    "stopImpersonation": "Stop Impersonation",
    "loggedInAs": "Logged in as",
    "enterReason": "Enter reason for impersonation...",
    "timeRemaining": "Time remaining",
    "notifications": "Notifications",
    "clear": "Clear",
    "markAllRead": "Mark all as read",
    "clearAll": "Clear all",
    "noNotifications": "No notifications",
    "batches": "Batches",
    "noActiveBatches": "No active batches",
    "refresh": "Refresh",
    "refreshCooldown": "Please wait {{seconds}}s before refreshing again",
    "minutes": "minutes",
    "justNow": "Just now",
    "minutesAgo": "{{count}} minute ago",
    "minutesAgo_other": "{{count}} minutes ago",
    "hoursAgo": "{{count}} hour ago",
    "hoursAgo_other": "{{count}} hours ago",
    "daysAgo": "{{count}} day ago",
    "daysAgo_other": "{{count}} days ago",
    "monthsAgo": "{{count}} month ago",
    "monthsAgo_other": "{{count}} months ago",
    "yearsAgo": "{{count}} year ago",
    "yearsAgo_other": "{{count}} years ago",
    "inMinutes": "in {{count}} minute",
    "inMinutes_other": "in {{count}} minutes",
    "inHours": "in {{count}} hour",
    "inHours_other": "in {{count}} hours",
    "inDays": "in {{count}} day",
    "inDays_other": "in {{count}} days",
    "inMonths": "in {{count}} month",
    "inMonths_other": "in {{count}} months",
    "inYears": "in {{count}} year",
    "inYears_other": "in {{count}} years",
    "fileNotFound": "File not found",
    "selectAll": "Select all",
    "clearSelection": "Clear selection",
    "import": "Import",
    "noFilesMatchingFilters": "No files matching filters, try to remove some filters or change the search criteria",
    "noUsersMatchingFilters": "No users matching filters, try to remove some filters or change the search criteria",
    "noGroupsMatchingFilters": "No groups matching filters, try to remove some filters or change the search criteria",
    "AIGrant": "AIGrant",
    "emailGrant": "EmailGrant",
    "searchTags": "Search tags",
    "expand": "Expand",
    "showMore": "Show more",
    "collapse": "Collapse",
    "manageUsersAndGroups": "Manage users and groups",
    "public": "Public",
    "private": "Private",
    "approved": "Approved",
    "rejected": "Rejected",
    "pending": "Pending",
    "pendingApprovalTooltip": "Awaiting approval, requested {{date}}",
    "approvedByTeamTooltip": "Sharing approved by team {{date}}",
    "rejectedByTeamTooltip": "Sharing rejected by team {{date}}",
    "reject": "Reject",
    "rejectFileShareRequest": "Reject file share request",
    "rejectionReason": "Rejection Reason",
    "rejectionReasonPlaceholder": "Enter the reason for rejection",
    "moreOwners": "More owners",
    "permissionLevel": "Permission level",
    "name": "Name",
    "approve": "Approve",
    "from": "From",
    "to": "to",
    "requester": "Requester",
    "shareTo": "Share To",
    "limitation": "Limitation",
    "selectRequestToViewDetails": "Select a request to view details",
    "shareRequestApprovalTitle": "Share request approval for {{fileName}}",
    "noFilesAvailable": "No files available",
    "accessDenied": "Access Denied",
    "fileShareRequestsList": "File share requests list",
    "fileShareRequestsDescription": "Approve or reject file share requests. Click on a request on the left side to view its details.",
    "waiting": "Waiting",
    "tagIsUsedForFileVisibility": "Files with this tag are shared with other users as set in the Tagged Files Visibility setting",
    "systemTagLocked": "System tag managed by the server: cannot be removed.",
    "tagRemovalRestricted": "Your administrator does not allow removing this tag from files.",
    "tagAdditionRestricted": "Your administrator does not allow adding this tag to files.",
    "completingLogin": "Completing login...",
    "redirectingToLogin": "Redirecting to login...",
    "redirecting": "Redirecting...",
    "twoFactorAuthentication": "2FA",
    "debug": "Debug",
    "sessionExpiresIn": "This folder will be locked again in {{time}}",
    "protectedFolder": "Protected folder",
    "sessionsTitle": "Unlock sessions for {{fileName}}",
    "folderSessions": "Folder Sessions",
    "publicLinks": "Public Links",
    "revoke": "Revoke",
    "revokeLink": "Revoke public link",
    "revokeLinkConfirmDescription": "Revoke the public link for {{fileName}}?",
    "protectedContentTitle": "Protected content",
    "protectedContentMessage": "This content is protected by a password. Enter the password to access it.",
    "accessCodeRequired": "Password is required.",
    "accessCodeLabel": "Password",
    "accessCodePlaceholder": "Enter password",
    "access": "Access",
    "folderContents": "Folder contents",
    "sharedAt": "Shared on",
    "alerts": {
      "moreCount": "{{count}} more alerts",
      "manageTwoFactor": "Manage 2FA",
      "dismissMenu": "Snooze or dismiss",
      "snoozePreset": {
        "h24": "1 day",
        "h72": "3 days",
        "h168": "1 week"
      },
      "snoozeHoursGeneric": "{{count}} hours"
    },
    "usersFetchFailed": "Could not load users. Check your connection and try again.",
    "groupsFetchFailed": "Could not load groups. Check your connection and try again.",
    "emailsFetchFailed": "Could not load emails. Check your connection and try again.",
    "pleaseSelectRole": "Please select a role",
    "selectColor": "Select color",
    "color": "Color",
    "loadingActivities": "Loading activities...",
    "quickShareMessagePlaceholder": "Write a message to selected users...",
    "signFile": "Sign file"
  },
  "roles": {
    "1000": "Super Admin",
    "1001": "Admin",
    "2001": "Contributor",
    "3002": "Reader",
    "4001": "External"
  },
  "accessMap": {
    "tagAccessTabLabel": "Access & Protections",
    "entityAccessTabLabel": "Tags & Protections",
    "visibility": "Visibility",
    "appliedProtections": "Applied protections",
    "appliedTo": "Applied to",
    "appliedToNobody": "No one currently receives this protection through this tag.",
    "configuration": "Configuration",
    "exceptions": "Exceptions",
    "exceptionsCount": "{{count}} exception",
    "exceptionsCount_one": "{{count}} exception",
    "exceptionsCount_other": "{{count}} exceptions",
    "hasExceptionsTooltip": "Some recipients are excluded from this protection.",
    "openInSettings": "Open in settings",
    "otherTagsInSetting": "Other tags that activate this protection",
    "noProtectionsForTag": "No protections are applied to this tag yet.",
    "noProtectionsForThisTag": "No protections inherited from this tag.",
    "configureProtection": "Configure a protection",
    "publicTagShort": "Public",
    "privateTagShort": "Private",
    "allUsersInCompany": "All users in the company",
    "tagNotShared": "This tag is not shared with anyone yet.",
    "protectionsCount": "{{count}} protection",
    "protectionsCount_one": "{{count}} protection",
    "protectionsCount_other": "{{count}} protections",
    "inheritedFromGroups": "Visible via groups: {{groups}}",
    "tagsVisibleToGroup": "Tags visible to this group ({{count}})",
    "tagsVisibleToUser": "Tags visible to this user ({{count}})",
    "rulesAppliedToGroup": "Protection rules applied to this group ({{count}})",
    "rulesAppliedToUser": "Protection rules applied to this user ({{count}})",
    "userSeesNoTags": "This user does not see any tags.",
    "groupSeesNoTags": "This group does not see any tags.",
    "tagNoRulesLead": "Files with this tag don't activate any specific rule for this group.",
    "tagRulesLead": "Files with this tag activate the following rule:",
    "tagRulesLead_one": "Files with this tag activate the following rule:",
    "tagRulesLead_other": "Files with this tag activate the following {{count}} rules:",
    "summary": {
      "action": "Action",
      "behaviour": "Behaviour",
      "readOnlyRoles": "Read-only roles",
      "showRecipients": "Show original recipients",
      "allowEdit": "Allow edit",
      "readOnlyMode": "Read-only mode",
      "watermarkText": "Watermark text",
      "placement": "Position",
      "appliesToExternal": "External User Enforcement",
      "approvedDomains": "Approved Domains",
      "maxExpirationDays": "Maximum Allowed Duration",
      "excludedDomains": "Excluded domains",
      "excludedGroups": "Excluded groups",
      "requireApprovalOnShare": "General Approval Requirement",
      "requireApprovalOnReshare": "Approval for Reshared Files Only",
      "reviewTeamSize": "Review Team",
      "hiddenFileTypes": "Invisible After Sharing",
      "allowedApplications": "Allowed Applications",
      "rolesAllowed": "Audience"
    }
  },
  "alerts": {
    "codes": {
      "TOTP_NOT_ENABLED": {
        "message": "Two-factor authentication is required. Enable it to secure your account."
      },
      "LICENSE_EXPIRING": {
        "message": "Your license expires on {{expirationDate}} ({{daysRemaining}} days remaining)."
      },
      "LOW_BACKUP_CODES": {
        "message": "You have few backup codes left ({{remaining}}). Regenerate them in two-factor settings."
      },
      "_generic": {
        "message": "You have an active notice ({{code}}). Contact your administrator if you need help."
      }
    }
  },
  "errors": {
    "required": "This field is required",
    "minLength": "Must be at least {{min}} characters",
    "authenticatorCodeInvalid": "The authenticator code is not valid.",
    "authenticatorNotRemoved": "An error occurred while removing the authenticator.",
    "authenticationUserBlocked": "The user is blocked. Please contact the administrator.",
    "authenticationUserExpired": "The user has expired. Please contact the administrator.",
    "codeIncorrect": "The code you entered is incorrect. Please try again.",
    "genericDeleteError": "An error occurred while deleting {{resource}}. Please try again or contact support if the problem persists.",
    "genericError": "An error occurred. Please try again or contact support if the problem persists.",
    "genericFetchError": "An error occurred while fetching {{resource}}. Please try again or contact support if the problem persists.",
    "userProfileUnavailable": "We couldn't load your profile. You stay signed in with limited permissions until this is fixed.",
    "userProfileStale": "We couldn't refresh your profile. You're still signed in with your last known permissions.",
    "userProfileRetry": "Retry",
    "alerts": {
      "dismissFailed": "Could not update this alert. Please try again.",
      "invalidSnooze": "Choose a valid snooze duration.",
      "fetchFailed": "Could not load alerts. They will retry automatically."
    },
    "sessionsFetchError": "Error fetching sessions.",
    "sessionsRevokeError": "Error revoking session.",
    "sessionsRevokeForbiddenError": "You do not have permission to revoke sessions for this user.",
    "sessionsRevokeOthersError": "Error revoking other sessions.",
    "sessionsRevokeAllError": "Error revoking all sessions.",
    "genericUpdateError": "An error occurred while updating {{resource}}. Please try again or contact support if the problem persists.",
    "genericCreateError": "An error occurred while creating {{resource}}. Please try again or contact support if the problem persists.",
    "invalidCredentials": "Incorrect email or password. Please verify your credentials and try again.",
    "invalidUsername": "The username you entered is not valid.",
    "tokenInvalid": "The provided token is not valid or has expired.",
    "tokenExpired": "Access token expired",
    "unsavedChangesMessage": "You have unsaved changes. Are you sure you want to leave and lose these changes?",
    "unsavedChangesTitle": "Unsaved Changes Detected.",
    "licenseExpired": "License has expired. Please renew your license.",
    "licenseMaxUsersReached": "The maximum number of users for this license has been reached. You cannot add new users or assign non-external roles to existing users.",
    "mandatoryClassificationCannotRemove": "You cannot remove all classification tags. At least one tag must remain because mandatory file classification is enabled in your organization's settings.",
    "tagRemovalDenied": "You are not allowed to remove one or more of the selected tags from this file.",
    "tagAdditionDenied": "You are not allowed to add one or more of the selected tags to this file.",
    "emailNotFound": "The email address {{email}} is not registered. Please verify your email address and try again.",
    "invalidEmailOrUsername": "Enter a valid email or username",
    "loginAliasNotValid": "This login alias is not valid. Use letters, digits, and . _ - @ + ' only (max 256 characters).",
    "loginAliasAlreadyUsed": "This login alias is already used by another user.",
    "loginAliasAlreadyUsedAsEmail": "This email is already used as a login alias by another user.",
    "otpExpired": "The OTP has expired. Please request a new OTP.",
    "totpWrong": "Invalid 2FA code. Please try again.",
    "temporaryTotpExpired": "Time to complete login has expired.",
    "errorAdminTotpResetNotAllowed": "Cannot disable 2FA: your organization does not allow administrators to reset user TOTP. A super administrator can allow this in Two-Factor Authentication (TOTP) settings.",
    "transferOwnershipFailed": "Ownership could not be transferred. Please try again or contact support.",
    "otpRequestLimitExceeded": "You have exceeded the limit for requesting OTPs. Please try again later.",
    "requestFilePermissions": "Try contacting the owner of the file to renew your permissions",
    "noUploadPermission": "You do not have permission to upload files in this location.",
    "publicLinkClassificationRequired": "The file must be classified before creating a public link.",
    "publicLinkPasswordRequired": "A password is required for public links.",
    "publicLinkMaxAccessCountRequired": "A maximum access count is required.",
    "publicLinkExpirationRequired": "An expiration date is required.",
    "publicLinkExpirationExceeded": "Expiration exceeds the maximum allowed days.",
    "publicLinkExpirationInPast": "Expiration date must be a future date.",
    "publicLinkFolderPasswordProtected": "Cannot create a public link for password-protected folders or for files inside them. To share via public link, remove the password protection from the folder.",
    "publicLinkDownloadRestricted": "Cannot create a public link because Download Encryption Enforcement is active for this file or its tags. To share via public link, remove the restriction from the Download Encryption Enforcement setting.",
    "publicLinkAnticaptureActive": " Cannot create a public link because Anti-capture mode is active for this file or its tags. To share via public link, remove Anti-capture from the file or the applicable tag settings.",
    "publicLinkExternalSharingRestricted": "Cannot create a public link because External Sharing Restrictions are active for this file or its tags. To share via public link, remove the applicable limits in the External Sharing Restrictions setting.",
    "publicLinkResharingDenied": "Cannot create a public link because resharing is not permitted for this file or its tags. To share via public link, review and update the File Re-sharing Permissions setting.",
    "publicLinkDownloadTagsRestricted": "Cannot create a public link because download restrictions are active for this file or its tags. To share via public link, review the Download Allowed Tags setting.",
    "publicLinkApprovalRequired": "Cannot create a public link because sharing approval is required for this file or its tags. To share via public link, review the Sharing Approval Requirements setting.",
    "publicLinkMandatoryExpiration": "Cannot create a public link because mandatory expiration policy is active for this file or its tags. To share via public link, ensure the expiration date is within the limit defined in the Mandatory Expiration Shared File setting.",
    "tagsAmountLimitReached": "You cannot create more than {{limit}} tags.",
    "hitASnag": "Uh-oh! Hit a snag there. Please retry...",
    "noPermission": "You don't have permission to perform this action.",
    "errorDownloadFile": "There was a problem downloading the file. Please try again.",
    "errorDuplicateFile": "There was a problem duplicating the file. Please try again.",
    "errorMoveFile": "There was a problem moving the file. Please try again.",
    "denyFileMove": "Move is not allowed for this file.",
    "pdfConversionUnsupportedFormat": "This file format is not supported for PDF conversion.",
    "pdfConversionFileTooLarge": "File too large for conversion. Maximum size is {{maxSizeMb}} MB.",
    "pdfConversionFailed": "PDF conversion failed. Please try again.",
    "pdfConversionAntivirusBlocked": "PDF conversion blocked: file contains a threat.",
    "fileNotFound": "File not found.",
    "errorDeleteFiles": "There was a problem deleting the files. Please try again.",
    "errorHideFiles": "There was a problem hiding the files. Please try again.",
    "errorUploadFile": "There was a problem uploading the file. Please try again.",
    "cannotAddArchivedFilesToFavorites": "Archived files cannot be added to favorites.",
    "cannotDeleteMultiplePasswordProtected": "Cannot delete the selected items because multiple password-protected folders are locked. Please unlock each folder individually and try again.",
    "cannotUnlockMultiplePasswordProtected": "Cannot unlock multiple password-protected folders at once. Please unlock each folder individually.",
    "groupNameCannotBeEmail": "The group name cannot be an email address.",
    "invalidFolder": "This folder is invalid.",
    "invalidFolderUpload": "The folder that you are trying to upload do not exist or is not supported.",
    "zeroByteFileNotUploaded": "Zero-byte files are not uploaded. Please select files with content.",
    "loginFailed": "Login failed",
    "unauthorized": "Authentication failed. Please try again.",
    "forbidden": "Access denied",
    "serverError": "Server error. Please try again later.",
    "tooManyRequests": "Too many requests. Please try again later.",
    "oauthAccessDenied": "Access denied by user",
    "oauthInvalidCallback": "Invalid OAuth callback",
    "oauthStateMismatch": "Security verification failed",
    "oauthContextMissing": "OAuth context missing",
    "oauthProviderNotEnabled": "OAuth provider not enabled",
    "oauthNotEnabled": "Direct OAuth not enabled for this tenant",
    "oauthDomainNotAllowed": "Email domain not allowed",
    "oauthEmailMismatch": "You signed in with a different account than the email you entered. Please sign in with the correct account.",
    "oauthCodeExchangeFailed": "Failed to exchange authorization code",
    "oauthTokenValidationFailed": "Token validation failed",
    "oauthInvalidTenant": "Invalid tenant",
    "oauthSessionExpired": "Session expired. Please try again.",
    "sessionExpired": "Your session has expired. Please log in again to continue.",
    "filePasswordLockout": "This folder is locked due to too many failed attempts. Try again in {{minutes}} minutes.",
    "getViewerData": "There was a problem getting the viewer data. Please try again.",
    "protectedLinkAlreadyUsed": "Link already used, generate a new code",
    "protectedLinkAlreadyUsedOrExpired": "Link already used or expired, generate a new code",
    "fileAccessSessionExpired": "Session expired, generate a new code",
    "protectedFileDownloadOnlyForWindows": "The protected file download is available only for Windows platform.",
    "antiCaptureActivated": "This item is protected by anti-capture settings.",
    "downloadRestrictionActivated": "This item is protected by download restrictions settings.",
    "watermarkProtectionDownloadDenied": "This file is protected and cannot be downloaded. You can still view it.",
    "antivirusFileInfected": "This file cannot be opened or shared because antivirus detected a threat.",
    "antivirusFileInfectedNamed": "Antivirus detected {{threatName}} in {{fileName}}.",
    "antivirusRescanNotAllowed": "You are not allowed to request an antivirus rescan for this file.",
    "antivirusNotAvailable": "Antivirus scanning is not available right now. Try again later.",
    "fileSizeTooBigForDownload": "The file cannot be downloaded in encrypted mode because it exceeds 250 MB.",
    "fileNotAvailable": {
      "title": "File no longer available",
      "description": "The file you are trying to access is no longer available. It may have been deleted or moved."
    },
    "publicLinkNotFoundTitle": "This link is not available",
    "publicLinkNotFoundMessage": "This link does not exist, was removed, or is no longer accessible.",
    "publicLinkItemNotAvailable": "This item is not available",
    "publicLinkExpiredTitle": "Link expired",
    "publicLinkExpiredMessage": "This link has expired and is no longer valid.",
    "publicLinkMaxAccessTitle": "Access limit reached",
    "publicLinkMaxAccessMessage": "The maximum number of accesses for this link has been reached.",
    "invalidAccessCode": "The password you entered is incorrect. Please try again.",
    "fileSizeUploadLimit": "The file size exceeds the upload limit of {{value}} mb",
    "fileSizeExceedsAdminLimit": "Unable to upload file: the size exceeds the maximum limit set by the administrator.",
    "fileSizeExceedsLicenseLimit": "Unable to upload file: the size exceeds the maximum limit established in the license.",
    "uploadingFileError": "There was a problem uploading the file.",
    "uploadInterrupted": "Upload cancelled by user.",
    "fileTypeRestrictionError": "This file type cannot be uploaded due to the settings applied.",
    "quickShareError": "There was a problem sharing the files. Please try again.",
    "quickShareFilesNotUploaded": "{{ count }} file were not uploaded successfully. Click Continue to share the successfully uploaded files anyway.",
    "quickShareFilesNotUploaded_other": "{{ count }} files were not uploaded successfully. Click Continue to share the successfully uploaded files anyway.",
    "enterOnBehalfOfUserFailed": "Failed to enter on behalf of user. Please try again.",
    "exitOnBehalfOfUserFailed": "Failed to exit on behalf of user. Please try again.",
    "reasonRequired": "Please enter a reason for entering on behalf of user",
    "reasonMinLength": "Reason must be at least 3 characters",
    "impersonatedUserNotNotified": "The user could not be notified by email (no email address on the account)",
    "quickShareFilesNotShared": "Files were not shared successfully. Click Continue to share the successfully uploaded files anyway.",
    "filesNotShared": "Files were not shared.",
    "fileSizeExceedsLimit": "The file size exceeds the limit of {{value}}.",
    "otpWrong": "The OTP code is wrong. Please try again.",
    "groupNameAlreadyUsed": "The group name is already used.",
    "updateFileAccessError": "There was a problem updating the file access. Please try again.",
    "deleteFileAccessError": "There was a problem deleting the file access. Please try again.",
    "errorCreateFileShortcut": "There was a problem creating the file shortcut. Please try again.",
    "openShortcutFileError": "Oops, it looks like linked file isn’t available anymore. It might have been removed or access revoked.",
    "confirmationMessageMatch": "The confirmation message does not match.",
    "emailExist": "Email already exists.",
    "shareFiles": "The was a problem sharing the files. Please try again.",
    "genericSellError": "An error occurred while listing the file for sale.",
    "someItemsCannotBeSelected": "Some items cannot be selected",
    "invalidMicrosoftEntraIdToken": "The Microsoft Entra ID token is not valid or has expired.",
    "atLeastOneOption": "You must select at least one option",
    "groupNameAlreadyExists": "The group name is already used.",
    "cannotAddSuperAdminToGroup": "You cannot add a Super Admin to a group.",
    "editSharingDenied": "You do not have permission to edit access rights for documents that have already been shared. If a user does not appear in the list, it means they already have an active sharing.",
    "errorRemoveShareFiles": "There was a problem removing the share files. Please try again.",
    "noFileClassificationAvailable": "No file classification available at the moment",
    "errorPermanentlyDeleteFiles": "There was a problem permanently deleting the files. Please try again.",
    "aiDocumentChatError": "An error occurred while chatting with the document. Please try again.",
    "filesAlreadyClassified": "Files are already classified",
    "filesBeingClassified": "Files are currently being classified",
    "filesBeingClassifiedDescription": "Please wait until the current classification process is complete before starting a new one.",
    "filesTooBig": "Files exceed the size limit for classification",
    "filesTooBigDescription": "The maximum file size allowed for AI classification is 250 MB. Please select smaller files.",
    "tooManyFiles": "Too many files selected",
    "tooManyFilesDescription": "{{files}} files selected; the maximum is {{limit}}. Please reduce the selection and try again.",
    "rejectionReasonRequired": "Rejection reason is required",
    "rejectionReasonMinLength": "Rejection reason must be at least 3 characters",
    "fileAlreadyInUseError": "The file is already in use by another user.",
    "contentHashMismatchError": "File corrupted during upload (hash mismatch)",
    "fileIntegrityCheckFailed": "File integrity check failed",
    "fileIntegrityCheckFailedDescription": "The downloaded file may be corrupted. Please try downloading again.",
    "fileIntegrityCheckError": "File integrity check error",
    "fileIntegrityCheckErrorDescription": "Could not verify file integrity, but download will proceed.",
    "storageUrlFetchFailed": "Tenant not found or temporarily unavailable",
    "storageUrlFetchFailedDescription": "Please check the address and try again: <strong>{{tenantAddress}}</strong>.",
    "folderPasswordRequired": "This folder requires password verification",
    "folderPassword": {
      "passwordRequired": "Password is required.",
      "tooShort": "Password must be at least 4 characters.",
      "ownerOnly": "Only the folder owner can perform this action.",
      "alreadyExists": "This folder already has password protection.",
      "ancestorProtected": "Cannot perform this action because a parent folder is password protected.",
      "descendantProtected": "Cannot perform this action because a subfolder is password protected.",
      "notSet": "This folder does not have password protection configured.",
      "notProtected": "This folder is not password protected.",
      "currentRequired": "Current password is required.",
      "expired": "Folder password protection has expired. Please contact the folder owner.",
      "incorrect": "The current folder password is incorrect. Please try again.",
      "sessionNotFound": "Session not found or already revoked.",
      "sessionForbidden": "You do not have permission to manage this session.",
      "otpNotRequested": "OTP has not been requested. Please request a new code."
    },
    "notAFolder": "Selected item is not a folder",
    "ipRegionBlocked": {
      "message": "Access denied from your location.",
      "loginTitle": "Access Denied",
      "loginMessage": "Access denied from your location.",
      "loginGeneric": "Access denied from your location.",
      "fileOperationTitle": "Operation Not Allowed",
      "fileOperationMessage": "Access denied from your location."
    },
    "ipRegionAdminLockout": {
      "title": "Cannot enable admin IP restriction",
      "message": "Your current IP address must be included in the allowed admin IP addresses, otherwise you would lock yourself out of the admin settings."
    },
    "dateMustBeFuture": "Date must be in the future",
    "externalSharingNotAllowed": "The following recipients are not authorized to receive external sharing: {{recipients}}",
    "sharingNotAllowedMandatoryTag": "Attachments must have a classification tag before sending",
    "fileSharingDenied": "File sharing is not allowed for this operation.",
    "cannotAccessFiles": "You cannot access one or more of the requested files.",
    "partialSharingDenied": "Some files cannot be shared with the selected recipients.",
    "partialSharingDeniedDisabledRecipients": "Some selected users or groups already have sharing for these files, but it is currently disabled. Re-enable it using the {{shareAgainLabel}} button next to each recipient.",
    "passKeyDataRequired": "Passkey data is missing or invalid. Please try again.",
    "passKeyForbidden": "You do not have permission to perform this action.",
    "passKeyLimitReached": "You have reached the maximum number of passkeys. Remove one before adding another.",
    "passKeyLockedOut": "Too many failed passkey attempts. Please try again later or use another sign-in method.",
    "passKeyNotAllowed": "This passkey action is not allowed.",
    "passKeyNotEnabled": "Passkeys are not enabled for your account or organization.",
    "passKeyNotFound": "Passkey not found. It may have been removed or is no longer valid.",
    "passKeySessionExpired": "The passkey session expired. Please start again.",
    "passKeyVerificationFailed": "Credential not found or not enabled for passwordless login.",
    "batchNotFound": "Batch not found or you do not have access to it.",
    "batchNotCancellable": "This batch cannot be cancelled (not a classification batch).",
    "batchAlreadyFinished": "This operation has already finished.",
    "batchRetryNotSupported": "Retry is only supported for classification batches.",
    "noFileJobsFound": "None of the selected files can be cancelled or retried in their current state.",
    "queueUnavailable": "The processing queue is temporarily unavailable. Please try again later.",
    "DIRECTORY_SYNC_ALREADY_RUNNING": "Another directory sync is running for this company. Retry when it ends.",
    "ldap": {
      "ACTIVE_DIRECTORY_NOT_AVAILABLE": "Active Directory sync is not available for this installation or licence.",
      "LDAP_NOT_CONFIGURED": "Active Directory is not configured yet. Open the LDAP settings page first.",
      "LDAP_CONFIGURATION_INVALID": "The LDAP configuration is invalid. Fix the highlighted fields and save again.",
      "LDAP_CREDENTIAL_REQUIRED": "A bind password is required. Enter the service-account password.",
      "LDAP_UNREACHABLE": "Domain controller unreachable — check host, port and firewall.",
      "LDAP_TLS_FAILED": "Certificate not trusted — upload the internal CA in the settings, or check security/port pairing.",
      "LDAP_BIND_FAILED": "Service account rejected — check bind DN and password.",
      "LDAP_BASE_DN_NOT_FOUND": "Bind succeeded but the base DN was not found — check base DN.",
      "LDAP_SEARCH_FAILED": "The directory refused the search — check the filters.",
      "LDAP_CREDENTIAL_ENCRYPTION_FAILED": "Server error, contact support.",
      "rateLimited": "Too many requests, retry in a minute."
    },
    "outboundEmail": {
      "OUTBOUND_EMAIL_NOT_AVAILABLE": "Custom e-mail domain is not available for this account or licence.",
      "OUTBOUND_EMAIL_CONFIG_INVALID": "The outbound e-mail configuration is invalid. Fix the highlighted fields and save again.",
      "OUTBOUND_EMAIL_NOT_CONFIGURED": "Save a domain configuration before verifying.",
      "OUTBOUND_EMAIL_NOT_READY": "Custom sender is not ready yet (disabled, not verified, or Mailgun not active).",
      "OUTBOUND_EMAIL_CONCURRENT_CHANGE": "The configuration changed while the check ran. Refresh status and retry.",
      "OUTBOUND_EMAIL_DNS_LOOKUP_FAILED": "DNS check unavailable, retry later.",
      "OUTBOUND_EMAIL_MAILGUN_FAILED": "Mailgun request failed. Ownership may still have been saved — refresh status.",
      "OUTBOUND_EMAIL_TEST_FAILED": "Could not send the test e-mail, retry later.",
      "rateLimited": "Too many requests, retry shortly."
    }
  },
  "notifications": {
    "genericUpdateSuccess": "{{resource}} updated successfully.",
    "genericCreateSuccess": "{{resource}} created successfully.",
    "linkCopiedToClipboard": "Link copied to clipboard!",
    "codeCopiedToClipboard": "Code copied to clipboard!",
    "fileProtectedWithAntiCapture": "This file is protected with anticapture To view the file content, enter this code when prompted in the Filegrant Viewer, and you’re done!",
    "otpCopiedToClipboard": "OTP copied to clipboard!",
    "fileProtectedDownloadInProgress": "Download in progress, at the end of the download run the application downloaded, enter above indicated to view the file.",
    "quickShareSuccess": "Files shared successfully.",
    "fileLocatedInThisLocation": "This file is already located in this location.",
    "fileAccessRevoked": "Access rights revoked successfully.",
    "fileAccessUpdated": "Access rights updated successfully.",
    "fileVersionRestored": "File version restored successfully.",
    "folderCreated": "Folder {{resource}} created successfully.",
    "fileCreated": "File {{resource}} created successfully.",
    "fileRenamed": "File {{resource}} renamed to {{newName}} successfully.",
    "fileDuplicated": "File {{resource}} duplicated successfully.",
    "fileDuplicated_other": "Files duplicated successfully.",
    "fileFavouriteChanged": "File {{resource}} {{isFavourite}} favorites successfully.",
    "fileFavouriteChanged_other": "Files {{isFavourite}} favorites successfully.",
    "fileShortcutCreated": "File {{resource}} shortcut created successfully.",
    "fileMoved": "File {{resource}} moved  successfully.",
    "fileMoved_other": "Files moved successfully.",
    "pdfConversionStarted": "Conversion of {{resource}} to PDF started.",
    "pdfConversionSuccess": "PDF conversion completed successfully.",
    "pdfConversionFailed": "PDF conversion failed.",
    "pdfConversionStillRunning": "PDF conversion is still running. You'll be notified when it finishes.",
    "emptyTrash": "Trash emptied successfully.",
    "operationMayTakeTime": "This operation may take some time to complete.",
    "fileRestored": "File {{resource}} restored successfully.",
    "fileRestored_other": "Files restored successfully.",
    "fileHidden": "File {{resource}} hidden successfully.",
    "fileHidden_other": "Files hidden successfully.",
    "fileUnhidden": "File {{resource}} unhidden successfully.",
    "fileUnhidden_other": "Files unhidden successfully.",
    "filesMarkedAsRead_one": "Marked as read.",
    "filesMarkedAsRead_other": "{{count}} files marked as read.",
    "filesMarkedAsUnread_one": "Marked as unread.",
    "filesMarkedAsUnread_other": "{{count}} files marked as unread.",
    "folderLocked": "{{count}} folder locked.",
    "folderLocked_other": "{{count}} folders locked.",
    "fileClassifying": "File is being classified",
    "filesClassifying": "{{count}} file is being classified",
    "filesClassifying_other": "{{count}} files are being classified",
    "filesClassifyingBatch": "{{count}} files are being classified as a batch",
    "filesClassifyingBatchWithSkipped": "{{count}} files queued for classification. {{skipped}} skipped.",
    "folderClassifyingBatch": "Folder contents are being classified as a batch",
    "foldersClassifyingBatch": "{{count}} folders are being classified as a batch",
    "fileTagsUpdated": "File {{resource}} tags updated successfully.",
    "fileDeleted": "File {{resource}} deleted successfully.",
    "fileDeleted_other": "Files deleted successfully.",
    "checkingFilesExistsCounter": "Checking files: {{done}} / {{total}}",
    "checkingFoldersExistsCounter": "Checking folders: {{done}} / {{total}}",
    "checkingFilesInFolderCounter": "{{folder}} · Checking files: {{done}} / {{total}}",
    "checkingSubfoldersInFolderCounter": "{{folder}} · Checking folders: {{done}} / {{total}}",
    "tags": {
      "title": "File Tagged",
      "description": "File #{{fileId}} has been tagged",
      "descriptionWithFileName": "{{fileName}} has been tagged",
      "descriptionGeneric": "File has been tagged",
      "errorTitle": "File couldn't be tagged",
      "error": "AI classification failed.",
      "batchSuccessTitle": "Classification batch complete",
      "batchSuccessDescription": "Classified {{processed}} of {{total}} files.",
      "batchFailedTitle": "Classification batch failed",
      "batchFailedDescription": "Batch finished with errors ({{processed}}/{{total}})."
    },
    "summary": {
      "title": "File Summary",
      "description": "Summary generated for file {{fileId}}",
      "ready": "The file summary is ready.",
      "open": "Open summary"
    },
    "fileUnavailable": "File not available",
    "suggestGridMode": {
      "title": "This folder contains only images",
      "description": "Switch to grid view for a better preview.",
      "action": "Switch to grid"
    },
    "documentClassification": {
      "title": "Document Classified",
      "description": "Document classification completed for file {{fileId}}"
    },
    "default": {
      "title": "Notification",
      "description": "New notification received"
    },
    "sharing": {
      "title": "File shared",
      "sharing_operation_download": "{{actorName}} downloaded {{fileName}}",
      "sharing_operation_open": "{{actorName}} opened {{fileName}}",
      "sharing_operation_edit": "{{actorName}} edited {{fileName}}",
      "sharing_operation_delete": "{{actorName}} deleted {{fileName}}",
      "sharing_operation_rename": "{{actorName}} renamed {{fileName}}",
      "sharing_operation_add": "{{actorName}} added {{fileName}}",
      "sharing_operation_move": "{{actorName}} moved {{fileName}}",
      "sharing_operation_copy": "{{actorName}} copied {{fileName}}",
      "sharing_operation_unknown": "{{actorName}} performed an operation on {{fileName}}"
    },
    "folderPasswordSet": "Password protection enabled",
    "folderPasswordUpdated": "Password protection updated",
    "folderPasswordRemoved": "Password protection removed",
    "unlockingFolder": "Unlocking folder…",
    "folderUnlocked": "Folder unlocked successfully"
  },
  "files": {
    "downloadPreparation": "Preparing download",
    "downloadReady": "Download ready",
    "compressionOfFilesInProgress": "Compression of files in progress",
    "compressionCompleted": "Compression completed",
    "compressionFailed": "Compression failed",
    "exportFolderFileList": {
      "button": "Export",
      "formatCsv": "CSV",
      "formatJson": "JSON",
      "formatExcelXml": "Excel (XML)",
      "modalTitle": "Export \"{{folder}}\" file list",
      "rootLabel": "Root",
      "modalDescription": "Exports only items in this folder — not files inside nested folders. Active filters apply. Choose columns and options. Folder size is left blank (no cheap batch size API).",
      "confirm": "Export",
      "empty": "This folder has no files to export.",
      "failed": "Could not export the file list.",
      "extension": "Extension",
      "id": "ID",
      "isShared": "Shared",
      "columnsLabel": "Columns",
      "delimiterLabel": "Column divider",
      "delimiterComma": "Comma (,)",
      "delimiterSemicolon": "Semicolon (;)",
      "delimiterTab": "Tab (\\t)",
      "delimiterPipe": "Pipe (|)",
      "tagsJoinLabel": "Tag divider",
      "tagsJoinSemicolon": "Semicolon (;)",
      "tagsJoinPipe": "Pipe (|)",
      "tagsJoinComma": "Comma (,)",
      "tagsJoinConflictWarning": "Tag divider matches the column divider. Downstream CSV parsers may split tags incorrectly.",
      "dateFormatLabel": "Date format",
      "dateFormat": {
        "localeShort": "Short date (locale) — e.g. {{sample}}",
        "iso": "ISO (YYYY-MM-DD) — e.g. {{sample}}",
        "localeDateTime": "Date and time (locale) — e.g. {{sample}}",
        "dmy": "DD/MM/YYYY — e.g. {{sample}}",
        "mdy": "MM/DD/YYYY — e.g. {{sample}}",
        "isoDateTime": "YYYY-MM-DD HH:mm — e.g. {{sample}}",
        "europeanDateTime": "DD/MM/YYYY HH:mm — e.g. {{sample}}"
      },
      "dragToReorder": "Drag to reorder {{column}}"
    }
  },
  "fileAccessNotification": {
    "enableActivityNotifications": "Enable activity notifications",
    "includeSubfolders": "Include subfolders",
    "notifyOwner": "Notify owner",
    "notifyRecipients": "Notify recipients",
    "whoCanTrigger": "Who can trigger notifications?",
    "trigger": {
      "ownerOnly": "Owner only",
      "anyone": "Anyone"
    },
    "operation": {
      "download": "Download",
      "open": "Open",
      "edit": "Edit",
      "delete": "Delete",
      "rename": "Rename",
      "add": "Add",
      "move": "Move",
      "copy": "Copy"
    },
    "configureNotifications": "Configure notifications",
    "customizeFor": "Customize for",
    "discardChangesTitle": "Discard changes?",
    "discardChangesDescription": "You have unsaved changes. Discard them and close?",
    "discardConfirm": "Discard",
    "notificationsDisabled": "Notifications disabled",
    "notificationsEnabled": "Notifications enabled",
    "modalTitle": "Activity notifications"
  },
  "modal": {
    "saveTagsConfirm": {
      "title": "Save tag changes?",
      "description": "You have unsaved changes to tags. Save before closing?"
    },
    "userGroupSelectorForm": {
      "title": "Manage Review Team",
      "description": "Select users and groups for the review team",
      "currentMembers": "Current Members",
      "unsavedReviewTeam": "Unsaved Review Team"
    },
    "tagUserGroupMultiSelectForm": {
      "title": "Manage Users and Groups",
      "description": "Select users and groups who can access this tag",
      "usersAndGroups": "Users and groups",
      "unsavedUsersAndGroups": "Unsaved Users and Groups"
    },
    "changeUserRole": {
      "title": "Change user role",
      "description": "Are you sure you want to change {{name}} role from {{initialRole}} to {{newRole}}?"
    },
    "deleteUsersForm": {
      "title": "Delete user",
      "title_other": "Delete users",
      "roleAdminOrContributor": "The user you are about to delete is a Contributor or Admin and may have uploaded files to the system. Deleting this user will also delete all of their uploaded files and any associated shares, and they will no longer be able to access the platform. Are you sure you want to proceed? <i>(Type \"{{keyword}}\" to confirm.)</i>",
      "roleReader": "The user you are about to delete is a Reader and may have files that were shared with them by other users. Deleting this user will prevent them from accessing the system and any files that were shared with them. Are you sure you want to proceed? <i>(Type \"{{keyword}}\" to confirm.)</i>",
      "roleExternal": "The user you are about to delete is also referenced by other users on the platform, who have shared files or folders directly with them. Removing this user will revoke their access to any shared content, and other users who shared with them will no longer see this user in their own user lists. Are you sure you want to proceed? <i>(Type \"{{keyword}}\" to confirm.)</i>",
      "multiple": "You are about to delete multiple users. Some of these users may have uploaded files to the system. Deleting them will remove all their uploaded files and any associated shares, and they will no longer be able to access the platform. Are you sure you want to proceed? <i>(Type \"{{keyword}}\" to confirm.)</i>",
      "transferDestinationLabel": "Transfer personal files to another user (optional)",
      "transferDestinationPlaceholder": "Search for a user…",
      "transferOptionalHint": "If you choose a recipient, personal files from the account(s) you are deleting will be transferred there before removal. Leave empty to remove files according to the policy described above.",
      "userReferencedInSettings": {
        "title": "Cannot delete user",
        "title_other": "Cannot delete users",
        "description": "The selected user cannot be deleted. This user is referenced in the following settings: <settingsList/>. Remove this user from these settings before trying again.",
        "description_other": "The selected users cannot be deleted. They are referenced in the following settings: <settingsList/>. Remove them from these settings before trying again.",
        "unknownSettings": "One or more settings"
      }
    },
    "changeUsersStatus": {
      "title": "Change user status",
      "description": "Are you sure you want to {{status}} <strong>{{resource}}</strong>?",
      "description_other": "Are you sure you want to {{status}} <strong>these users</strong>?"
    },
    "excludeFromSso": {
      "titleExclude": "Exclude user from SSO",
      "titleInclude": "Re-enable SSO for user",
      "descriptionExclude": "Are you sure you want to exclude <strong>{{resource}}</strong> from SSO? They will no longer be able to sign in via the configured identity provider and will have to log in via OTP.",
      "descriptionInclude": "Are you sure you want to re-enable SSO for <strong>{{resource}}</strong>? They will be able to sign in via the configured identity provider again."
    },
    "enterOnBehalfOf": {
      "title": "Enter On Behalf Of mode",
      "description": "You're starting a session where you'll see data and perform operations on behalf of <strong>{{resource}}</strong>.<br /><br />Do you confirm?"
    },
    "impersonateUser": {
      "title": "Impersonate User",
      "description": "Are you sure you want to log in as {{userName}}? You will be able to see and perform operations as this user.",
      "emailNotice": "The user will receive an email notifying them of this impersonation, including your name, the date and time, and the reason you enter below.",
      "reasonLabel": "Reason — shown to the user in the notification email",
      "reasonTruncateHint": "Reasons longer than 500 characters are truncated with \"…\" in the email (the full text is still stored).",
      "reasonEmptyHint": "If left empty, the email shows \"Not specified\"."
    },
    "userForm": {
      "editTitle": "Edit user",
      "newTitle": "New user",
      "editDescription": "Edit user details",
      "newDescription": "Add a new user"
    },
    "userGroups": {
      "title": "Group membership",
      "description": "Groups list which <strong>{{resource}}</strong> is a member"
    },
    "userFiles": {
      "title": "Shared Items",
      "description": "Items shared with <strong>{{resource}}</strong>"
    },
    "groupFiles": {
      "title": "Shared Items",
      "description": "Items shared with <strong>{{resource}}</strong>"
    },
    "fileSizeTooBigForOpen": {
      "title": "File size too big",
      "description": "The file size exceeds the limit of {{value}}. If you want to open the file, you can download it and open it locally."
    },
    "deleteGroups": {
      "title": "Delete group",
      "title_other": "Delete groups",
      "description": "Are you sure you want to delete <strong>{{resource}}</strong>? Are you sure you want to proceed? <i>(Type \"{{keyword}}\" to confirm.)</i>",
      "description_other": "Are you sure you want to delete <strong>these groups</strong>? Are you sure you want to proceed? <i>(Type \"{{keyword}}\" to confirm.)</i>"
    },
    "groupForm": {
      "editTitle": "Edit group",
      "newTitle": "New group",
      "viewTitle": "View group",
      "editDescription": "Edit group details",
      "viewDescription": "View group details",
      "newDescription": "Add a new group",
      "allUsers": "All users",
      "selectedUsersOrGroups": "Selected users or groups"
    },
    "entraIdGroupsImportForm": {
      "importFromEntraId": "Import from Entra ID",
      "title": "Import Groups from Microsoft Entra ID",
      "searchGroups": "Search groups...",
      "selectNew": "Select new only",
      "existing": "Existing",
      "linked": "Linked",
      "new": "New",
      "importMembers": "Also import group members",
      "importSelected": "Import ({{count}})",
      "importSuccess": "Import completed: {{created}} created, {{updated}} updated",
      "importError": "Error during import",
      "errorLoadingGroups": "Error loading groups from Entra ID",
      "noGroupsFound": "No groups found",
      "resultSummary": "Created: {{created}}, Updated: {{updated}}, Skipped: {{skipped}}, Failed: {{failed}}",
      "usersImported": "{{count}} member(s) also imported",
      "permissionDeniedFallback": "Permission denied",
      "permissionErrorTitle": "Insufficient Azure AD Permissions",
      "permissionErrorDescription": "The Azure AD application does not have sufficient permissions to access Microsoft Graph API.",
      "permissionErrorSteps": "To resolve this issue:",
      "permissionErrorStep1": "Go to Azure Portal > App registrations > Your app",
      "permissionErrorStep2": "Navigate to API permissions",
      "permissionErrorStep3": "Add the required Application permissions (not Delegated)",
      "permissionErrorStep4": "Click \"Grant admin consent\" to authorize the permissions",
      "requiredPermissions": "Required permissions",
      "defaultRole": "Default role"
    },
    "csvUsersImportForm": {
      "importFromCsv": "Import from CSV",
      "title": "Import users from CSV",
      "description": "Create new users only. Rows whose email already exists are skipped (not treated as failures). Roles: SuperAdmin, Admin, Contributor, Reader (or numeric codes).",
      "browserStayOpenWarning": "Do not close or refresh this browser tab until the import finishes. Progress exists only in this session.",
      "confirmSkipErrors": "There are {{count}} elements with errors and those will not be imported.",
      "downloadTemplate": "Download CSV template",
      "sendInvites": "Send invitation emails to newly created users",
      "dropzone": "Drop a CSV file here or click to browse",
      "fileSelected": "Selected: {{name}}",
      "invalidFileType": "Please select a .csv file",
      "readError": "Could not read the CSV file",
      "noValidRows": "No valid rows found in this file",
      "colLine": "Line",
      "confirmImport": "Import {{count}} users",
      "emptyFile": "The CSV file is empty",
      "invalidHeader": "Invalid header. Expected: {{expected}}",
      "tooManyColumns": "Too many columns on this row",
      "missingFirstName": "First name is required",
      "missingLastName": "Last name is required",
      "missingEmail": "Email is required",
      "invalidEmail": "Invalid email address",
      "missingRole": "Role is required",
      "invalidRole": "Invalid role: {{value}}",
      "superAdminRoleNotAllowed": "Only a SuperAdmin can assign the SuperAdmin role",
      "invalidExpirationDate": "Invalid expiration date: {{value}}",
      "invalidBoolean": "Invalid boolean for {{field}}: {{value}}",
      "duplicateInFile": "Duplicate email in file (first seen on line {{firstLine}})",
      "genericCreateError": "Could not create user",
      "drawerAria": "User import progress",
      "drawerRunning": "Importing users…",
      "drawerCompleted": "User import complete",
      "drawerCancelled": "User import cancelled",
      "importingUsersCounter": "Importing users {{amount}} of {{total}}",
      "importedUsersCounter": "Imported {{amount}} of {{total}}",
      "waitingForImport": "Waiting",
      "importingRow": "Importing…",
      "alreadyExists": "Already exist",
      "summary": "Created: {{created}} · Already exist: {{skipped}} · Failed: {{failed}}",
      "progressCount": "{{done}} / {{total}}",
      "failedList": "Failed",
      "alreadyExistList": "Already exist ({{count}})",
      "cancelImport": "Cancel import",
      "cancelConfirmTitle": "Cancel import?",
      "cancelConfirmContent": "In-flight creates will finish; remaining rows will not start.",
      "continueImport": "Keep importing",
      "minimizeDrawer": "Minimize",
      "expandDrawer": "Expand",
      "previewHeading": "{{total}} users · {{errors}} errors",
      "searchPlaceholder": "Search users…",
      "colStatus": "Status",
      "filterWithErrors": "With errors",
      "filterValid": "Valid",
      "statusError": "Error",
      "statusOk": "OK"
    },
    "entraIdUsersImportForm": {
      "importFromEntraId": "Import from Entra ID",
      "title": "Import Users from Microsoft Entra ID",
      "searchUsers": "Search users...",
      "selectNew": "Select new only",
      "existing": "Existing",
      "new": "New",
      "importSelected": "Import ({{count}})",
      "importSuccess": "Import completed: {{created}} created, {{updated}} updated",
      "importError": "Error during import",
      "errorLoadingUsers": "Error loading users from Entra ID",
      "noUsersFound": "No users found",
      "resultSummary": "Created: {{created}}, Updated: {{updated}}, Skipped: {{skipped}}, Failed: {{failed}}",
      "permissionDeniedFallback": "Permission denied",
      "permissionErrorTitle": "Insufficient Azure AD Permissions",
      "permissionErrorDescription": "The Azure AD application does not have sufficient permissions to access Microsoft Graph API.",
      "permissionErrorSteps": "To resolve this issue:",
      "permissionErrorStep1": "Go to Azure Portal > App registrations > Your app",
      "permissionErrorStep2": "Navigate to API permissions",
      "permissionErrorStep3": "Add the required Application permissions (not Delegated)",
      "permissionErrorStep4": "Click \"Grant admin consent\" to authorize the permissions",
      "requiredPermissions": "Required permissions",
      "defaultRole": "Default role"
    },
    "batchDetailForm": {
      "title": "Batch detail",
      "noFailedFiles": "No failed files",
      "noFiles": "No files in this status",
      "fileCancelled": "Cancellation requested for this file.",
      "fileCancelError": "Error requesting file cancellation.",
      "fileRetried": "File queued for retry",
      "fileRetryError": "Error retrying file",
      "truncatedHint": "Failed-file preview was truncated. Use the Failed tab for the full list.",
      "attempt": "Attempt {{count}}",
      "tabs": {
        "pending": "Pending",
        "processing": "Processing",
        "success": "Completed",
        "failed": "Failed",
        "canceled": "Canceled"
      },
      "status": {
        "pending": "Pending",
        "processing": "Processing",
        "success": "Completed",
        "failed": "Failed",
        "canceled": "Canceled"
      }
    },
    "batchesList": {
      "panelTitle": "Batches",
      "noActiveBatches": "No active batches",
      "cancelAllFailed": "Cancel all Failed batches (not Processing)",
      "cancelAllFailedConfirmTitle": "Cancel all Failed batches?",
      "cancelAllFailedConfirmContent": "This clears every batch with status Failed. Processing and Queued batches keep running and are not affected. This cannot be undone.",
      "cancelBatch": "Cancel batch",
      "cancelBatchConfirmTitle": "Cancel this batch?",
      "cancelBatchConfirmContent": "This will cancel the request. Processing may stop at the next checkpoint. This cannot be undone.",
      "failedFiles": "{{count}} file failed",
      "failedFiles_other": "{{count}} files failed",
      "progress": "{{processed}} / {{total}}",
      "status": {
        "all": "All",
        "queued": "Queued",
        "processing": "Processing",
        "completed": "Completed",
        "failed": "Failed",
        "partiallycompleted": "Partially Completed",
        "cancelled": "Cancelled"
      },
      "operation": {
        "all": "All Operations",
        "classification": "AI Classification",
        "folderexpansion": "Folder Expansion",
        "delete": "Delete",
        "zip": "ZIP creation failed"
      },
      "pendingFiles": "{{count}} pending",
      "pendingFiles_other": "{{count}} pending",
      "processingFiles": "{{count}} processing",
      "processingFiles_other": "{{count}} processing",
      "processedFiles": "{{count}} completed",
      "processedFiles_other": "{{count}} completed",
      "canceledFiles": "{{count}} canceled",
      "canceledFiles_other": "{{count}} canceled",
      "viewDetail": "View details"
    },
    "tagForm": {
      "editTitle": "Edit tag",
      "newTitle": "New tag",
      "editDescription": "Edit tag details",
      "newDescription": "Add a new tag",
      "visibility": "Visibility",
      "selectUserRoles": "Select user roles",
      "visibilityDescription": "Make this tag visible to the following roles and specify if the tag will be visible to everyone or only to specific groups or users.",
      "usedInSettings": "Used in:",
      "usedInSettingsNone": "This tag is not used in any setting."
    },
    "deleteTag": {
      "title": "Delete tag",
      "description": "Are you sure you want to delete <strong>{{resource}}</strong>? Are you sure you want to proceed?",
      "descriptionWithPublicTag": "Are you sure you want to delete <strong>{{resource}}</strong>? Deleting this tag will remove all shares associated with it in the Tagged Files Visibility setting.",
      "errorInUse": "Unable to delete tag",
      "errorInUseDescription": "This tag is currently in use in the following areas:",
      "errorInUseAction": "Remove the tag from these locations before deleting it.",
      "usedInSettings": "Settings",
      "usedInClassificationAgent": "Classification Agent"
    },
    "fileTitleForm": {
      "newFolderTitle": "New folder",
      "editFolderTitle": "Rename folder",
      "editFileTitle": "Rename file"
    },
    "fileFromTemplateForm": {
      "newWordDocumentTitle": "New Word Document",
      "newExcelDocumentTitle": "New Excel Document",
      "newPowerpointDocumentTitle": "New PowerPoint Document",
      "newGenericDocumentTitle": "New Document"
    },
    "enterFolderPasswordForm": {
      "passwordPlaceholder": "Password",
      "required": "Password is required",
      "cancel": "Cancel",
      "confirm": "Unlock",
      "error": "Incorrect password",
      "lockout": "Too many failed attempts. Try again in {{minutes}} minutes.",
      "genericError": "An error occurred",
      "resetPassword": "Reset password",
      "forgotPassword": "Forgot password?",
      "title": "Protected Folder",
      "description": "The folder \"{{folderName}}\" requires a password."
    },
    "filePasswordForm": {
      "title": "Folder Password Protection",
      "createTitle": "Set Password Protection",
      "editTitle": "Edit Password Protection",
      "password": "Password",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "newPasswordHelp": "Leave empty to keep current password",
      "ownerBypass": "Owner Bypass",
      "ownerBypassDescription": "Owner can access folder without password",
      "adminBypass": "Admin Bypass",
      "adminBypassDescription": "Admin can access folder without password",
      "maxFailedAttempts": "Max Failed Attempts",
      "lockoutDuration": "Lockout Duration (minutes)",
      "sessionDuration": "Session Duration (minutes)",
      "expirationDate": "Expiration Date",
      "expirationDatePlaceholder": "Select date (optional)",
      "remove": "Remove Password",
      "removeConfirm": "Are you sure you want to remove the password?",
      "validation": {
        "required": "This field is required",
        "minLength": "Must be at least {{min}} characters",
        "expirationDateExpired": "Expiration date cannot be in the past"
      }
    },
    "fileSessionsForm": {
      "title": "Folder Sessions",
      "revokeAllSessionsDescription": "All unlock sessions for \"{{fileName}}\" will be revoked. Users will need to enter the password again to access this folder.",
      "revokeAllFolderSessionsDescription": "All folder unlock sessions will be revoked. Users will need to enter the password again to access any protected folder.",
      "noSessions": "No active sessions",
      "unknownDevice": "Unknown device",
      "createdAt": "Created",
      "expiresAt": "Expires",
      "revokeSession": "Revoke",
      "sessionRevoked": "Session revoked successfully",
      "sessionRevoked_other": "{{count}} sessions revoked successfully",
      "allSessionsRevoked": "All sessions have been revoked",
      "fetchError": "Error fetching sessions",
      "revokeError": "Error revoking session",
      "revokeAllError": "Error revoking all sessions",
      "revokeSessionConfirmTitle": "Revoke this session?",
      "revokeSessionConfirmDescription": "This folder unlock session will be revoked immediately. The user will need to enter the password again to access this folder.",
      "revokeAllConfirmTitle": "Revoke all folder sessions?",
      "revokeAllConfirmDescription": "All folder unlock sessions will be revoked. Users will need to enter the password again to access protected folders.",
      "logoutAll": "Revoke all"
    },
    "userSessionsForm": {
      "activeSessions": "Active Sessions",
      "manageSessions": "Manage sessions",
      "manageUserSessions": "Sessions of {{userName}}",
      "noSessions": "No active sessions",
      "unknownBrowser": "Unknown browser",
      "unknownDevice": "Unknown device",
      "lastActivity": "Last activity",
      "expiresAt": "Expires",
      "currentSession": "Current session",
      "revokeSession": "Revoke",
      "sessionRevoked": "Session revoked successfully",
      "sessionRevoked_other": "{{count}} sessions revoked successfully",
      "otherSessionsRevoked": "{{count}} session revoked successfully",
      "otherSessionsRevoked_other": "{{count}} sessions revoked successfully",
      "allSessionsRevoked": "All sessions have been revoked",
      "revokeSessionConfirmTitle": "Revoke this session?",
      "revokeSessionConfirmDescription": "The device will be logged out immediately.",
      "revokeGroupedSessionConfirmDescription": "This will revoke {{count}} sessions from this device.",
      "revokeOthersConfirmTitle": "Log out all other devices?",
      "revokeOthersConfirmDescription": "All devices except the current one will be logged out.",
      "revokeAllConfirmTitle": "Log out all devices?",
      "revokeAllConfirmDescription": "All devices will be logged out, including the current one. You will need to log in again.",
      "adminRevokeAllConfirmTitle": "Log out all user sessions?",
      "adminRevokeAllConfirmDescription": "All sessions of {{userName}} will be revoked. The user will need to log in again.",
      "logoutOthers": "Log out other devices",
      "logoutAll": "Log out all",
      "revokeAllUserSessions": "Revoke all"
    },
    "resetFilePasswordForm": {
      "forgotPassword": "Forgot password?",
      "otpSentToEmail": "OTP sent to your email address.",
      "resetPassword": "Reset password",
      "otpCodeLabel": "OTP code",
      "newPasswordLabel": "New password",
      "wrongOtpCode": "Wrong OTP code.",
      "tooManyAttemptsRequestNewOtp": "Too many attempts. Request a new OTP.",
      "codeExpiredRequestNewOtp": "Code expired. Request a new OTP.",
      "otpRequired": "OTP is required",
      "otpMustBe6": "OTP must be 6 digits",
      "newPasswordRequired": "New password is required",
      "newPasswordMin": "Password must be at least 4 characters",
      "passwordResetSuccess": "Password has been reset successfully.",
      "tooManyOtpRequests": "Too many OTP requests. Please try again later."
    },
    "fileMoveForm": {
      "title": "Move {{resource}}",
      "title_other": "Move {{count}} files",
      "currentPosition": "Current position",
      "folderIsEmpty": "Folder is empty",
      "selectFolderToMoveInto": "Select a position to show the folder path where you want to move the file"
    },
    "convertToPdf": {
      "title": "Convert to PDF",
      "selectDestination": "Select destination folder"
    },
    "fileShortcutForm": {
      "title": "Create a shortcut for {{resource}}",
      "currentPosition": "Current position",
      "folderIsEmpty": "Folder is empty",
      "selectFolderToCreateShortcutInto": "Select a position to show the folder path where you want to create the shortcut",
      "goBack": "Go back"
    },
    "fileChooseDestinationForm": {
      "currentPosition": "Current position",
      "folderIsEmpty": "Folder is empty",
      "selectFolderHint": "Select the folder where you want to save the file",
      "goBack": "Go back"
    },
    "fileShareForm": {
      "title": "Share {{resource}}",
      "title_other": "Share {{count}} files",
      "message": "Share this file with one or more users or groups.",
      "message_other": "Share {{count}} files with one or more users or groups.",
      "currentPosition": "Current position",
      "folderIsEmpty": "Folder is empty",
      "selectFolderToShareInto": "Select a position to show the folder path where you want to share the file",
      "peopleWithAccess": "People with access",
      "sendMessage": "Notify recipients by email",
      "sendMessagePlaceholder": "Add a custom message (optional)",
      "existingAccessesChanged": "Existing accesses changed",
      "existingAccessesChangedDescription": "Save applies your edits to existing accesses, then adds the new users or groups. Cancel leaves the form as it is and does not add them.",
      "existingAccessesExpirationRequired": "To update these existing accesses you must set an expiration date allowed by company policies.",
      "applyAllExpirationDates": "Apply all"
    },
    "filePublicLinkForm": {
      "title": "Public Link",
      "createTitle": "Create Public Link",
      "expirationLabel": "Expiration (optional)",
      "expirationLabelRequired": "Expiration",
      "expirationPlaceholder": "Never",
      "maxAccessCountLabel": "Max access count (optional)",
      "maxAccessCountLabelRequired": "Max access count",
      "maxAccessCountPlaceholder": "Unlimited",
      "allowDownload": "Allow download",
      "protectWithPassword": "Protect with password",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Enter password",
      "passwordRequired": "Password is required when protection is enabled",
      "createLink": "Create Link",
      "linkCreatedTitle": "Link created!",
      "linkCreatedMessage": "The public link has been created.",
      "copyLink": "Copy link",
      "warning": "Creating a public link bypasses the standard protections on this file. Anyone with the link may access the document content—use with care.",
      "expiresAt": "Expires",
      "remainingAccesses": "Remaining accesses",
      "password": "Password",
      "revoke": "Revoke link",
      "revoked": "Public link revoked successfully.",
      "publicUrl": "Public URL",
      "status": "Status",
      "statusActive": "Active",
      "statusExpired": "Expired",
      "statusExhausted": "Limit reached",
      "accessCount": "Accesses",
      "hasPassword": "Password protected",
      "createdAt": "Created",
      "errors": {
        "linkAlreadyExists": "A public link already exists for this file. Revoke it first to create a new one.",
        "linkNotFound": "No active link found for this file.",
        "featureDisabled": "Public links are disabled for your organization.",
        "notOwner": "You must be the owner to create or revoke public links."
      }
    },
    "filePublicLinksForm": {
      "statusExpired": "Expired",
      "statusExhausted": "Limit reached",
      "statusActive": "Active",
      "expiresAt": "Expires",
      "accessCount": "Accesses",
      "hasPassword": "Password",
      "empty": "No public links yet."
    },
    "userTransferOwnershipForm": {
      "title": "Transfer ownership – {{sourceName}}",
      "destinationLabel": "Destination user",
      "destinationPlaceholder": "Search and select a user",
      "destinationRequired": "Select a destination user.",
      "infoMessage": "Files will be moved into a folder \"Transferred from {{email}}\" at the recipient's root. Files listed for sale on the marketplace will not be transferred.",
      "submit": "Transfer ownership",
      "cancel": "Cancel",
      "close": "Close",
      "successTitle": "Transfer completed",
      "resultFilesTransferred": "Files transferred",
      "resultFoldersTransferred": "Folders transferred",
      "resultSharesUpdated": "Shares updated",
      "resultSelfSharesRemoved": "Self shares removed",
      "resultTagAssignmentsRemoved": "Tag assignments removed",
      "resultTagAssignmentsTransferred": "Tag assignments transferred",
      "resultFilesForSaleExcluded": "Files for sale excluded",
      "resultWrapperFolderName": "Wrapper folder name"
    },
    "userTotpForm": {
      "title": "2FA – {{userName}}",
      "statusTitle": "2FA status",
      "totpEnabled": "TOTP enabled",
      "enabledAt": "Enabled on",
      "backupCodesRemaining": "Backup codes remaining",
      "requiredByPolicy": "Required by policy",
      "lockoutStatus": "Lockout status",
      "failedAttempts": "Failed attempts",
      "exemptionTitle": "TOTP exemption",
      "grantExemption": "Grant exemption",
      "revokeExemption": "Revoke exemption",
      "revoke": "Revoke",
      "exemptionTypeTemporary": "Temporary",
      "exemptionTypePermanent": "Permanent",
      "exemptionTypeLabel": "Type",
      "exemptionExpires": "Expires on",
      "exemptionReason": "Reason",
      "grantedBy": "Granted by",
      "grantedAt": "Granted on",
      "grantDialogTitle": "Grant exemption",
      "grantDialogTemporary": "Temporary",
      "grantDialogPermanent": "Permanent",
      "grantDialogDays": "Days",
      "grantDialogReason": "Reason (min 5 characters)",
      "grantSubmit": "Grant",
      "revokeConfirmTitle": "Revoke exemption",
      "revokeConfirmDescription": "The user will be required to comply with 2FA policy again.",
      "disableConfirmTitle": "Disable 2FA for this user?",
      "disableConfirmDescription": "This will remove two-factor authentication for the user. They will need to set it up again if required by policy.",
      "statusLoading": "Loading…",
      "statusError": "Failed to load 2FA status.",
      "grantSuccess": "Exemption granted.",
      "revokeSuccess": "Exemption revoked.",
      "disableSuccess": "2FA disabled.",
      "cancel": "Cancel",
      "disableTotp": "Disable 2FA",
      "retry": "Retry",
      "errorGeneric": "Something went wrong. Please try again."
    },
    "userPasskeyForm": {
      "cancel": "Cancel",
      "retry": "Retry",
      "errorGeneric": "Something went wrong. Please try again.",
      "passkeyRemove": "Remove",
      "passkeyRemoveAll": "Remove all passkeys",
      "passkeyRemoveAllConfirm": "This will remove all {{count}} passkeys for this user. They will need to register new ones.",
      "passkeyRemoveAllSuccess": "All passkeys removed.",
      "passkeyRemoveAllTitle": "Remove all passkeys?",
      "passkeyRemoveConfirm": "Remove passkey \"{{name}}\"? The user will not be able to use it for sign-in anymore.",
      "passkeyRemoveSuccess": "Passkey removed.",
      "passkeyRemoveTitle": "Remove passkey?",
      "passkeysBlocked": "Passkey lockout",
      "passkeysCount": "Passkeys registered",
      "passkeysEnabled": "Passkeys enabled",
      "passkeysFailedAttempts": "Passkey failed attempts",
      "passkeysLoadError": "Could not load passkey admin status.",
      "passkeysTitle": "Passkeys"
    },
    "loginTokensForm": {
      "title": "Access Tokens – {{userName}}",
      "manageTokens": "Manage access tokens",
      "noTokens": "No access tokens configured for this user.",
      "createToken": "Create new token",
      "label": "Label",
      "labelRequired": "Label is required",
      "labelPlaceholder": "e.g. CRM Integration, CI/CD Pipeline",
      "expirationDays": "Expiration (days)",
      "create": "Create",
      "cancel": "Cancel",
      "close": "Close",
      "delete": "Delete",
      "retry": "Retry",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "expired": "Expired",
      "enable": "Enable",
      "disable": "Disable",
      "createdAt": "Created",
      "expiresAt": "Expires",
      "lastUsed": "Last used",
      "lastUsedIp": "Last IP",
      "neverUsed": "Never used",
      "maxTokensReached": "Maximum number of tokens reached (2). Delete an existing token to create a new one.",
      "tokenCreatedTitle": "Token created successfully",
      "tokenCreatedWarning": "Copy this token now. It will not be shown again.",
      "copyToken": "Copy token",
      "copied": "Copied!",
      "deleteConfirmTitle": "Delete access token?",
      "deleteConfirmDescription": "The token \"{{label}}\" will be permanently deleted and can no longer be used for authentication.",
      "deleteSuccess": "Token deleted successfully.",
      "errorCannotCreateTokenForSuperAdmin": "Access tokens cannot be created for super administrators.",
      "errorGeneric": "Something went wrong. Please try again.",
      "errorLoad": "Failed to load access tokens.",
      "errorMaxReached": "This user already has the maximum number of tokens.",
      "errorTokenAlreadyUsed": "This token has already been used and cannot be re-enabled."
    },
    "alertDismiss": {
      "title": "Dismiss or snooze alert",
      "chooseAction": "How do you want to continue?",
      "permanent": "Don't show again",
      "snooze": "Remind me later",
      "snoozeDuration": "Remind me after",
      "confirm": "Apply",
      "success": "Preference saved."
    },
    "alertsList": {
      "title": "All active alerts",
      "dismiss": "Snooze or dismiss"
    },
    "totpForm": {
      "title": "Two-Factor Authentication",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "activatedOn": "Activated on {{date}}",
      "backupCodesRemaining": "{{count}} / {{total}} backup codes remaining",
      "requiredByPolicy": "Your organization requires two-factor authentication.",
      "gracePeriodEnds": "You have until {{date}} to enable it.",
      "activate": "Enable 2FA",
      "setupTitle": "Set up Two-Factor Authentication",
      "scanQR": "Scan this QR code with your authenticator app (Google Authenticator, Microsoft Authenticator, Authy, etc.).",
      "manualEntry": "Can't scan? Enter manually",
      "hideManual": "Hide manual entry",
      "enterSecretManually": "Enter this code manually in your app:",
      "copySecret": "Copy",
      "copied": "Copied to clipboard",
      "verifyCodeLabel": "Enter the 6-digit code from your app",
      "verifyAndActivate": "Verify and enable",
      "backupCodesTitle": "Two-Factor Authentication enabled!",
      "regenerateSuccess": "Backup codes regenerated",
      "backupCodesWarning": "Save these backup codes in a safe place. They can be used to access your account if you lose access to your authenticator app. Each code can only be used once.",
      "copyAll": "Copy all",
      "download": "Download",
      "print": "Print",
      "savedConfirm": "I have saved these codes in a safe place",
      "continue": "Continue",
      "regenerateBackupCodes": "Regenerate backup codes",
      "disableTotp": "Disable 2FA",
      "disableConfirm": "Disable Two-Factor Authentication?",
      "disableConfirmDescription": "Removing 2FA will make your account less secure. You will need to reconfigure your authenticator app if you want to enable 2FA again.",
      "enterCodeToConfirm": "Enter TOTP code to confirm",
      "cancel": "Cancel",
      "disable": "Disable",
      "disabledSuccess": "Two-Factor Authentication has been disabled.",
      "invalidCode": "Invalid code. Please try again.",
      "errorGeneric": "Something went wrong. Please try again.",
      "retry": "Retry"
    },
    "passkeyCreateForm": {
      "addDescription": "When you continue, your browser will ask you to verify with Touch ID, Face ID, Windows Hello, or your security key.",
      "continueAuthenticator": "Continue",
      "deviceNameInvalid": "Enter a device name between 1 and 100 characters.",
      "deviceNameLabel": "Device name",
      "deviceNamePlaceholder": "e.g. MacBook Touch ID",
      "passkeyCancelled": "Passkey sign-in was cancelled.",
      "registerErrorDeviceAlreadyRegistered": "A passkey for this device is already registered. Use another authenticator or remove the existing passkey first.",
      "registerErrorGeneric": "Passkey registration could not be completed. Please try again.",
      "registerErrorNotSupported": "Your browser or device does not support this type of passkey registration.",
      "registerSuccess": "Passkey saved.",
      "title": "Add a passkey"
    },
    "passkeyEditForm": {
      "deviceNameInvalid": "Enter a device name between 1 and 100 characters.",
      "deviceNameLabel": "Device name",
      "renameError": "Could not rename the passkey.",
      "renameSuccess": "Passkey renamed.",
      "saveLabel": "Save",
      "title": "Rename passkey"
    },
    "passkeysForm": {
      "addPasskey": "Add passkey",
      "browserUnsupported": "Your browser does not support passkeys. Use a current version of Chrome, Safari, Edge, or Firefox.",
      "empty": "No passkeys yet. Add one to sign in faster and use it as a second factor.",
      "lastUsed": "Last used",
      "loadError": "Could not load passkey status.",
      "maxReached": "You can register up to {{max}} passkeys.",
      "never": "Never",
      "passwordless": "Passwordless",
      "passwordlessDisabled": "Passwordless disabled.",
      "passwordlessEnabled": "Passwordless enabled.",
      "passwordlessUnavailable": "Not available for this device",
      "policyDisabled": "Passkeys are disabled by your organization.",
      "registered": "Registered",
      "remove": "Remove",
      "removeConfirm": "Remove passkey \"{{name}}\"? You will not be able to use it for sign-in anymore.",
      "removeError": "Could not remove the passkey.",
      "removeLastWarning": "This is your only passkey. Removing it will disable passkey sign-in until you add a new one.",
      "removeSuccess": "Passkey removed.",
      "removeTitle": "Remove passkey?",
      "rename": "Rename",
      "title": "Passkeys",
      "toggleError": "Could not update passwordless setting.",
      "transport": "Device type",
      "transportBle": "Bluetooth security key",
      "transportHybrid": "Phone",
      "transportHybridInternal": "Synced passkey (phone)",
      "transportInternal": "This device (Touch ID, Face ID, Windows Hello)",
      "transportNfc": "Security key (NFC)",
      "transportUsb": "Security key (USB)",
      "transportUsbNfc": "Security key (USB + NFC)",
      "transportUnknown": "Not reported"
    },
    "filesSelectForm": {
      "confirmDeselectParent": "Deselect parent folder?",
      "confirmDeselectParentDescription": "Selecting this folder will deselect the parent folder and all folders at the same level. Do you want to continue?",
      "ariaLabel": "File sharing form",
      "selectUsersOrGroups": "Select users or groups",
      "userMultiSelectAria": "User and group selection",
      "actions": "Actions"
    },
    "fileTagsForm": {
      "title": "Edit Tags - {{resource}}",
      "availableTags": "Available tags",
      "assignedTags": "Assigned tags",
      "searchAvailableTags": "Search available tags",
      "searchAssignedTags": "Search assigned tags",
      "noAssignedTags": "No tags assigned",
      "clickHintAdd": "Click a tag to add it.",
      "clickHintRemove": "Click a tag to remove it. Drag the handle to reorder.",
      "clickToAdd": "Add tag {{title}}",
      "clickToRemove": "Remove tag {{title}}",
      "dragToReorder": "Drag to reorder {{title}}",
      "aiScrapingOnlyPdfOffice": "AI Scraping is active only on PDF and Office files.",
      "watermarkOnlyPdfOffice": "Watermark protection is active only on PDF and Office files."
    },
    "openFileFromTrash": {
      "title": "This file is in your trash",
      "description": "To view <strong>{{resource}}</strong>, you need to restore it from the trash."
    },
    "fileUploadOptionsForm": {
      "title": "Uploading options",
      "description": "<strong>{{resource}}</strong> already exists in this location. Do you want to replace the existing file with a new version or keep both files? Replacing files will not change the sharing options",
      "description_other": "One or more elements already exists in this location. Do you want to replace the existing files with a new version or keep both files? Replacing files will not change the sharing options",
      "replaceExistingFile": "Replace existing file",
      "replaceExistingFile_other": "Replace existing files",
      "keepBothFiles": "Keep both files",
      "keepBothFiles_other": "Keep both files",
      "newOnly": "New only"
    },
    "filePermanentlyDeleteForm": {
      "title": "Permanently delete {{resource}}",
      "title_other": "Permanently delete {{count}} files",
      "description": "Are you sure you want to permanently delete <strong>{{resource}}</strong>? This action cannot be undone.",
      "description_other": "Are you sure you want to permanently delete <strong>these files</strong>? This action cannot be undone."
    },
    "fileSellForm": {
      "title": "Sell file",
      "message": "Sell the file with FileGrant",
      "uploadPreview": "Click or drag to upload the image preview",
      "uploadPreviewHint": "Square image - Max 5MB",
      "removeImage": "Remove image",
      "pleaseEnterPrice": "Please enter a price",
      "invalidNumber": "Invalid number",
      "priceMin": "Price must be at least €{{amount}}",
      "allowDownload": "Allow file download",
      "removeFromStore": "Remove from store",
      "listedSuccess": "File successfully listed for sale!",
      "purchaseLink": "Purchase link",
      "previewUploadError": "Error during preview upload",
      "imageTooLarge": "Image must be smaller than 5MB",
      "unableToReadImage": "Unable to read the image",
      "previewAlt": "Preview",
      "mustBeImage": "File must be an image",
      "previewImage": "Preview image"
    },
    "emptyFilesTrash": {
      "title": "Empty trash",
      "description": "Are you sure you want to empty the trash? Type <strong>{{keyword}}</strong> to confirm, this action cannot be undone."
    },
    "settingExceptionsForm": {
      "title": "Edit exceptions",
      "description": "Edit the exceptions for the setting.",
      "unsavedExceptions": "Unsaved exceptions",
      "currentExceptions": "Current exceptions"
    },
    "aiSummary": {
      "title": "AI Summary"
    },
    "aiDocumentChat": {
      "title": "Chat With Document"
    },
    "sendInvitationToGroupUsers": {
      "title": "Send invitation",
      "description": "You can send a custom message to the new users of the group or you can close this dialog without any further action.",
      "success": "Invitation sent successfully",
      "error": "Error sending invitation",
      "customMessagePlaceholder": "Optional: Custom message"
    },
    "sendInvitationToUsers": {
      "title": "Send invitation",
      "description": "You can send a custom message to {{resource}} or you can close this dialog without any further action.",
      "description_other": "You can send a custom message to {{count}} users or you can close this dialog without any further action.",
      "success": "Invitation sent successfully",
      "error": "Error sending invitation",
      "customMessagePlaceholder": "Optional: Custom message"
    },
    "restoreFileVersion": {
      "title": "Restore file version",
      "description": "Are you sure you want to restore <strong>{{resource}}</strong> to version <strong>{{version}}</strong>?"
    },
    "fileShareFormUnauthorizedUsers": {
      "title": "Unauthorized users",
      "descriptionForAllUsers": "You cannot share files with these users due to the current settings",
      "descriptionForSomeUsers": "You cannot share files with these users: <strong> {{users}} </strong> due to the current settings, do you want to share with other users that are not blocked by the setting?"
    },
    "sessionExpired": {
      "title": "Session expired",
      "description": "Your session has expired. Please log in again to continue.",
      "redirectMessage": "You’ll be redirected to the login in <strong>{{seconds}}</strong> seconds…",
      "goToLoginNow": "Go to login now"
    },
    "appUpdated": {
      "title": "New version available",
      "description": "A new version of the application is available. Please reload the page to continue.",
      "reloadButton": "Reload"
    },
    "tooManyRequestsOverlay": {
      "title": "Too many requests",
      "description": "You have made too many requests in a short time. Please wait a moment before retrying.",
      "redirectMessage": "You will be able to retry in <strong>{{seconds}}</strong> seconds…"
    },
    "activateTotpOverlay": {
      "badge": "Account protection",
      "title": "Your files deserve an extra layer of defense",
      "description1": "At CyberGrant we know that confidential data is priceless — or rather, it has a price, and it is very high for anyone who wants to take it from you.",
      "description2": "Two-factor authentication (2FA) adds a second verification layer that blocks unauthorized access even if credentials are compromised.",
      "stat1Value": "99.9%",
      "stat1Label": "of automated attacks blocked with 2FA",
      "stat2Value": "< 30s",
      "stat2Label": "to complete the initial setup",
      "featuresTitle": "With 2FA enabled",
      "feature1": "No access without your phone",
      "feature2": "Immediate notification on every suspicious attempt",
      "feature3": "Stronger alignment with NIS2 and GDPR",
      "actionActivate": "Enable 2FA now",
      "actionRemind": "Remind me in {{count}} day",
      "actionRemind_other": "Remind me in {{count}} days",
      "actionSkipForever": "I accept the risk and do not want to enable 2FA",
      "skipForever": "Skip forever",
      "skipForeverConfirmTitle": "Confirm your choice",
      "skipForeverConfirmBody1": "You are choosing not to enable two-factor authentication (2FA). 2FA is the simplest and most effective security measure you can adopt. Not enabling it is an unnecessary and easily avoidable risk.",
      "skipForeverConfirmBody2": "Are you sure you want to continue without enabling two-factor authentication (2FA)?",
      "skipForeverConfirmEnableNow": "Enable it now",
      "skipForeverConfirmDecline": "I don't want to enable it",
      "footer": "You can manage 2FA anytime from Security settings in your account.",
      "badgeMandatory": "Action required",
      "titleMandatory": "Two-factor authentication is now required",
      "description1Mandatory": "Your organization requires two-factor authentication (2FA) for your account, and the grace period to set it up has ended. You must enable it now to continue using Filegrant.",
      "footerMandatory": "This step is required by your organization's security policy and cannot be postponed."
    },
    "openFileLocallyError": {
      "title": "Client not found",
      "description": "To open documents locally, you need to have Remotegrant installed. Contact the administrator to install it."
    },
    "offline": {
      "title": "Offline",
      "description": "You are offline. Please check your internet connection and try again.",
      "message": "Waiting for internet connection..."
    },
    "webAppUpdateAvailable": {
      "title": "Web app update available",
      "description": "A new version of the web app is available. Please refresh the page to update.",
      "okText": "Update",
      "cancelText": "Later"
    },
    "keepFilesOfflineError": {
      "title": "Client not found",
      "description": "To keep files on your PC, you need to have the RemoteGrant agent installed. Contact your administrator to install it."
    },
    "sharingApprovalRequirementReviewTeamForm": {
      "title": "Manage Review Team",
      "description": "Manage the review team for the sharing approval requirement."
    },
    "tagsRequiredForShare": {
      "title": "Tags required for share",
      "description": "The file <strong>{{resource}}</strong> requires tags to be shared. Please add tags to the file and try again.",
      "description_other": "Some of these files requires tags to be shared. Please add tags to the files and try again."
    },
    "tagsRequiredForDownload": {
      "title": "Tags required for download",
      "description": "The file <strong>{{resource}}</strong> requires tags to be downloaded. Please add tags to the file and try again.",
      "description_other": "Some of these files requires tags to be downloaded. Please add tags to the files and try again."
    },
    "filesWithShortcutsDeleteConfirmation": {
      "title": "Delete Files?",
      "description": "Are you sure you want to delete <strong>{{resource}}</strong>? Shortcuts of the selected files were found. If you delete this file, those shortcuts will no longer work <br /><br />Do you want to continue?",
      "description_other": "Are you sure you want to delete <strong>these files</strong>? Shortcuts of the selected files were found. If you delete these files, those shortcuts will no longer work <br /><br />Do you want to continue?"
    },
    "officeTokenExpired": {
      "title": "Session expired",
      "description": "Refresh the page to continue"
    },
    "officeEditorBeta": {
      "title": "Try the new FileGrant Office?",
      "description": "FileGrant Office is available in beta. You can keep using the classic editor, or try the new experience for this session.",
      "tryNew": "Try the new editor",
      "useClassic": "Use classic editor"
    },
    "officeEditorDelete": {
      "title": "Move to trash and close editor?",
      "description": "The file will be moved to the trash and the editor will close. Unsaved changes are handled by autosave."
    },
    "applyIsUsedForFileVisibilityTags": {
      "title": "Apply tags to files",
      "description": "Applying the selected tags will automatically share these files with other users, according to the Tagged Files Visibility settings.<br /><br />Affected tags:<br /><strong>{{resource}}</strong><br /><br />Do you want to continue?",
      "description_other": "Applying some of the selected tags will automatically share these files with other users, according to the Tagged Files Visibility settings.<br /><br />Affected tags:<br /><strong>{{resource}}</strong><br /><br />Do you want to continue?"
    },
    "activeDirectoryUsersImportForm": {
      "importFromActiveDirectory": "Import from Active Directory",
      "title": "Import Users from Active Directory",
      "searchUsers": "Search users...",
      "selectNew": "Select new only",
      "existing": "Existing",
      "new": "New",
      "importSelected": "Import ({{count}})",
      "importSuccess": "Import completed: {{created}} created, {{updated}} updated",
      "importError": "Error during import",
      "errorLoadingUsers": "Error loading users from Active Directory",
      "noUsersFound": "No users found",
      "resultSummary": "Created: {{created}}, Updated: {{updated}}, Skipped: {{skipped}}, Failed: {{failed}}",
      "defaultRole": "Default role",
      "openSettings": "Open LDAP settings"
    },
    "activeDirectoryGroupsImportForm": {
      "importFromActiveDirectory": "Import from Active Directory",
      "title": "Import Groups from Active Directory",
      "searchGroups": "Search groups...",
      "selectNew": "Select new only",
      "existing": "Existing",
      "linked": "Linked",
      "new": "New",
      "importSelected": "Import ({{count}})",
      "importSuccess": "Import completed: {{created}} created, {{updated}} updated",
      "importError": "Error during import",
      "errorLoadingGroups": "Error loading groups from Active Directory",
      "noGroupsFound": "No groups found",
      "resultSummary": "Created: {{created}}, Updated: {{updated}}, Skipped: {{skipped}}, Failed: {{failed}}",
      "defaultRole": "Default role",
      "openSettings": "Open LDAP settings",
      "importMembers": "Import members",
      "usersImported": "{{count}} member(s) also imported"
    },
    "entraIdFullSync": {
      "menuLabel": "Full sync (Entra ID)",
      "title": "Full Entra ID sync",
      "syncUsers": "Sync users",
      "syncGroups": "Sync groups",
      "createMissingUsers": "Create missing users",
      "createMissingGroups": "Create missing groups",
      "updateExisting": "Update existing",
      "disableMissingUsers": "Disable users no longer in the directory",
      "disableMissingUsersTitle": "Disable missing users?",
      "disableMissingUsersConfirm": "Users imported from this directory that are no longer present will be disabled in Filegrant. Users disabled by an administrator will not be re-enabled by the sync. Continue?",
      "confirmSync": "Sync and disable",
      "groupFilter": "Group name filter (optional)",
      "defaultRole": "Default role for new users",
      "runSync": "Run full sync",
      "syncSuccess": "Full sync completed",
      "syncError": "Full sync failed",
      "resultSummary": "Created: {{created}}, Updated: {{updated}}, Skipped: {{skipped}}, Failed: {{failed}}"
    },
    "activeDirectoryFullSync": {
      "menuLabel": "Full sync (Active Directory)",
      "title": "Full Active Directory sync",
      "syncUsers": "Sync users",
      "syncGroups": "Sync groups",
      "createMissingUsers": "Create missing users",
      "createMissingGroups": "Create missing groups",
      "updateExisting": "Update existing",
      "disableMissingUsers": "Disable users no longer in the directory",
      "disableMissingUsersTitle": "Disable missing users?",
      "disableMissingUsersConfirm": "Users imported from this directory that are no longer present will be disabled in Filegrant. Users disabled by an administrator will not be re-enabled by the sync. Continue?",
      "confirmSync": "Sync and disable",
      "groupFilter": "Group name filter (optional)",
      "defaultRole": "Default role for new users",
      "runSync": "Run full sync",
      "syncSuccess": "Full sync completed",
      "syncError": "Full sync failed",
      "resultSummary": "Created: {{created}}, Updated: {{updated}}, Skipped: {{skipped}}, Failed: {{failed}}"
    },
    "directorySync": {
      "usersDisabled": "{{count}} user(s) disabled",
      "disableThemAnyway": "Disable them anyway",
      "suggestFullSync": "Tip: a full sync can re-link a group re-created in the directory.",
      "massDisableConfirmTitle": "Confirm mass disable?",
      "massDisableConfirmFallback": "A large share of users would be disabled. Confirm to proceed."
    }
  },
  "specialFolders": {
    "FTA27E720F2F2BD4718893095FE4354A4F6": "Quick Share"
  },
  "viewer": {
    "eml": {
      "attachments": "Attachments",
      "cc": "Cc",
      "date": "Date",
      "downloadAttachment": "Download {{name}}",
      "emptyBody": "This message has no body content.",
      "from": "From",
      "parseError": "This email file could not be parsed.",
      "showRawSource": "Show raw source",
      "subject": "Subject",
      "to": "To"
    },
    "ics": {
      "description": "Description",
      "empty": "No calendar events found in this file.",
      "end": "End",
      "location": "Location",
      "organizer": "Organizer",
      "parseError": "This calendar file could not be parsed.",
      "showRaw": "Show raw source",
      "start": "Start",
      "untitled": "Untitled event"
    },
    "msg": {
      "attachments": "Attachments",
      "cc": "Cc",
      "date": "Date",
      "downloadAttachment": "Download {{name}}",
      "emptyBody": "This message has no body content.",
      "from": "From",
      "parseError": "This Outlook message could not be parsed.",
      "showRawSource": "Show raw source",
      "subject": "Subject",
      "to": "To"
    },
    "vcf": {
      "email": "Email",
      "empty": "No contacts found in this file.",
      "note": "Note",
      "organization": "Organization",
      "parseError": "This contact file could not be parsed.",
      "phone": "Phone",
      "showRaw": "Show raw source",
      "title": "Title",
      "unnamed": "Unnamed contact"
    },
    "htmlPreview": {
      "title": "Open HTML Preview",
      "description": "This HTML file may contain JavaScript code that could be potentially dangerous. The preview will be displayed in a sandboxed environment for security. Do you want to proceed?",
      "button": "Preview HTML",
      "hideButton": "Hide Preview"
    },
    "error": {
      "decryptFailed": {
        "title": "Decrypt failed",
        "description": "The file cannot be decrypted. Please try again."
      },
      "officeNoPreview": {
        "title": "No preview available",
        "description": "Heads-up: Double-check the source's trustworthiness before downloading this original file."
      },
      "blobFetchFailed": {
        "title": "File not found",
        "description": "The file was not found. Please try again."
      },
      "videoPlayback": {
        "title": "Video playback error",
        "description": "The video could not be played. Try reloading the page."
      },
      "videoUnsupported": {
        "title": "Video format not supported",
        "description": "Your browser cannot decode this video (for example HEVC/H.265 or 10-bit video). Ask for a version encoded in H.264 (MP4) to play it here."
      },
      "fetchFilePermissionsFailed": {
        "title": "File permissions fetch failed",
        "description": "The file permissions could not be fetched. Please try again."
      },
      "isFolder": {
        "title": "File is a folder",
        "description": "The file is a folder. Cannot be opened in the viewer."
      },
      "fetchFileFailed": {
        "title": "File fetch failed",
        "description": "The file could not be fetched. Please try again."
      },
      "noPreviewAvailable": {
        "title": "No preview available",
        "description": "Heads-up: Double-check the source's trustworthiness before downloading this original file."
      },
      "noPermissions": {
        "title": "No permissions",
        "description": "You do not have permission to open this file."
      }
    },
    "sign": {
      "title": "Add signature",
      "add": "Add signature",
      "delete": "Remove signature",
      "pickFolder": "Choose destination folder",
      "saveSignature": "Also save this signature to Files",
      "selectFolderHint": "Select a position to show the folder path where you want to save the signature",
      "unavailable": "PDF signing is not available with the current viewer license.",
      "success": "Signed PDF saved",
      "error": "Could not save signed PDF",
      "flattenWarning": "The signature cannot be removed after saving. Make sure before you save.",
      "modeEnabled": "Sign mode enabled",
      "modeDisabled": "Sign mode disabled",
      "tab": {
        "draw": "Draw",
        "upload": "Upload",
        "drive": "From Files"
      },
      "draw": {
        "hint": "Draw your signature in the box",
        "clear": "Clear"
      },
      "upload": {
        "dropHint": "Drop an image here or click to browse"
      },
      "replaceOrCopy": {
        "title": "Save signed PDF",
        "replace": "Replace original",
        "replaceHint": "Overwrite the current PDF with the signed version",
        "copy": "Save as copy",
        "copyHint": "Keep the original and save the signed PDF in a folder you choose"
      }
    }
  },
  "store": {
    "fileSalesOverview": "File Sales Overview",
    "totalSales": "Units Sold",
    "fileRevenue": "File Revenue",
    "unitRevenue": "Unit Price",
    "stock": "Stock",
    "openStoreLink": "Open store link",
    "salesDashboard": "Sales dashboard",
    "confirmEmail": "Confirm email",
    "confirmEmailPlaceholder": "Confirm your email",
    "emailPlaceholder": "you@example.com",
    "pleaseEnterEmail": "Please enter your email",
    "pleaseConfirmEmail": "Please confirm your email",
    "emailsDoNotMatch": "The two emails do not match!",
    "invalidEmail": "The input is not a valid E-mail!",
    "payNow": "Pay now",
    "paymentSuccessful": "Payment successful!",
    "fileAlreadySold": "File already sold to this email",
    "emailsMismatch": "Email and confirmation email do not match.",
    "invalidEmailFormat": "Invalid email format",
    "fileNotFound": "File not found",
    "filePreview": "File Preview",
    "filePreviewAlt": "File preview",
    "fileFullPreviewAlt": "File full preview",
    "byOwner": "By {{name}}",
    "purchase": "Purchase"
  },
  "dashboard": {
    "title": "Executive report",
    "tabs": {
      "overview": "Overview"
    },
    "riskIndicators": {
      "title": "Risk Indicators",
      "untaggedFiles": {
        "label": "Untagged Files",
        "description": "Percentage of files not classified with tags. A high value indicates risk of non-compliance with data classification policies."
      },
      "sharingWithoutExpiration": {
        "label": "Sharing Without Expiration",
        "description": "Percentage of shares without expiration date. Perpetual shares increase the risk of unauthorized access over time."
      },
      "editorSharing": {
        "label": "Editor Permission Sharing",
        "description": "Percentage of shares with edit permissions. High values increase the risk of unauthorized data alteration."
      },
      "externalSharing": {
        "label": "External Sharing",
        "description": "Percentage of shares to external domains. High values may indicate risk of sensitive data leakage."
      },
      "excessiveExpiration": {
        "label": "Excessive Expiration",
        "description": "Percentage of active shares with expiration exceeding 90 days. Prolonged access increases the risk of compromise."
      },
      "userConcentration": {
        "label": "User Concentration",
        "description": "Maximum percentage of shares made by a single user. High concentration indicates risk of insider threat or compromised account."
      },
      "thresholds": "Thresholds"
    },
    "ssoCoverage": {
      "label": "Internal users without SSO",
      "asOfNow": "As of now",
      "excluded": "Excluded from SSO",
      "outsideDomains": "E-mail domain not covered by SSO",
      "description": "Current snapshot of enabled internal users (every role except External, not expired) who log in by e-mail OTP instead of SSO. Excluded from SSO takes precedence over domain not covered. Does not follow the report date range."
    },
    "riskDetail": {
      "viewDetails": "Details",
      "user": "User",
      "domain": "Domain",
      "domains": "Domains",
      "shares": "Shares",
      "noData": "No data available for this indicator",
      "totalUsers": "{{count}} users affected",
      "countLabel": {
        "editorSharing": "Editor Shares",
        "untaggedFiles": "Untagged Files",
        "sharingWithoutExpiration": "Without Expiration",
        "externalSharing": "External Shares",
        "excessiveExpiration": "Excessive Shares",
        "userConcentration": "Total Shares"
      }
    },
    "volumeData": {
      "volume": "Volume",
      "files": "Files",
      "folders": "Folders",
      "total": "Total Items"
    },
    "classification": {
      "title": "TAG Classification",
      "withTag": "With TAG",
      "withoutTag": "Without TAG"
    },
    "sharing": {
      "internal": "Sharing with Internals",
      "external": "Sharing with Externals",
      "readOnly": "Sharing with Read Only",
      "editor": "Sharing with Editor"
    },
    "expiration": {
      "title": "Sharing Expiration",
      "withExpiration": "with expiration",
      "withoutExpiration": "without expiration"
    },
    "expirationAnalysis": {
      "title": "Detailed Expiration Analysis",
      "count": "Count",
      "average": "Average Duration",
      "active": "Active",
      "expired": "Expired",
      "min": "Min Duration",
      "max": "Max Duration",
      "days": "days",
      "distribution": {
        "expired": "Expired",
        "expiringSoon": "0-7 days",
        "shortTerm": "7-30 days",
        "mediumTerm": "30-90 days",
        "longTerm": "90-365 days",
        "excessive": ">365 days"
      }
    },
    "domains": {
      "title": "Recipient Domains",
      "domain": "Domain",
      "type": "Type",
      "count": "Count",
      "distribution": "Distribution",
      "internal": "Internal",
      "external": "External",
      "openRecipients": "Open share recipients for {{domain}}"
    },
    "users": {
      "title": "User Statistics",
      "user": "User",
      "files": "Files",
      "folders": "Folders",
      "total": "Total",
      "sharing": "Sharing",
      "withSharing": "With Sharing",
      "withoutSharing": "Without Sharing"
    },
    "refresh": "Refresh Report",
    "retry": "Retry",
    "period": "Period",
    "apply": "Apply",
    "lastMonth": "Last Month",
    "last3Months": "Last 3 Months",
    "year": "Year",
    "all": "All",
    "cachedData": "Data updated at: {{date}}",
    "internalDomains": "Internal Domains",
    "critical": "critical",
    "warnings": "warnings",
    "criticalAlert": "Critical risk indicators detected. Immediate action required.",
    "warningAlert": "Warning risk indicators detected. Review recommended.",
    "securityIncidents": {
      "title": "Security incidents and alerts",
      "noData": "No security incidents or alerts in this period",
      "dateTime": "Date and time",
      "severityColumn": "Severity",
      "category": "Type",
      "description": "Description",
      "user": "User",
      "ipAddress": "IP address",
      "country": "Country",
      "viewInActivityLog": "View in Activity Log",
      "severityLevels": {
        "critical": "Critical",
        "error": "Error",
        "warning": "Warning",
        "info": "Info"
      },
      "categories": {
        "loginFailed": "Failed login",
        "suspiciousAccess": "Suspicious access",
        "policyViolation": "Policy violation",
        "permissionDenied": "Permission denied",
        "rateLimitExceeded": "Rate limit exceeded",
        "configurationAlert": "Configuration change",
        "sharingViolation": "Sharing violation",
        "dataExportAlert": "Data export"
      }
    },
    "securityAnomalies": {
      "title": "Security Anomalies",
      "noData": "No open security anomalies in this period",
      "criticalAlert": "{{count}} critical security anomaly requires attention",
      "criticalAlert_other": "{{count}} critical security anomalies require attention",
      "byDetectorTitle": "Anomalies by type",
      "summary": {
        "totalOpen": "Open anomalies",
        "critical": "Critical",
        "warning": "Warning",
        "info": "Info"
      },
      "severityColumn": "Severity",
      "type": "Type",
      "anomaly": "Anomaly",
      "events": "Events",
      "lastSeen": "Last seen",
      "actionsColumn": "Actions",
      "handledAt": "Handled on",
      "tabs": {
        "open": "Open",
        "managed": "Managed"
      },
      "actions": {
        "hide": "Mark as handled",
        "restore": "Restore"
      },
      "hideConfirmTitle": "Mark this anomaly as handled?",
      "hideNotePlaceholder": "Optional note (reason)…",
      "restoreConfirmTitle": "Restore this anomaly?",
      "hideSuccess": "Anomaly marked as handled",
      "hideError": "Could not mark the anomaly as handled",
      "restoreSuccess": "Anomaly restored",
      "restoreError": "Could not restore the anomaly",
      "managedLoadError": "Could not load managed anomalies",
      "managedNoData": "No managed anomalies",
      "severityLevels": {
        "critical": "Critical",
        "warning": "Warning",
        "info": "Info"
      },
      "detectors": {
        "admin_ip_blocked": "Admin access from blocked IP",
        "unauthorized_country": "Access from unauthorized country",
        "brute_force_login": "Login brute-force",
        "password_spray": "Password spray",
        "folder_password_brute_force": "Folder password brute-force",
        "public_link_brute_force": "Public link brute-force",
        "security_signal": "Security signal"
      }
    },
    "activityMap": {
      "title": "Activity by country",
      "noData": "No activity location data in this period",
      "activities": "{{count}} activities",
      "failedLogins": "{{count}} failed logins",
      "legendLow": "Low",
      "legendHigh": "High",
      "selectedCountry": "{{country}}",
      "hint": "Click a country on the map to see details.",
      "viewDetails": "View access details",
      "periodNote": "Map data covers the last 90 days.",
      "periodRange": "Map data from {{from}} to {{to}}."
    },
    "geoDetail": {
      "title": "Access details — {{country}}",
      "totalUsers": "{{count}} users",
      "user": "User",
      "activities": "Activities",
      "failedLogins": "Failed logins",
      "distinctIps": "IPs",
      "lastAccess": "Last access",
      "anonymous": "Anonymous",
      "noData": "No access data for this country in the selected period",
      "geoUnavailable": "Geolocation unavailable"
    },
    "recipients": {
      "title": "Share recipients",
      "domainSubtitle": "Domain: {{domain}}",
      "refreshHint": "Recompute the data (at most once every 30 seconds)",
      "topTitle": "Top 10 recipients by shared items",
      "noData": "No recipients in the selected period",
      "countingRulesTitle": "How recipients are counted",
      "countingRules": {
        "active": "Only active shares count: expired, pending, refused, revoked or exhausted shares and files in the recycle bin are excluded.",
        "direct": "Only direct shares count: a shared folder is one item, its content is not expanded.",
        "group": "A group is one recipient (members are shown for information); all public links are one row.",
        "domainCount": "These totals can be lower than the Recipient Domains counts, which include every share of the period."
      },
      "summary": {
        "internalUsers": "Internal users",
        "externalUsers": "External users",
        "groups": "Groups",
        "publicLinks": "Public links",
        "totalShares": "Total shares"
      },
      "types": {
        "all": "All types",
        "internal": "Internal",
        "external": "External",
        "group": "Group",
        "public": "Public"
      },
      "type": "Type",
      "domain": "Domain",
      "domainPlaceholder": "Filter by domain",
      "searchPlaceholder": "Search name or email",
      "editorOnly": "Editor shares only",
      "withoutExpirationOnly": "Without expiration only",
      "sortBy": "Sort by",
      "sortByValue": "Sort by: {{field}}",
      "sort": {
        "items": "Items",
        "editor": "Editor shares",
        "withoutExpiration": "Without expiration",
        "lastShared": "Last shared",
        "owners": "Owners",
        "name": "Name"
      },
      "totalRecipients": "{{count}} recipients",
      "name": "Name",
      "email": "Email",
      "members": "Members",
      "items": "Items",
      "filesFolders": "{{files}} files / {{folders}} folders",
      "editorShares": "Editor",
      "withoutExpiration": "No expiration",
      "withoutPassword": "No password",
      "owners": "Owners",
      "lastShared": "Last shared",
      "highestRisk": "Highest risk",
      "publicLinks": "Public links",
      "unknown": "Unknown",
      "itemsTitle": "Shared with {{name}}",
      "totalItems": "{{count}} shared items",
      "noItems": "No active shares in the selected period",
      "itemName": "Name",
      "file": "File",
      "folder": "Folder",
      "size": "Size",
      "owner": "Owner",
      "permission": "Permission",
      "editor": "Editor",
      "viewer": "Viewer",
      "expiration": "Expiration",
      "never": "Never",
      "createdAt": "Shared on",
      "canDownload": "Download",
      "passwordProtected": "Password",
      "accesses": "Accesses",
      "accessCountValue": "{{count}} / {{max}}",
      "unlimited": "Unlimited",
      "yes": "Yes",
      "no": "No"
    },
    "errors": {
      "accessDenied": "Access Denied",
      "accessDeniedDescription": "You do not have permission to view the Executive Report. Only Administrators can access this section.",
      "serverError": "System Error",
      "serverErrorDescription": "Unable to generate the report. Please try again later.",
      "noData": "No Data Available",
      "pdfExportFailed": "Failed to export the dashboard as PDF. Please try again or contact support.",
      "folderPasswordForm": {
        "title": "Folder Password Protection"
      },
      "invalidFilter": "Invalid filter: it has been reset.",
      "recipientNotFound": "Recipient not found. The list has been refreshed."
    }
  },
  "aiClassificationStatus": {
    "none": "None",
    "queued": "Queued...",
    "classifying": "Classifying...",
    "done": "Completed",
    "error": "Error",
    "unknown": "Unknown"
  },
  "webSocketStatus": {
    "idle": "Idle",
    "connecting": "Connecting",
    "open": "Open",
    "closing": "Closing",
    "closed": "Closed",
    "error": "Error"
  },
  "fileOfflineStatus": {
    "Pending": "Queued for device syncing",
    "Downloading": "Downloading to device",
    "Downloaded": "Synced on Device"
  },
  "file": {
    "antivirus": {
      "pending": "Antivirus scan in progress",
      "rescanPending": "Rescan queued — file remains blocked ({{threatName}})",
      "infected": "Threat detected: {{threatName}}",
      "error": "Antivirus could not verify this file",
      "errors": {
        "STREAM_TOO_LARGE": "Not verified by antivirus — file is too large to scan",
        "ENGINE_UNREACHABLE": "Antivirus engine unreachable",
        "SCAN_TIMEOUT": "Antivirus scan timed out",
        "MAX_RETRIES": "Antivirus scan failed after multiple attempts"
      },
      "rescanFailed": "Rescan failed — file remains blocked ({{threatName}})",
      "retry": "Retry scan",
      "contactAdmin": "Contact your administrator if you believe this is a false positive.",
      "stickyNote": "Re-uploading, restoring a version, or editing in Office will not clear this threat.",
      "tooLarge": "Not verified by antivirus — file is too large to scan"
    }
  },
  "batch": {
    "status": {
      "all": "All",
      "queued": "Queued",
      "processing": "Processing",
      "completed": "Completed",
      "failed": "Failed",
      "partiallycompleted": "Partially Completed",
      "cancelled": "Cancelled"
    },
    "operation": {
      "all": "All Operations",
      "classification": "AI Classification",
      "folderexpansion": "Folder Expansion",
      "delete": "Delete"
    },
    "failedFiles": "{{count}} file failed",
    "failedFiles_other": "{{count}} files failed",
    "eta": "ETA",
    "failedFilesDetail": "Failed Files Detail",
    "noFailedFiles": "No failed files",
    "fileCancelled": "Cancellation requested for this file.",
    "fileCancelError": "Error requesting file cancellation.",
    "fileRetried": "File queued for retry",
    "fileRetryError": "Error retrying file",
    "cancelAllFailed": "Cancel all Failed batches (not Processing)",
    "cancelAllFailedConfirmTitle": "Cancel all Failed batches?",
    "cancelAllFailedConfirmContent": "This clears every batch with status Failed. Processing and Queued batches keep running and are not affected. This cannot be undone."
  },
  "entraId": {
    "importFromEntraId": "Import from Entra ID",
    "importGroupsTitle": "Import Groups from Microsoft Entra ID",
    "importUsersTitle": "Import Users from Microsoft Entra ID",
    "searchGroups": "Search groups...",
    "selectNew": "Select new only",
    "existing": "Existing",
    "new": "New",
    "importMembers": "Also import group members",
    "importSelected": "Import ({{count}})",
    "importSuccess": "Import completed: {{created}} created, {{updated}} updated",
    "importError": "Error during import",
    "errorLoadingGroups": "Error loading groups from Entra ID",
    "errorLoadingUsers": "Error loading users from Entra ID",
    "noGroupsFound": "No groups found",
    "noUsersFound": "No users found",
    "resultSummary": "Created: {{created}}, Updated: {{updated}}, Skipped: {{skipped}}, Failed: {{failed}}",
    "usersImported": "{{count}} member(s) also imported",
    "permissionErrorTitle": "Insufficient Azure AD Permissions",
    "permissionErrorDescription": "The Azure AD application does not have sufficient permissions to access Microsoft Graph API.",
    "permissionErrorSteps": "To resolve this issue:",
    "permissionErrorStep1": "Go to Azure Portal > App registrations > Your app",
    "permissionErrorStep2": "Navigate to API permissions",
    "permissionErrorStep3": "Add the required Application permissions (not Delegated)",
    "permissionErrorStep4": "Click \"Grant admin consent\" to authorize the permissions",
    "requiredPermissions": "Required permissions",
    "filterBySync": "Filter by sync",
    "syncedWithEntraId": "Synced with Entra ID",
    "syncedTooltip": "Synced with Microsoft Entra ID",
    "searchUsers": "Search users...",
    "importUsersSuccess": "Import completed: {{created}} created, {{updated}} updated",
    "usersResultSummary": "Created: {{created}}, Updated: {{updated}}, Skipped: {{skipped}}, Failed: {{failed}}",
    "defaultRole": "Default role"
  },
  "continents": {
    "europe": "Europe",
    "asia": "Asia",
    "africa": "Africa",
    "northAmerica": "North America",
    "southAmerica": "South America",
    "oceania": "Oceania",
    "antarctica": "Antarctica"
  },
  "components": {
    "countrySelect": {
      "placeholder": "Select countries...",
      "euOption": "European Union (All 27 countries)",
      "searchPlaceholder": "Search countries..."
    },
    "regionSelect": {
      "placeholder": "Select regions or enter ISO codes...",
      "euOption": "European Union",
      "searchPlaceholder": "Search regions..."
    },
    "ipCidrInput": {
      "placeholder": "Enter IP addresses or CIDR ranges, separated by commas",
      "helperText": "Examples: 192.168.1.100, 10.0.0.0/8, 2001:db8::/32",
      "invalidEntry": "Enter a valid IP address or CIDR range",
      "invalidEntries": "Invalid entries: {{entries}}"
    },
    "ipRegionExceptionForm": {
      "title": "Manage IP/Region Exceptions",
      "description": "Grant additional access criteria to specific users or groups",
      "typeLabel": "Exception Type",
      "additionalIpsTitle": "Additional Allowed IPs",
      "addAllowedIp": "Add IP or CIDR",
      "additionalCountriesTitle": "Additional Allowed Countries",
      "additionalRegionsTitle": "Additional Allowed Regions",
      "expirationTitle": "Expiration Date",
      "expirationNone": "No Expiration",
      "expirationCustom": "Expires on:",
      "reasonTitle": "Reason (for audit)",
      "reasonPlaceholder": "e.g., Business trip to London - Feb 2026",
      "addException": "Add Exception",
      "existingExceptions": "Existing Exceptions",
      "fetchError": "An error occurred while fetching the exceptions. Please try again.",
      "selectAtLeastOne": "Select at least one user or group",
      "atLeastOneCriterion": "Add at least one IP address, country or region: an exception without criteria grants nothing",
      "alreadyPresent": "The selected users or groups already have an exception on this restriction"
    }
  },
  "email": {
    "inbox": "Inbox",
    "sent": "Sent",
    "favorites": "Favorites",
    "trash": "Trash",
    "drafts": "Drafts",
    "noEmails": "No emails in this folder",
    "noEmailsFound": "No emails found",
    "noSubject": "(No subject)",
    "searchPlaceholder": "Search emails",
    "newMessage": "New Message",
    "newEmail": "Email",
    "folders": "Folders",
    "to": "To",
    "from": "From",
    "cc": "Cc",
    "bcc": "Bcc",
    "subject": "Subject",
    "date": "Date",
    "body": "Body",
    "send": "Send",
    "sending": "Sending...",
    "cancel": "Cancel",
    "draftIdle": "Waiting for changes",
    "draftSaveError": "Save failed",
    "draftSaved": "Draft saved",
    "draftSaving": "Saving...",
    "editDraft": "Edit draft",
    "saveDraft": "Save draft",
    "sendError": "Failed to send email",
    "errorExternalSharingNotAllowed": "The following recipients are not authorized",
    "errorSharingDenied": "You do not have permission to share these files",
    "errorPartialSharingDenied": "Some attachments cannot be shared with the selected recipients",
    "errorCannotAccessFiles": "You do not have access to the attached files",
    "attachmentReadOnly": "View only",
    "attachmentEditor": "Can edit",
    "attachmentExpirationWarning": "Sharing will expire in {{days}} days",
    "attachmentPermission": "Permission",
    "writeMessage": "Write your message...",
    "attachFiles": "Attach files",
    "attachments": "Attachments",
    "hasAttachments": "Has attachments",
    "addFavorite": "Add to favorites",
    "removeFavorite": "Remove from favorites",
    "moveToTrash": "Move to trash",
    "archive": "Archive",
    "archiveAction": "Archive",
    "unarchiveAction": "Move to Inbox",
    "restore": "Restore",
    "deleteDraft": "Delete draft",
    "deleteDraftConfirm": "Move this draft to trash? You can restore it from Trash later.",
    "deletePermanently": "Delete permanently",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "bulletList": "Bullet list",
    "fontSmall": "Small",
    "fontNormal": "Normal",
    "fontLarge": "Large",
    "fontHuge": "Huge",
    "sendingInProgress": "Sending in Progress",
    "stepPreparing": "Preparing message for delivery",
    "stepValidating": "Validating recipients",
    "stepArchiving": "Archiving to secure storage",
    "stepDelivering": "Delivering to recipients...",
    "secureDelivery": "Secure Delivery - Enterprise Protected",
    "protect": "Protect with password",
    "protectionTitle": "Password Protection",
    "protectionPassword": "Password",
    "protectionConfirm": "Confirm password",
    "protectionHint": "Hint (optional)",
    "protectionMismatch": "Passwords do not match",
    "protectionWarning": "The email content will be encrypted locally. If you lose this password, the message cannot be recovered.",
    "protectedMessage": "This message is protected by a password.",
    "protectedSnippet": "Protected message",
    "protectedHintLabel": "Hint",
    "enterPassword": "Enter password to read the message",
    "unlock": "Unlock",
    "wrongPassword": "Incorrect password. Please try again.",
    "reply": "Reply",
    "forward": "Forward",
    "forwardedMessage": "Forwarded message",
    "forwardExpired": "The original message has expired, the forward has been cancelled.",
    "forwardAttachmentsTitle": "Forward attachments",
    "forwardAttachmentsMessage": "This message contains attachments. Do you want to include them in the forwarded message?",
    "forwardWithAttachments": "With attachments",
    "forwardWithoutAttachments": "Without attachments",
    "selectFromFileGrant": "Select from FileGrant",
    "uploadFromDevice": "Upload from device",
    "selectFiles": "Select files",
    "selectFolderForUpload": "Select upload folder",
    "filesSelected": "{{count}} file(s) selected",
    "confirm": "Confirm",
    "expiration": "Expiration",
    "expirationTitle": "Expiration Date",
    "expirationDescription": "The email will no longer be accessible after the selected date.",
    "expirationPlaceholder": "Select expiration date and time",
    "expiresOn": "Expires on {{date}}",
    "expired": "Expired on {{date}}",
    "selected": "{{count}} selected",
    "markAsRead": "Mark as read",
    "markAsUnread": "Mark as unread",
    "deletePermanentlyConfirm": "Are you sure you want to permanently delete {{count}} emails? This action cannot be undone.",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "removeAttachment": "Remove attachment",
    "removeAttachmentConfirm": "Do you want to remove this attachment? Access will be revoked for all recipients.",
    "attachmentNotFound": "Attachment not found",
    "featureNotAvailable": "Feature not available",
    "removeRecipient": "Remove recipient",
    "removeRecipientsConfirm": "Do you want to remove {{count}} recipient(s)? They will no longer be able to see this email and access to attachments will be revoked.",
    "emailNotFound": "Email not found",
    "recipientNotFound": "Recipient not found",
    "mustKeepOneRecipient": "At least one recipient must remain",
    "replyAll": "Reply All",
    "activity": "Activity",
    "cannotCreateEmail": "You do not have permission to create new emails",
    "blockForward": "Block forward",
    "blockForwardDescription": "Recipients will not be able to forward this email",
    "advancedProtection": "Advanced protection",
    "protectDescription": "Recipients will need a password to read this email"
  },
  "note": {
    "createNote": "Note",
    "createTitle": "Create note",
    "newNote": "New note",
    "fileName": "File name",
    "fileNameRequired": "File name is required",
    "placeholder": "Write your note...",
    "loadError": "Unable to load the note",
    "sidebarTitle": "Notes",
    "editing": "Editing",
    "reading": "Reading",
    "codeBlock": "Code block",
    "rename": "Rename",
    "renamed": "File renamed",
    "renameError": "Unable to rename the file",
    "saved": "Note saved",
    "saveError": "Unable to save the note",
    "checklist": "Checklist",
    "linkUrl": "Link URL",
    "linkText": "Link text",
    "insertLink": "Insert link",
    "saving": "Saving…",
    "savedShort": "Saved",
    "delete": "Delete note",
    "deleteTitle": "Delete note",
    "deleteConfirm": "Delete the note \"{{name}}\"? It will be moved to the trash.",
    "deleted": "Note deleted",
    "deleteError": "Unable to delete the note",
    "expandSidebar": "Expand sidebar",
    "collapseSidebar": "Collapse sidebar"
  },
  "aiSummary": {
    "generationInProgress": "Generating the summary may take a while: you can close this window, we'll notify you when it's ready.",
    "closeAndNotify": "Close, we'll notify you"
  },
  "imagePreview": {
    "loadFullQuality": "Load full quality",
    "loadFullQualityTooltip": "Load the original full-resolution image (large file)",
    "loadingFullQuality": "Loading full quality…",
    "openInViewer": "Open in viewer"
  },
  "shortcuts": {
    "title": "Keyboard shortcuts",
    "then": "then",
    "searchLabel": "Search keyboard shortcuts",
    "searchPlaceholder": "Search shortcuts…",
    "listLabel": "Keyboard shortcuts list",
    "noResults": "No shortcuts match your search.",
    "categories": {
      "app": "Application",
      "create": "Create",
      "file": "Files",
      "navigation": "Navigation",
      "selection": "Selection",
      "view": "View"
    },
    "app": {
      "focusSearch": "Focus search",
      "openShortcutsHelp": "Open keyboard shortcuts"
    },
    "create": {
      "openMenu": "Open create menu",
      "folder": "New folder",
      "uploadFile": "Upload file",
      "uploadFolder": "Upload folder",
      "word": "New Word document",
      "excel": "New Excel spreadsheet",
      "powerpoint": "New PowerPoint presentation",
      "note": "New note",
      "secret": "New login credentials",
      "secretCard": "New payment card",
      "secretIdentity": "New identity",
      "secretSshKey": "New SSH key",
      "secretCustom": "New custom secret"
    },
    "file": {
      "open": "Open",
      "openNewTab": "Open in new tab",
      "rename": "Rename",
      "share": "Share",
      "move": "Move",
      "favorite": "Add to favorites",
      "delete": "Remove",
      "copyLink": "Copy link",
      "createShortcut": "Create shortcut",
      "details": "Details",
      "download": "Download",
      "publicLink": "Public link",
      "setPassword": "Set password",
      "aiSummary": "AI summary",
      "tags": "Edit tags"
    },
    "view": {
      "toggleGridList": "Toggle grid or list view"
    },
    "nav": {
      "focusSidebar": "Focus navigation",
      "focusMain": "Focus file list",
      "focusDetails": "Focus details panel",
      "focusUploadDrawer": "Focus upload progress"
    },
    "selection": {
      "selectAll": "Select all",
      "clear": "Clear selection",
      "toggle": "Toggle selection",
      "moveFocusUp": "Move focus up",
      "moveFocusDown": "Move focus down",
      "moveFocusLeft": "Move focus left",
      "moveFocusRight": "Move focus right",
      "extendUp": "Extend selection up",
      "extendDown": "Extend selection down",
      "extendLeft": "Extend selection left",
      "extendRight": "Extend selection right"
    }
  },
  "chat": {
    "thinking": {
      "working": "Working on your request. This can take a few seconds."
    },
    "stream": {
      "tools": {
        "routing": "Classifying request",
        "rag_search": "Searching documents",
        "filename_search": "Searching by filename",
        "metadata_search": "Searching metadata",
        "open_file": "Opening file",
        "relevance_assessment": "Assessing relevance",
        "search_refinement": "Refining search",
        "activity_log_search": "Searching activity log",
        "calculator": "Calculating",
        "chart_generation": "Generating chart",
        "aggregation": "Aggregating results",
        "answer_generation": "Writing answer",
        "paused": "Waiting in queue",
        "unknown": "Working"
      },
      "descriptions": {
        "routing": {
          "start": "Figuring out what you need…",
          "done": "Request classified{{intentDetail}}."
        },
        "rag_search": {
          "start": "Looking through your documents{{queryDetail}}…",
          "done": "Found matching passages in your library{{countDetail}}."
        },
        "filename_search": {
          "start": "Looking through your files by name{{patternDetail}}…",
          "done": "Matched files by their names{{countDetail}}."
        },
        "metadata_search": {
          "start": "Scanning tags, dates, and other properties…",
          "done": "Finished checking document properties{{countDetail}}."
        },
        "open_file": {
          "start": "Reading the chosen document{{filenameDetail}}…",
          "done": "Document content is ready to use{{filenameDetail}}."
        },
        "relevance_assessment": {
          "start": "Weighing which results best match your question{{candidateCountDetail}}…",
          "done": "Kept the strongest matches{{countDetail}}."
        },
        "search_refinement": {
          "start": "Tightening the query for better hits{{queryDetail}}…",
          "done": "Updated the search criteria."
        },
        "activity_log_search": {
          "start": "Checking who did what, and when{{queryDetail}}…",
          "done": "Pulled the matching activity entries{{countDetail}}."
        },
        "calculator": {
          "start": "Crunching the numbers{{expressionDetail}}…",
          "done": "Numbers are ready{{expressionDetail}}."
        },
        "chart_generation": {
          "start": "Turning data into a visual…",
          "done": "Chart is ready to show."
        },
        "aggregation": {
          "start": "Combining matches into one set…",
          "done": "Combined results are ready{{countDetail}}."
        },
        "answer_generation": {
          "start": "Putting your reply together…",
          "done": "Reply is ready."
        },
        "paused": {
          "start": "GPU busy — your turn is queued{{reasonDetail}}…",
          "done": "Resumed — continuing your request."
        },
        "unknown": {
          "start": "Working on this step…",
          "done": "This step is complete."
        }
      },
      "param": {
        "query": " for «{{query}}»",
        "pattern": " for «{{pattern}}»",
        "filename": " «{{filename}}»",
        "expression": " ({{expression}})",
        "count": " ({{count}})",
        "candidateCount": " ({{count}} candidates)",
        "reason": " — {{reason}}",
        "intent": " as «{{intent}}»"
      },
      "reasons": {
        "gpu_overload": "GPU overload"
      },
      "toolsUsed": "Tools used ({{count}})"
    },
    "disclaimer": "AIGrant can make mistakes. Check important information.",
    "offlineHint": "Realtime disconnected. Browse chats anytime; send when back online.",
    "offlineDisclaimer": "Offline: you can send messages once the connection is restored.",
    "connectingHint": "Establishing realtime connection. You can send once ready.",
    "connectingDisclaimer": "Connecting: you can send messages once the connection is ready.",
    "placeholder": "Type your message... (Enter to send, Shift+Enter for new line)",
    "dictate": "Dictate",
    "stopDictation": "Stop dictation",
    "speechUnsupported": "Speech recognition is not supported in this browser",
    "dictationFailed": "Could not start dictation",
    "regenerate": "Regenerate",
    "readAloud": "Read aloud",
    "stopReading": "Stop reading",
    "speechUnavailable": "Speech synthesis unavailable",
    "requestCancelled": "Request cancelled",
    "genericError": "An error occurred while processing your request.",
    "gpuBusyBody": "The system is temporarily overloaded. Please try again in a few moments.",
    "gpuBusyRetrying": "System busy — retrying once…",
    "responseTimeout": "The request could not be completed within the maximum time (10 minutes). Please try again later or contact support if this persists.",
    "jumpToLatest": "Jump to latest"
  },
  "sharePointStatus": {
    "menuLabel": "SharePoint",
    "title": "SharePoint status",
    "openConfiguration": "Configure",
    "refreshHint": "Reads the state live from your tenant. Use it sparingly.",
    "never": "Never",
    "notAvailableTitle": "Not included in your licence",
    "notAvailable": "The SharePoint integration is not included in your licence. Contact support to enable it.",
    "loadFailedTitle": "The status could not be loaded",
    "loadFailed": "Something went wrong while reading the state of the integration.",
    "verdict": {
      "encrypting": "Files in the perimeter are being encrypted",
      "notEncrypting": "Nothing is being encrypted"
    },
    "unmatched": {
      "title": "Some perimeter sites do not exist in your tenant",
      "body": "Matching is exact, so a renamed or deleted site stops matching. The files of these sites are not being inspected or encrypted:",
      "allMissingTitle": "No site of the perimeter exists in your tenant",
      "allMissingBody": "Nothing is being watched at all. None of these sites could be found:",
      "repickAction": "Pick these sites again"
    },
    "blocking": {
      "notConfiguredTitle": "The integration is not configured",
      "notConfigured": "No credentials are stored, so nothing is happening at all.",
      "configInvalid": "The stored configuration was refused by the same validation the scan runs, so nothing is happening at all.",
      "workerDisabledTitle": "The scan is not active on this installation",
      "workerDisabled": "The scan worker is not registered on this deployment, so nothing will be inspected. This is not something you can change: contact support.",
      "noCertificateTitle": "No encryption certificate is selected",
      "noCertificate": "No RemoteGrant certificate is selected, so there is no key and nothing will be encrypted.",
      "certificateUnusableTitle": "The encryption certificate can no longer be used",
      "certificateUnusable": "Re-select the certificate and save to resume encryption. It may have been deleted in RemoteGrant, its key may have been replaced, or RemoteGrant may be unreachable.",
      "noKeyWhileArmed": "Discovery mode is off, so this configuration looks active while nothing is being encrypted.",
      "emptyPerimeterTitle": "The perimeter is empty",
      "emptyPerimeter": "No site of the perimeter resolves against your tenant, so nothing is being watched."
    },
    "certificate": {
      "label": "Encryption certificate",
      "none": "None selected",
      "unnamed": "Certificate #{{id}}",
      "repickAction": "Re-select the certificate"
    },
    "perimeterUnresolvedTitle": "The perimeter could not be checked against your tenant",
    "perimeterUnresolvedBody": "The counters below are still accurate, but the watched sites and folders could not be read right now. This does not mean the perimeter is empty.",
    "perimeterError": {
      "unauthorized": "Microsoft Graph refused the credentials: the client secret may have expired, or the application permissions may be missing admin consent.",
      "unavailable": "Microsoft Graph is temporarily unreachable.",
      "siteNotFound": "A site of the perimeter is no longer visible with these credentials.",
      "generic": "The tenant could not be reached."
    },
    "countersTitle": "Scan activity",
    "pendingInQueue": "Files waiting to be processed",
    "totalFilesEncrypted": "Files encrypted so far",
    "scanInterval": "Perimeter checked",
    "everyNMinutes": "Every {{minutes}} minutes",
    "lastEncryptedAt": "Last file encrypted",
    "lastDeltaAdvancedAt": "Last scan cycle",
    "lastVerifiedAt": "Credentials last verified",
    "verifyOk": "Passed",
    "verifyKo": "Refused",
    "perimeterTitle": "Watched perimeter",
    "perimeterUnknown": "The perimeter could not be read from your tenant right now.",
    "perimeterEmpty": "No site is being watched.",
    "crossLibraryCaveat": "Each folder below is matched against the root of every document library of its site, not only the library it was picked from.",
    "wholeSiteTag": "Whole site",
    "wholeSiteBody": "No folder filter: every file of this site is in scope.",
    "allFileTypes": "All file types",
    "filteredFileTypes": "Only: {{extensions}}",
    "notAllowedTitle": "You are not allowed to see this",
    "notAllowed": "You are not allowed to manage the SharePoint integration. Ask a SuperAdmin to grant you access to this setting.",
    "box": {
      "active": "Active",
      "dryRunDiscovery": "Discovery",
      "dryRunEncryption": "Encryption",
      "dryRunLabel": "Mode",
      "dryRunOffCaption": "Matching files are encrypted in place, with no way back.",
      "dryRunOnCaption": "The perimeter is only inspected: nothing is written back.",
      "inactive": "Inactive",
      "off": "Off",
      "on": "On",
      "scanLabel": "Scan"
    },
    "issuesTitle": "Conditions that need your attention"
  },
  "sharePoint": {
    "editor": {
      "error": {
        "disabled": {
          "description": "The SharePoint integration is not enabled on this installation.",
          "title": "Integration not available"
        },
        "forbidden": {
          "description": "You do not have permission to open this file on SharePoint.",
          "title": "Access denied"
        },
        "generic": {
          "description": "Could not open the file in the editor. Try again, or open it in the viewer.",
          "title": "Cannot open the editor"
        },
        "notProtected": {
          "description": "This file is not encrypted by FileGrant, so it opens directly in SharePoint with Office.",
          "title": "Nothing to open here"
        },
        "tooLarge": {
          "description": "This file exceeds the size limit for editing. You can still open it in the viewer.",
          "title": "File too large to edit"
        },
        "unsupported": {
          "description": "This format cannot be edited online. You can still open it in the viewer.",
          "title": "Format not editable"
        }
      },
      "loading": "Opening the file in the editor…",
      "readOnly": {
        "description": "SharePoint did not grant you permission to change this file, or no certificate is available to encrypt a save with. You can read it, but not save it.",
        "title": "Read-only document"
      },
      "signIn": {
        "button": "Sign in to edit the file",
        "description": "Sign in with your Microsoft account to edit this file. Editing needs permission to change files on SharePoint, which an administrator may have to approve.",
        "failed": "Sign-in did not complete. Check that the browser is not blocking pop-ups, then try again.",
        "title": "Sign-in required"
      }
    },
    "signIn": {
      "failed": {
        "description": "Could not load the Microsoft sign-in configuration. Reload the page, or try again in a few moments.",
        "title": "Sign-in unavailable"
      },
      "loading": "Preparing the Microsoft sign-in…",
      "notConfigured": {
        "description": "This file cannot be opened: an administrator has not configured the Microsoft app registration the browser signs into. Ask them to complete the SharePoint integration setting.",
        "title": "Sign-in not configured"
      }
    },
    "viewer": {
      "edit": "Edit",
      "error": {
        "authFailed": {
          "description": "Could not get permission to read your SharePoint files. Sign in again, or ask an administrator to approve FileGrant access.",
          "title": "Sign-in required"
        },
        "disabled": {
          "description": "The SharePoint integration is not enabled on this installation.",
          "title": "Integration not available"
        },
        "forbidden": {
          "description": "You do not have permission to open this file on SharePoint.",
          "title": "Access denied"
        },
        "generic": {
          "description": "Could not open the file from SharePoint. Try again.",
          "title": "Cannot open the file"
        },
        "invalidLink": {
          "description": "This SharePoint link is not valid. Open the file again from SharePoint.",
          "title": "Invalid link"
        },
        "notFound": {
          "description": "The file was not found: it may have been moved or deleted.",
          "title": "File not found"
        },
        "reopen": {
          "description": "The permission to open this file has expired, or the file changed in the meantime. Open it again from SharePoint.",
          "title": "Open the file again"
        },
        "tooLarge": {
          "description": "This file exceeds the size limit of the SharePoint viewer.",
          "title": "File too large"
        }
      },
      "loading": "Reading the file from SharePoint…",
      "signIn": {
        "button": "Sign in to open the file",
        "description": "Sign in with your Microsoft account to open this file. It is decrypted only if you are allowed to read it.",
        "failed": "Sign-in did not complete. Check that the browser is not blocking pop-ups, then try again.",
        "title": "Sign-in required"
      },
      "source": "From SharePoint"
    }
  },
  "activeDirectory": {
    "syncedWithActiveDirectory": "Synced with Active Directory"
  }
}
